import { AfterViewInit, Component, OnInit, ElementRef, HostListener } from '@angular/core';
import { CrudService } from '../../services/crud.service';
import { Router, ActivatedRoute} from '@angular/router';
import { SchedaCorso } from '../../interface/scheda-corso';
import { environment } from 'src/environments/environment';
import Swal from 'sweetalert2';

import { ViewChild } from '@angular/core';
import { TabComponent, TabsetComponent } from 'ngx-tabset';
import { ReturnStatement } from '@angular/compiler';

import { JitsiComponent } from 'src/app/jitsi/jitsi.component';
import { Meta, MetaDefinition } from '@angular/platform-browser';
import { Accordion } from 'ngx-accordion';
import { element } from 'protractor';
import { timeInterval } from 'rxjs/operators';
import { settings } from 'cluster';
import { report } from 'process';

@Component({
  selector: 'app-detail',
  templateUrl: './detail.component.html',
  styleUrls: ['./detail.component.scss'],
})
export class DetailComponent implements OnInit, AfterViewInit {
    @ViewChild(JitsiComponent) JitsiChild!: JitsiComponent;
    @ViewChild('staticTabs') staticTabs: TabsetComponent;
    @ViewChild('tabs1') tabs1: TabComponent;
    @ViewChild('tabs2') tabs2: TabComponent;
    @ViewChild('tabs3') tabs3: TabComponent;
    @ViewChild('tabs4') tabs4: TabComponent;
    @ViewChild('tabs5') tabs5: TabComponent;
    @ViewChild('tabs6') tabs6: TabComponent;
    @ViewChild("myVideo", { static: false }) myVideo: ElementRef;
    @ViewChild('pageAccordion') pageAccordion: Accordion;

    //PAYPAL
    cartTotalPrice: number = 1;
    showPaypal: boolean = false;
    isTransactionComplete: boolean = false;

    public value_tempoUpdateReportEsame: number=30  ;
    public tempoUpdateReportEsame: number=this.value_tempoUpdateReportEsame;

    public logoPartner: string="assets/img/logo_new1.png";
    public logoFondo: string="";

    public onFocusVideo: boolean=false;
    public isPresentazioneAI: boolean=false;
    private presMessageHandler: any=null;
    private presTempoCompletato: number=0;
    private presLastSlide: number=-1;
    private presTempoRestanteSec: number=0;
    // "Exact resume" cache: ultima slide+seek noti per ciascun id_modulo_body_paragrafo,
    // ricevuti dal viewer via postMessage `presTempoCompletato`. Riusati nell'URL del
    // viewer alla prossima apertura per saltare il probe stimato (che cumula drift
    // sub-secondo per slide e fa "ripartire qualche secondo indietro").
    private presResumeByParagrafo: { [idParagrafo: string]: { slide: number; seek: number } } = {};

    public isPauseVideo: number=0;

    public idCorsoGlobal: string;
    public schedaCorsistaGlobal: any=[];
    public isMiur: boolean=false;
    public isMim: boolean=false;
    public courseViewer: string='standard';

    public costoCorso: string;
    public linkEsterno: string="";
    public costoCorsoScontato: string="";
    public productID: any;
    public detailAcquisto: any;
    public detailUser: any=[];

    //espresso in secondi (300 = 5 minuti) | TEST: 60s = 1 minuto
    public tempoAutoSaveVideo: number=1800;
    public tempoAutoSaveVideoCnt: number=0;
    public tempoTrascorsoAutoSaveVideo: number=0;
    public canSave: boolean=true;
    public pdfDurataSec: number=0;
    public sentinellaOutFinestra: boolean=false;
    // Il browser rallenta i timer delle schede in background (anche a 1 scatto al minuto):
    // il tempo si misura dall'orologio reale e, per il video, da quanto avanza il video.
    public orologioVideo: any={ct: null, ora: 0, resto: 0};
    public orologi: any={};

    public detailEsameCorsoSetting: any=[];
    public sponsorCorso: any=[];

    public liveVideoRegistrazione: any=[];
    public canShowProgressPlayer: boolean=false;

    public sessioneEsame: any=[];
    public sessioneEsameCorsista: any=[];
    public sessioneEsamePin: string="";
    public showEsameDiretto: boolean=false;

    public schedaCorsista: any;
    public moduliUC: string[];
    public moduloUC_TestValutazione: string[];
    // Subset filtrato: SOLO i test di valutazione (isTestValutazione=1). Serve al
    // template per non mostrare gli esami finali come "TEST DI VALUTAZIONE" nel
    // tab "Moduli UC". Il payload backend include entrambi (test + esami) per
    // calcolare isSuperato/nTentativi di tutti — v2 discrimina in card, v1 no.
    public moduloUC_TestValutazioneOnly: any[] = [];

    public moduloUC_TestValutazioneSelected: any;
    public showTestValutazione: boolean=false;

    public isInEsame: boolean=false;

    public materialeDidattico: string[];
    // Materiale caricato dai docenti per l'aula del corsista (tbl_materiale_extra_docente).
    // Il backend lo restituisce gia' in product['materiale_docente'] (approvato+attivo, scoped aula);
    // in v1 il tab non lo leggeva -> materiale docente mai mostrato al corsista.
    public materialeDocente: any[] = [];
    public nModuliUC: number;
    public ModuloUC_frequenza: number;
    // Display reale di fruizione: percentuale vera (floor) e flag "completata" basato
    // su isComplete di ogni modulo. Mantenuto separato da `ModuloUC_frequenza` perche'
    // quest'ultima viene `ceil`-ata e forzata-100 dal backend (api/corso.php:652-655)
    // ed e' usata da altre logiche (gating esame finale, accesso attestato).
    public fruizioneDisplayPercent: number = 0;
    public fruizioneCompletata: boolean = false;
    // Stato "tutto bloccato in attesa esame finale": il corsista ha completato i
    // contenuti (tutti i moduli isComplete=1) MA c'e' un esame finale ancora da
    // superare. In questa fase moduli + SP devono essere bloccati per forzare
    // il corsista a sostenere l'esame anziche' rivedere contenuti.
    public bloccaTuttoPerEsameFinale: boolean = false;

    public timeCheck: number;
    public timeCheckBackup: number;

    public tempoTrascorso: number = 0;
    public tempoRestanteLimite: number = 0;
    public tempoRestanteSessione: number = 0;
    public labelTempoRestanteLimite: string;
    public labelTempoRestanteSessione: string;

    public isPlayVideo: boolean=false;

    public tempoRestanteLimiteTEST: number = 0;
    public labelTempoRestanteLimiteTEST: string;

    public arraySaveDatiUC_Tempo: Array<any>=[];
    public timerHandle: any;
    public timerHandleCheck: any;
    public timerHandleEsaminatore: any;
    public timeStartVideo: any;

    public nPropostaCorsi: any=[];
    public nParagrafi: number = 0;
    public elencoDataCorso: any=[];
    public detailQuiz: any=[];
    public detailQuizOnlyTEST: any=[];
    //true quando il corso NON ha esame finale e il corsista ha completato la fruizione:
    //in quel caso l'attestato spetta per completamento (flag calcolato dal backend).
    public attestatoPerCompletamento: boolean=false;
    public showEsameFattiDay: boolean=false;
    public durataEsameTotale: string;

    public isEnabledUser: boolean=false;
    public isInLive: number=0;
    public idCorsoSvolgimentoDefaultCorso: number=0;
    public protocollo: any;
    public mansione: any;
    public reportForData: number=0;
    public limita_moduloUC: number=0;
    public limiteGiorno: number=0;
    public limiteGiornoAula: number=0;
    public lockModuliUC: number=0;
    public bloccoVisualizzazioneRipetuta: number=0;
    public isInLiveLinkAula: string="";
    public arrayLive: any=[];

    public detallCorso: SchedaCorso = {} as SchedaCorso;
    public urlImage = environment.urlImageCorso;
    public urlImageHD = environment.urlImageCorsoHD;
    public urlVideoCorso = environment.urlImageVideoCorso;
    public videoPreview = environment.urlImageVideoCorso;
    public materialeDidatticoPath = environment.urlMaterialeDidattico;
    // Base piattaforma per prefissare path_file del materiale docente (relativo: assets/media/materiale_docente/...)
    public urlPiattaformaBase = environment.urlWeb;
    public urlStampa = environment.urlStampa;

    public canShowElencoDate = environment.canShowElencoDate;

    public numeroTelefono = environment.numero_telefono;
    public canShowPagamentoRate = environment.canShowPagamentoRate;
    public textShowPagamentoRate = environment.textShowPagamentoRate;

    public isLimiteRaggiunto: boolean=false;

    public briciolaTag: string;
    public cntClick: number = 1;

    public showMeet: boolean=false;
    public showMeetPreload: boolean=false;
    // Codice cliente, server e nome aula passati a <app-jitsi>, fotografati
    // dalla live al momento dell'ingresso (vedi datiAulaDallaLive).
    public meetDati: any=null;
    // «Entra in aula» cliccato prima che quei dati ci siano: si aspetta.
    public preparandoAula: boolean=false;
    public showControlloPresenza: boolean=false;
    public timeControlloPresenza: number=60;
    public timerHandleControlloPresenza: any;

    public arrayConnessioniVideo: any=[];

    public isFAD_Always: boolean=false;

    public resetTimeFadEveryDays: boolean=false;

    // Consultazione: corso completato, materiale accessibile ma senza tracciamento DB
    public isConsultazione: boolean=false;

    // Always-FAD: aula configurata FAD-sempre. Sotto-caso di isConsultazione=true
    // (anche always-FAD non traccia il tempo video) MA con semantica diversa per i
    // test/esami: il corsista PUO' eseguirli (controllo di autovalutazione) ma
    // l'esito non viene salvato sul DB. UI: banner diverso, bottone con label
    // "Verifica (esito non registrato)".
    public isAlwaysFadMode: boolean=false;

    // ECM
    public isECM: boolean=false;
    public ecmConfig: any=null;
    public ecmAntifrodeTimer: any=null;
    public ecmAntifrodeMinutiTrascorsi: number=0;
    public videoEndedNaturally: boolean=false;
    public ecmTimerSincronaScadenza: any=null;
    public ecmRevisionePlayVideoResumePoint: number=0;
    public ecmRevisioneMap: any={}; // mappa id_modulo_body_paragrafo → {tempoRevisionato, durataSec, rivisto}

    public worker: Worker;

    constructor(
        private crudService: CrudService,
        private router: Router,
        private actRoute: ActivatedRoute,
        private metaService:Meta) { }

        @HostListener('window:focus', [])
        onFocus(): void {
            console.log('Finestra attiva');
            if(this.arrayLive.isLive==1)
                this.sessioneIsTerminata();
            this.sentinellaOutFinestra=false;
            /*
            if(this.arrayLive.isLive==1) {
                let idCorsoSvolgimento=this.arrayLive['id_corso_svolgimento'];
                this.crudService.checkIfSessioneIsTerminata(idCorsoSvolgimento).subscribe(timeRestante => {
                    console.log("Time Restante:"+timeRestante);
                });
            }
            */
        }

        @HostListener('window:blur', [])
        onBlur(): void {
            console.log('Finestra non attiva');
        }

        // Chiusura automatica solo quando la scheda e' davvero nascosta (ridotta a icona,
        // cambio scheda, coperta da un'altra finestra). La sola perdita di focus (popup di
        // Teams/Outlook, clic sull'altro monitor) lascia il video visibile: non si chiude.
        @HostListener('document:visibilitychange', [])
        onVisibilityChange(): void {
            if(document.visibilityState==='hidden' && this.onFocusVideo==true && this.isPlayVideo==true && !this.isPresentazioneAI) {
                this.sentinellaOutFinestra=true;
                this.chiudiVideo();
            }
        }

    ngAfterViewInit(): void {
        setTimeout(() => {
            this.showEsame();
        }, 2000);
    }

    ngOnDestroy(): void {
        clearInterval(this.timerHandle);
        clearInterval(this.timerHandleCheck);
        clearInterval(this.timerHandleEsaminatore);
        clearInterval(this.timerHandleControlloPresenza);
    }


ngOnInit() {
    this.worker = new Worker(new URL('./worker.ts', import.meta.url), { type: 'module' });

    this.detallCorso['image']="";

    //mi recupero il dettaglio dell'user dopo il LOGIN
    this.detailUser=JSON.parse(localStorage.getItem('user_id'));

    if(JSON.parse(localStorage.getItem('user_id'))==null) {
        //console.log("jooo");
        this.detailUser={'id_corsista': 0};
    }
    else {
        //mi recupero il dettaglio dell'user dopo il LOGIN
        this.detailUser=JSON.parse(localStorage.getItem('user_id'));
    }

    if(!(this.detailUser)) {
        this.detailUser={'canDownloadAttestato': '0'};
    }

    //mi recupero l'ID del CORSO per ricavare la scheda
    this.productID = this.actRoute.snapshot.params['id'];

    if(this.detailUser) {
        this.crudService.api_getDetailCorsista(this.detailUser['id_corsista']).subscribe(productData => {
            //console.log(productData);
            this.schedaCorsistaGlobal=productData;

            this.detailUser['assistenza']=productData['assistenza'];
            this.detailUser['canDownloadAttestato']=productData['canDownloadAttestato'];
            this.schedaCorsista=productData;
            let idPartner=productData['id_partner'];

            this.crudService.api_get_DetailPartner(idPartner).subscribe(productData => {
                if(idPartner!=1) {
                    if(productData['image_logo'])
                        this.logoPartner=environment.urlImagePartners+productData['image_logo'];
                }

                this.urlVideoCorso+=this.detailUser['id_partner']+"/";
                this.videoPreview+=this.detailUser['id_partner']+"/";
                let idUser=this.detailUser['id_user'];
                this.mansione=this.detailUser['mansione'];
                let idCorsista=this.detailUser['id_corsista'];
                this.checkUserIsEnabled(this.productID, idCorsista);
            },(err)=>{
                //console.log(err);
                }, ()=>{
            }
            );

        },(err)=>{
            //console.log(err);
            }, ()=>{
        });
    }
    else {
        this.urlVideoCorso+="1/";
        this.videoPreview+="1/";
        this.loadDetailsCorso(this.productID, '1');
    }

    //this.loadDetailsCorso(this.productID);

     //visualizzo i dettaglio del CORSO. ritardo di 250 perchè prima mi serve capire se il corsista è abilitato
     /*
     setTimeout(() => {
     }, 500);
     */
  }

  sessioneIsTerminata() {
    if(this.arrayLive['id_corso_svolgimento']>0) {
        this.crudService.checkIfSessioneIsTerminata(this.arrayLive['id_corso_svolgimento']).subscribe(timeRestante => {
        if(this.arrayLive.isLive==1) {
            this.tempoRestanteSessione=parseInt(timeRestante.toString());

            if(parseInt(timeRestante.toString())<=0) {
                this.limiteRaggiunto(1);
                return;
            }
        }
    });
    }
  }

  showEsame() {
    /*
    if(this.tempoRestanteLimiteTEST>0 && this.detailQuiz['isSuperatoQuiz']==0) {
        this.staticTabs.tabs.first.active=false;
        //this.tabs3.active=false;
        if(this.tabs2.active) this.tabs2.active=false;
        if(this.tabs3.active) this.tabs3.active=false;
        this.tabs5.active=true;
    }
    */
  }

  playPause() {
    var myVideo: any = document.getElementById("myVideo");
    if (myVideo.paused) myVideo.play();
    else myVideo.pause();
  }

  initiSocialMeta() {
    this.metaService.addTag( { name:'title',content:this.detallCorso.titolo});
    this.metaService.addTag( { name:'description',content:this.detallCorso.descrizione});
    this.metaService.addTag( { name:'image',content:this.urlImageHD+this.detallCorso['image']});
  }

  checkout(){
    if(this.detailUser) {
        this.showPaypal = true;
    }
    else {
        this.confermaNewAccount();
    }
  }

  confermaNewAccount() {
    Swal.fire({
        icon: 'info',
        title: 'Non sei registrato',
        text: 'prima di procedere bisogna registrare i propri dati, vuoi procedere con la registrazione?',
        showCancelButton: true,
        confirmButtonColor: '#6993FF',
        cancelButtonColor: '#dadada',
        confirmButtonText: 'Si, procedo!',
        cancelButtonText: 'Annulla',
        width: '400px',
        allowOutsideClick: false,
      }).then((result) => {
        if (result.isConfirmed) {
            location.href="/corsisti/nuovo-account";
        }
      })
  }

  annullaAcquisto() {
    this.showPaypal = false;
  }

  paymentApprove(event){
    //console.log(event);
    if(event.status == 'COMPLETED'){
        let idTransiction=event.id;
        let metodo="paypal";
        let status=event.status;
        let payer_id = event.payer.payer_id;
        let payer_nome=event.payer.name.given_name;
        let payer_cognome=event.payer.name.surname;
        let payer_email=event.payer.email_address;
        let purchase_id=event.purchase_units[0].payee.merchant_id;
        let purchase_importo_valuta=event.purchase_units[0].amount.currency_code;
        let purchase_importo=event.purchase_units[0].amount.value;
        let payment_id=event.purchase_units[0].payments.captures[0].id;

        var arrayDetail={'idCorso': this.idCorsoGlobal,
                         'idCorsista': this.detailUser['id_corsista'],
                         'idPartner': this.detailUser['id_partner'],
                         'metodo': metodo,
                         'idTransiction': idTransiction,
                         'status': status,
                         'payer_id': payer_id,
                         'payer_nome': payer_nome,
                         'payer_cognome': payer_cognome,
                         'payer_email': payer_email,
                         'purchase_id': purchase_id,
                         'purchase_importo_valuta': purchase_importo_valuta,
                         'purchase_importo': purchase_importo,
                         'payment_id': payment_id};

                         //console.log(arrayDetail);
      this.isTransactionComplete = true;
      this.registraPagamento(arrayDetail);
    }
    else {
        this.acquistoError();
    }
  }

  registraPagamento(arrayDetail) {
    this.crudService.api_registraPagamento(arrayDetail).subscribe(productData => {
        //console.log(productData);
        if(productData==1) {
            this.addCorsistaInAula();
        }
    },(err)=>{
        //console.log(err);
        }, ()=>{
    }
    );
  }

  addCorsistaInAula() {
    this.crudService.api_addCorsistaInAula(this.detailUser['id_corsista'], this.detailUser['id_partner'], this.idCorsoGlobal).subscribe(productData => {
        if(productData==1) {
            this.getDetailCorsista();
            this.acquistoSuccess();
        }
    },(err)=>{
        //console.log(err);
        }, ()=>{
    }
    );
  }

  getDetailCorsista() {
    this.crudService.api_getDetailCorsista(this.detailUser['id_corsista']).subscribe(productData => {

        //invio l'email di conferma attivare al corsista
        var arrayDetail={'nome': productData['nome'],
                        'cognome': productData['cognome'],
                        'nomeCorso': this.detallCorso.titolo,
                        'cf': productData['cf'],
                        'email': productData['email'],
                        'idPartner':this.detailUser['id_partner']};

        //invio l'email al corsista
        //this.sentEmailConfermaAttivazioneToCorsista(arrayDetail);
    },(err)=>{
        //console.log(err);
        }, ()=>{
    });
}

updateTimeReportEsame(saveFast) {
    this.tempoUpdateReportEsame-=1;
    if((this.tempoUpdateReportEsame<=0) || (saveFast==1)) {
        //se devo salvare in modo rapido, senza azzerare il contatore ma
        //salvando i secondi trascorsi
        if(saveFast==0)
            this.tempoUpdateReportEsame=this.value_tempoUpdateReportEsame;

        if((((this.sessioneEsameCorsista.isDayEsame==1 &&
            this.sessioneEsameCorsista.isInLiveEsameCorsista==1 &&
            this.sessioneEsameCorsista.id_esame_type_documento &&
            this.sessioneEsameCorsista.n_documento &&
            (this.sessioneEsamePin!=this.sessioneEsameCorsista.pin_esame) &&
            this.showEsameDiretto==true) &&
            this.detailQuiz['isSuperatoQuiz']==0)) || this.isInEsame==true) {
                var arrayDetail={'idCorso': this.idCorsoGlobal,
                                'idCorsista': this.detailUser['id_corsista'],
                                'idQuizHeader':this.detailQuiz['id_quiz_header'],
                                'time': this.tempoUpdateReportEsame}
                this.crudService.api_updateTimeReportEsame(arrayDetail).subscribe(response => {
                    //console.log(response);
                });
        }
    }
}

aggiornaTempoLimiteTEST() {
    if(this.isConsultazione) return;
    console.log(this.tempoRestanteLimiteTEST);

    this.updateTimeReportEsame(0);

    if(this.tempoRestanteLimiteTEST<=0) {
        clearInterval(this.timerHandle);

        this.updateTimeReportEsame(1);

        //this.tabs5.active=true;
        if(this.sessioneEsameCorsista.isDayEsame==1 && this.sessioneEsameCorsista.isInLiveEsameCorsista==1 && this.showEsameDiretto==true) {
            this.controllaQuizTEST(1);
        }
        else if(this.detailQuiz['terminaTEST']) {
            this.controllaQuizTEST(0);
        }
        else {
            if(this.timerHandle)
                location.reload();
        }

        //location.reload();
        return;
    }

    this.tempoRestanteLimiteTEST-=1;
    this.labelTempoRestanteLimiteTEST=this.secondsToHms(this.tempoRestanteLimiteTEST);
 }

  aggiornaTempoLimite(secondi = 1) {
    if(this.isConsultazione) return;
    if(this.tempoRestanteLimite<=0) {
        return;
    }

    this.tempoRestanteLimite-=secondi;
    this.labelTempoRestanteLimite=this.secondsToHms(this.tempoRestanteLimite);

    /*
    this.tempoAutoSaveVideoCnt++;
    if(this.tempoAutoSaveVideoCnt>=this.tempoAutoSaveVideo) {
        this.tempoAutoSaveVideoCnt=0;
        this.salvaTempoVideoAutomatico();
    }
    */

    if(this.tempoRestanteLimite<=0) {
        if(this.tempoTrascorso<=0)
            location.reload();

        clearInterval(this.timerHandle);
        this.chiudiVideoLimiteRaggiunto();
    }
  }

  aggiornaTempoSessione() {
    if(this.isConsultazione) return;
    if(this.tempoRestanteSessione<=0) {
        return;
    }

    this.tempoRestanteSessione-=this.secondiOrologio('sessione');
    this.labelTempoRestanteSessione=this.secondsToHms(this.tempoRestanteSessione);

    if(this.tempoRestanteSessione<=0) {
        if(this.tempoTrascorso<=0)
            location.reload();

        clearInterval(this.timerHandle);
        this.chiudiVideoLimiteRaggiunto();
    }
  }

  aggiornaTempoLimiteAula() {
    if(this.isConsultazione) return;
    //console.log(this.tempoRestanteLimite);

    //this.tempoRestanteLimite-=1;
    this.labelTempoRestanteLimite=this.secondsToHms(this.tempoRestanteLimite);

    if(this.tempoRestanteLimite<=0) {
        this.limiteGiornoAula=0;
        this.isInLive=2;
        this.setTimeOutAulaForCorsisti();
        clearInterval(this.timerHandle);
    }
  }

  setTimeOutAulaForCorsisti() {
    let idCorsoSvolgimento=this.arrayLive['id_corso_svolgimento'];
    let idCorsista=this.detailUser['id_corsista'];

    this.crudService.api_setTImeoutCorsista(idCorsista, idCorsoSvolgimento, 0).subscribe(productData => {
        this.showMeet=false;
    },(err)=>{
        //console.log(err);
        }, ()=>{
    });

    // Butta fuori tutti gli altri corsisti in aula: quando il MIO timer scade,
    // se il mio browser non e' throttled sono io a segnalare la fine lezione
    // agli altri via close-room. Copre il caso "docente ha chiuso ma alcuni
    // corsisti hanno tab in background e non lo sanno". La chiamata era
    // COMMENTATA nel sorgente storico -> il close-room broadcast NON partiva
    // mai (dead code confermato in audit).
    // buttaTuttiFuori ora usa jitsiSafeBroadcast (guardia bridge + unicast).
    try { if (this.JitsiChild) this.JitsiChild.buttaTuttiFuori(); }
    catch (e) { console.warn('buttaTuttiFuori errore:', e); }

    Swal.fire({
        title:'Evento Terminato',
        text: 'puoi uscire dall\'aula.',
        icon: 'success',
        showCancelButton: false,
        confirmButtonColor: '#6993FF',
        cancelButtonColor: '#dadada',
        confirmButtonText: 'Grazie',
        allowOutsideClick: false,
     }).then((result) => {
        if (result.isConfirmed) {
            location.reload();
        }
    });

    setTimeout(() => {
        location.reload();
    }, 5000);
  }

  selectAula() {
    this.staticTabs.tabs.first.active=false;
    this.staticTabs.tabs.last.active=true;
    this.tabs2.active=false;
  }


  selectTabModuliUC(canAdd) {
    //this.staticTabs.tabs.first.active=true;
    //this.staticTabs.tabs.last.active=false;
    if(this.tabs1) this.tabs1.active=false;
    if(this.tabs2) this.tabs2.active=true;
    if(this.tabs3) this.tabs3.active=false;
    if(this.tabs4) this.tabs4.active=false;
    if(this.tabs5) this.tabs5.active=false;

    if(canAdd)
        this.entraInAula();
  }

  acquistoSuccess() {
    let name=this.schedaCorsista['cognome']+" "+this.schedaCorsista['nome'];
    let email="egeria.formazione@gmail.com";
    let number=this.schedaCorsista['telefono'];
    let message="Corso: <b>"+this.detallCorso.titolo+"</b> al costo di <b>€. "+this.cartTotalPrice+"</b>";
    let sceltaCorso='<b>Acquisto Online</b>';
    this.crudService.sent_Email(name, email, number, message, sceltaCorso).subscribe(responseData => {
        },(err)=>{
            }, ()=>{
        }
    );

    Swal.fire({
        title:'Pagamento Effettuato',
        text: 'effettuato con successo, puoi accedere al corso.',
        icon: 'success',
        showCancelButton: false,
        confirmButtonColor: '#6993FF',
        cancelButtonColor: '#dadada',
        confirmButtonText: 'Iniza il corso',
        allowOutsideClick: false,
     }).then((result) => {
        if (result.isConfirmed) {
            location.reload();
        }
    });
  }


  acquistoError() {
    Swal.fire({
        title:'Pagamento non riuscito!',
        text: 'non siamo riusciti a completare il pagamento.',
        icon: 'error',
        showCancelButton: false,
        confirmButtonColor: '#6993FF',
        cancelButtonColor: '#dadada',
        confirmButtonText: 'Riprova',
        allowOutsideClick: false,
     }).then((result) => {
        if (result.isConfirmed) {
            location.reload();
        }
    });
  }

  /**
   * Ricalcola isLocked sui moduli UC in base a isSequenzaModuliUC / progressione
   */
  ricalcolaLockingModuliUC() {
    // Stato "attesa esame finale": tutti i moduli completi MA esame finale non
    // superato → blocca TUTTO (moduli + SP) per forzare il corsista a sostenere
    // l'esame. Priorita' massima: vince su FAD_Always e Consultazione perche'
    // l'esame deve essere fatto prima di tutto.
    if(this.bloccaTuttoPerEsameFinale) {
        this.moduliUC.forEach(elementUC => {
            elementUC['isLocked']=1;
            if(elementUC['paragrafi']) {
                elementUC['paragrafi'].forEach(elementParagrafo => {
                    if(elementParagrafo['sotto-paragrafi']) {
                        elementParagrafo['sotto-paragrafi'].forEach(elementSotto => {
                            elementSotto['isFileLocked']=1;
                        });
                    }
                });
            }
        });
        return;
    }

    //se isFAD_Always è attivo, sblocco tutto
    if(this.isFAD_Always==true) {
        this.moduliUC.forEach(elementUC => {
            elementUC['isLocked']=0;
            if(elementUC['paragrafi']) {
                elementUC['paragrafi'].forEach(elementParagrafo => {
                    if(elementParagrafo['sotto-paragrafi']) {
                        elementParagrafo['sotto-paragrafi'].forEach(elementSotto => {
                            elementSotto['isFileLocked']=0;
                        });
                    }
                });
            }
        });
        return;
    }

    // Consultazione: sblocco tutto il materiale per libera consultazione
    if(this.isConsultazione) {
        this.moduliUC.forEach(elementUC => {
            elementUC['isLocked']=0;
            elementUC['isComplete']=1;
            if(elementUC['paragrafi']) {
                elementUC['paragrafi'].forEach(elementParagrafo => {
                    if(elementParagrafo['sotto-paragrafi']) {
                        elementParagrafo['sotto-paragrafi'].forEach(elementSotto => {
                            elementSotto['isFileLocked']=0;
                        });
                    }
                });
            }
        });
        if(this.moduloUC_TestValutazione) {
            this.moduloUC_TestValutazione.forEach(el => {
                el['canEnableTestValutazione']=1;
            });
        }
        return;
    }

    var isProgressioneModuli = 0;
    if(this.elencoDataCorso && this.elencoDataCorso.length) {
        isProgressioneModuli = this.elencoDataCorso[0]['canProgressiveModuli'];
    }

    if(!this.arrayLive) return;

    if(this.isInLive) {
        // DAD (isLive==1)
        if(this.arrayLive.isLive==1) {
            if(this.arrayLive.isSequenzaModuliUC==1) {
                var indexElement=0;
                var indexElementInner=0;
                this.moduliUC.forEach(element => {
                    element['isLocked']=1;
                    if(this.arrayLive.isSequenzaModuliUC_Array) {
                        this.arrayLive.isSequenzaModuliUC_Array.forEach(elementSequenza => {
                            if(element['id_modulo_header']==elementSequenza.id_modulo_header) {
                                if(indexElement==0 || indexElementInner==0) {
                                    element['isLocked']=0;
                                }
                                else if(indexElement>0) {
                                    if(this.moduliUC[indexElement-1]['isComplete']==1)
                                        element['isLocked']=0;
                                    else
                                        element['isLocked']=2;
                                }
                                indexElementInner++;
                            }
                        });
                    }
                    indexElement++;
                });
            }
            else if(isProgressioneModuli==1) {
                var indexElement=0;
                this.moduliUC.forEach(element => {
                    // Aggiorna test valutazione
                    if(this.moduloUC_TestValutazione && this.moduloUC_TestValutazione.length>0) {
                        if((this.moduloUC_TestValutazione.length-1)>=indexElement) {
                            if(this.moduliUC[indexElement]['isComplete']==1) {
                                if(this.moduloUC_TestValutazione.length>(indexElement+1)) {
                                    this.moduloUC_TestValutazione[indexElement+1]['canEnableTestValutazione']=1;
                                }
                            } else {
                                if(this.moduloUC_TestValutazione.length>(indexElement+1)) {
                                    this.moduloUC_TestValutazione[indexElement+1]['canEnableTestValutazione']=0;
                                }
                            }
                        }
                    }
                    if(indexElement==0) {
                        element['isLocked']=0;
                    }
                    else if(indexElement>0) {
                        if(this.moduliUC[indexElement-1]['isComplete']==1) {
                            if(this.moduloUC_TestValutazione && (this.moduloUC_TestValutazione.length-1)>=(indexElement-1)) {
                                if(this.moduloUC_TestValutazione[indexElement-1]['position']==indexElement) {
                                    if(this.moduloUC_TestValutazione[indexElement-1]['isSuperato']==1) {
                                        element['isLocked']=0;
                                    } else {
                                        element['isLocked']=2;
                                    }
                                } else {
                                    element['isLocked']=0;
                                }
                            } else {
                                element['isLocked']=0;
                            }
                        } else {
                            element['isLocked']=2;
                        }
                    }
                    if(this.moduloUC_TestValutazione && this.moduloUC_TestValutazione.length) {
                        if((this.moduloUC_TestValutazione[0]['position']==0) && (this.moduloUC_TestValutazione[0]['isSuperato']!=1) && (isProgressioneModuli==1)) {
                            element['isLocked']=2;
                        }
                    }
                    indexElement++;
                });
            }
        }

        // FAD in live (isLive==3)
        if(this.arrayLive.isLive==3) {
            if(this.arrayLive.isSequenzaModuliUC==1 || isProgressioneModuli==1) {
                var indexElement=0;
                this.moduliUC.forEach(element => {
                    // Aggiorna test valutazione
                    if(this.moduloUC_TestValutazione && this.moduloUC_TestValutazione.length>0) {
                        if((this.moduloUC_TestValutazione.length-1)>=indexElement) {
                            if(this.moduliUC[indexElement]['isComplete']==1) {
                                this.moduloUC_TestValutazione[indexElement]['canEnableTestValutazione']=1;
                            } else {
                                this.moduloUC_TestValutazione[indexElement]['canEnableTestValutazione']=0;
                            }
                        }
                    }
                    if(indexElement==0) {
                        element['isLocked']=0;
                    }
                    else if(indexElement>0) {
                        if(this.moduliUC[indexElement-1]['isComplete']==1)
                            element['isLocked']=0;
                        else
                            element['isLocked']=2;
                    }
                    indexElement++;
                });
            }
        }
    }
    else {
        // FAD non in live (isLive==3)
        if(this.arrayLive.isLive==3) {
            if(this.arrayLive.isSequenzaModuliUC==1 || isProgressioneModuli==1) {
                var indexElement=0;
                this.moduliUC.forEach(element => {
                    // Aggiorna test valutazione
                    if(this.moduloUC_TestValutazione && this.moduloUC_TestValutazione.length>0) {
                        if((this.moduloUC_TestValutazione.length-1)>=indexElement) {
                            if(this.moduliUC[indexElement]['isComplete']==1) {
                                this.moduloUC_TestValutazione[indexElement]['canEnableTestValutazione']=1;
                            } else {
                                this.moduloUC_TestValutazione[indexElement]['canEnableTestValutazione']=0;
                            }
                        }
                    }
                    if(indexElement==0) {
                        element['isLocked']=0;
                    }
                    else if(indexElement>0) {
                        if(this.moduliUC[indexElement-1]['isComplete']==1) {
                            if(this.moduloUC_TestValutazione && ((this.moduloUC_TestValutazione.length-1)>=(indexElement-1) && (this.moduloUC_TestValutazione[indexElement-1]['position']==indexElement))) {
                                if(this.moduloUC_TestValutazione[indexElement-1]['isSuperato']==1) {
                                    element['isLocked']=0;
                                } else {
                                    element['isLocked']=2;
                                }
                            } else {
                                element['isLocked']=0;
                            }
                        } else {
                            element['isLocked']=2;
                        }
                    }
                    if(this.moduloUC_TestValutazione && this.moduloUC_TestValutazione.length) {
                        if((this.moduloUC_TestValutazione[0]['position']==0) && (this.moduloUC_TestValutazione[0]['isSuperato']!=1) && (isProgressioneModuli==1)) {
                            element['isLocked']=2;
                        }
                    }
                    indexElement++;
                });
            }
        }
    }
  }

  noFADAttiva(isLocked, moduloUC: any = null) {
    //oggi la FAD non e' attiva: vale per tutti i video, prima dell'ordine di visione
    //(altrimenti dal 2° video in poi usciva «Riprendi il video» invece di «FAD non attiva!»)
    if(this.lockModuliUC==1 && !this.isConsultazione)
        isLocked=0;

    if(isLocked==3) {
        var spInfo = this.findIncompleteFileForUC(moduloUC);
        if(spInfo) {
            Swal.fire({
                title:'Riprendi il video',
                html: '«' + spInfo.sp['titolo'] + '» — mancano <b>' + spInfo.mancanti_label + '</b>. Finiscilo per accedere al prossimo contenuto.',
                icon: 'info',
                showCancelButton: true,
                confirmButtonColor: '#6993FF',
                cancelButtonColor: '#dadada',
                confirmButtonText: 'Riprendi',
                cancelButtonText: 'Annulla',
                allowOutsideClick: false,
             }).then((result) => {
                if(result.isConfirmed) {
                    var sp = spInfo.sp;
                    this.playVideo(
                        this.urlVideoCorso + sp['video'],
                        sp['titolo'],
                        spInfo.uc['id_corso'],
                        spInfo.uc['id_partner'],
                        sp['id_modulo_body'],
                        sp['id_modulo_body_paragrafo'],
                        sp['tempoTrascorso'],
                        sp['durata'],
                        0,
                        false
                    );
                }
            });
            return;
        }
        Swal.fire({
            title:'Contenuto bloccato',
            text: 'prima di procedere devi completare la visualizzazione del contenuto precedente.',
            icon: 'warning',
            showCancelButton: false,
            confirmButtonColor: '#6993FF',
            cancelButtonColor: '#dadada',
            confirmButtonText: 'Ok',
            allowOutsideClick: false,
         });
        return;
    }
    if(isLocked==2) {
        // Identifica l'UC precedente non completa e i sotto-paragrafi mancanti
        // per indicare al corsista esattamente cosa rivedere, e fornire un
        // pulsante diretto. Rispetta `canProgressiveModuli`: non bypassa
        // il blocco, guida solo a chiuderlo.
        var blocking = this.findIncompleteUCForUC(moduloUC);
        if(blocking && blocking.sotto.length > 0) {
            var first = blocking.sotto[0];
            var altri = blocking.sotto.length - 1;
            var msgText = '«' + first.sp['titolo'] + '» — mancano <b>' + first.mancanti_label + '</b>. Finiscilo per accedere al prossimo modulo.';
            if(altri > 0) msgText += ' (+ altri ' + altri + ' da completare a seguire)';
            Swal.fire({
                title:'Riprendi il video',
                html: msgText,
                icon: 'info',
                showCancelButton: true,
                confirmButtonColor: '#6993FF',
                cancelButtonColor: '#dadada',
                confirmButtonText: 'Riprendi',
                cancelButtonText: 'Annulla',
                allowOutsideClick: false,
             }).then((result) => {
                if(result.isConfirmed) {
                    var sp = first.sp;
                    this.playVideo(
                        this.urlVideoCorso + sp['video'],
                        sp['titolo'],
                        blocking.uc['id_corso'],
                        blocking.uc['id_partner'],
                        sp['id_modulo_body'],
                        sp['id_modulo_body_paragrafo'],
                        sp['tempoTrascorso'],
                        sp['durata'],
                        0,
                        false
                    );
                }
            });
            return;
        }
        Swal.fire({
            title:'Modulo incompleto',
            text: 'prima di procedere alla visualizzazione del materiale del modulo UC attuale devi completare la visualizzazione dei moduli precedenti.',
            icon: 'error',
            showCancelButton: false,
            confirmButtonColor: '#6993FF',
            cancelButtonColor: '#dadada',
            confirmButtonText: 'Riprova',
            allowOutsideClick: false,
         }).then((result) => {
            if (result.isConfirmed) {
                location.reload();
            }
        });
        return;
    }

    Swal.fire({
        title:'FAD non attiva!',
        text: 'non sei abilitato alla visualizzazione del corso in questo giorno o fascia d\'orario, consulta l\'elenco date',
        icon: 'error',
        showCancelButton: false,
        confirmButtonColor: '#6993FF',
        cancelButtonColor: '#dadada',
        confirmButtonText: 'Grazie',
        allowOutsideClick: false,
     }).then((result) => {
        if (result.isConfirmed) {

        }
    });
  }

  /**
   * Converte una durata in formato MM.SS (es. "50.16" = 50m 16s) in secondi assoluti.
   * Robust contro stringhe/numeri e trim trailing-zero (es. "50.8" = 50m 8s, NON 50m 80s).
   */
  private mmSsToSec(mmss: any): number {
    if(mmss === null || mmss === undefined || mmss === '') return 0;
    var parts = String(mmss).split('.');
    var min = parseInt(parts[0]) || 0;
    var sec = parts.length > 1 ? (parseInt(parts[1]) || 0) : 0;
    return min * 60 + sec;
  }

  private formatMancanti(sec: number): string {
    if(sec <= 0) return '0s';
    if(sec < 60) return sec + 's';
    var min = Math.floor(sec / 60);
    var s = sec % 60;
    return s > 0 ? (min + 'm ' + s + 's') : (min + 'm');
  }

  /**
   * Cerca a ritroso la prima UC con isComplete!=1 precedente all'UC cliccata, e raccoglie
   * tutti i suoi sotto-paragrafi con isFileComplete!=1 calcolando i secondi mancanti.
   * Serve a guidare il corsista al contenuto specifico da riguardare quando scatta isLocked=2.
   */
  private findIncompleteUCForUC(moduloUC: any): { uc: any, sotto: any[] } | null {
    if(!moduloUC || !this.moduliUC || !this.moduliUC.length) return null;
    var idx = -1;
    for(var k = 0; k < this.moduliUC.length; k++) {
        if(this.moduliUC[k]['id_modulo_header'] == moduloUC['id_modulo_header']) {
            idx = k;
            break;
        }
    }
    if(idx <= 0) return null;
    for(var i = idx - 1; i >= 0; i--) {
        var uc = this.moduliUC[i];
        if(uc['isComplete'] == 1) continue;
        var sotto: any[] = [];
        if(uc['paragrafi']) {
            uc['paragrafi'].forEach((par: any) => {
                if(par['sotto-paragrafi']) {
                    par['sotto-paragrafi'].forEach((sp: any) => {
                        if(sp['isFileComplete'] != 1) {
                            var durataSec = this.mmSsToSec(sp['durata']);
                            var trascorsoSec = this.mmSsToSec(sp['tempoTrascorso']);
                            var mancanti = Math.max(0, durataSec - trascorsoSec);
                            sotto.push({
                                sp: sp,
                                mancanti_sec: mancanti,
                                mancanti_label: this.formatMancanti(mancanti)
                            });
                        }
                    });
                }
            });
        }
        return { uc: uc, sotto: sotto };
    }
    return null;
  }

  /**
   * Trova il PRIMO sotto-paragrafo PRECEDENTE non completato che blocca la catena.
   * Usato quando isLocked=3 (catena SP cross-UC del backend) per guidare il corsista
   * direttamente al SP che ha rotto la catena.
   *
   * Logica: scorre UC e SP in ordine "naturale" (UC 0..idx, SP 0..N) e restituisce
   * il PRIMO incontro con isFileComplete!=1. E' il vero blocker della catena
   * sequenziale (i SP/UC successivi sono incompleti perche' non ancora aperti).
   *
   * Bug v1 storico: il loop scorreva al contrario (UC idx..0, SP N..0) e quindi
   * trovava per primo l'ULTIMO incompleto (es. cliccando SP[4] e con SP[3] e SP[5]
   * incompleti, restituiva SP[5] invece di SP[3]).
   */
  private findIncompleteFileForUC(moduloUC: any): { uc: any, sp: any, mancanti_label: string } | null {
    if(!moduloUC || !this.moduliUC || !this.moduliUC.length) return null;
    var idx = -1;
    for(var k = 0; k < this.moduliUC.length; k++) {
        if(this.moduliUC[k]['id_modulo_header'] == moduloUC['id_modulo_header']) {
            idx = k;
            break;
        }
    }
    // Scorri in avanti dall'UC piu' antica fino a quella cliccata (inclusa):
    // qualunque SP della stessa UC che precede quello cliccato puo' bloccare,
    // ma quelli SUCCESSIVI nello stesso array (non ancora aperti) no.
    var searchEnd = (idx >= 0) ? idx : this.moduliUC.length - 1;
    for(var i = 0; i <= searchEnd; i++) {
        var uc = this.moduliUC[i];
        if(!uc['paragrafi']) continue;
        for(var p = 0; p < uc['paragrafi'].length; p++) {
            var par = uc['paragrafi'][p];
            if(!par['sotto-paragrafi']) continue;
            for(var s = 0; s < par['sotto-paragrafi'].length; s++) {
                var sp = par['sotto-paragrafi'][s];
                if(sp['isFileComplete'] != 1) {
                    var durataSec = this.mmSsToSec(sp['durata']);
                    var trascorsoSec = this.mmSsToSec(sp['tempoTrascorso']);
                    var mancanti = Math.max(0, durataSec - trascorsoSec);
                    return { uc: uc, sp: sp, mancanti_label: this.formatMancanti(mancanti) };
                }
            }
        }
    }
    return null;
  }

  contenutoCompletato() {
    Swal.fire({
        title:'Contenuto completato',
        text: 'Hai già completato questo contenuto, passa al successivo.',
        icon: 'info',
        showCancelButton: false,
        confirmButtonColor: '#6993FF',
        confirmButtonText: 'Chiudi',
        allowOutsideClick: false,
    });
  }

  noAulaAttiva() {
    Swal.fire({
        title:'Aula non attiva!',
        text: 'non è stato ancora creato il link per connetterti in aula virtuale, riprova più tardi.',
        icon: 'error',
        showCancelButton: false,
        confirmButtonColor: '#6993FF',
        cancelButtonColor: '#dadada',
        confirmButtonText: 'Grazie',
        allowOutsideClick: false,
     }).then((result) => {
        if (result.isConfirmed) {

        }
    });
  }

  entraInAula() {
     if(this.arrayLive.length<=0) {
         return;
     }

     /*
      let arrayDetails={'idCorsista':this.arrayLive['id_corsista'],
                        'idCorsoSvolgimento': this.arrayLive['id_corso_svolgimento'],
                        'idCorsoHeader':this.arrayLive['id_corso_header'],
                        'durata': this.arrayLive['durata'],
                        'nome_aula':this.arrayLive['nome_aula'],
                        'link_aula':this.arrayLive['link_aula'],
                        'dataInizio': this.arrayLive['data_ora'],
                        'dataFine': this.arrayLive['data_ora_fine_full']};
      this.crudService.set_entraInAulaCorsista(arrayDetails).subscribe(responseData => {
         // this.showMeet=true;
          if(responseData==1) {}
      });
      */
    }

   entraInAulaMeet() {
        if(this.arrayLive.length<=0) {
            return;
        }
        if(this.preparandoAula) {
            return;
        }

        // Check accesso bloccato prima di entrare in aula
        const formData = new FormData();
        formData.append('idCorsista', this.arrayLive['id_corsista']);
        formData.append('idCorsoSvolgimento', this.arrayLive['id_corso_svolgimento']);
        fetch(this.crudService.url + 'check-accesso-bloccato.php', { method: 'POST', body: formData })
            .then(r => r.json())
            .then(resp => {
                if (resp.bloccato == 1) {
                    Swal.fire({
                        title: 'Accesso Bloccato',
                        text: 'Il tuo accesso alle aule è stato temporaneamente sospeso. Contatta l\'amministrazione per ulteriori informazioni.',
                        icon: 'warning',
                        confirmButtonColor: '#6993FF',
                        confirmButtonText: 'OK'
                    });
                    return;
                }
                this.procedEntraInAulaMeet();
            })
            .catch(err => { console.error('[AccessoCheck] fetch error:', err); this.procedEntraInAulaMeet(); });
    }

    // Dati della stanza Jitsi presi dalla live (api/corso.php::get_ElencoAulaCorsoTag
    // li restituisce insieme a nome_aula). null se ne manca anche uno solo:
    // senza codice cliente Jitsi aprirebbe «dominio//aula», una stanza vuota.
    datiAulaDallaLive() {
        const live = this.arrayLive || {};
        const dati = {
            tokenMeet: String(live['tokenMeet'] || '').trim(),
            serverMeet: String(live['serverMeet'] || '').trim(),
            nomeAula: String(live['nome_aula'] || '').trim()
        };
        return (dati.tokenMeet && dati.serverMeet && dati.nomeAula) ? dati : null;
    }

    // Barriera: aspetta i dati dell'aula per qualche secondo, poi li rilegge dal
    // server. Se mancano ancora, avvisa il corsista e NON apre la stanza.
    attendiDatiAula() {
        if (this.preparandoAula) return;
        this.preparandoAula = true;
        const inizio = Date.now();
        const attesa = setInterval(() => {
            if (this.datiAulaDallaLive()) {
                clearInterval(attesa);
                this.preparandoAula = false;
                this.procedEntraInAulaMeet();
                return;
            }
            if (Date.now() - inizio < 4000) return;
            clearInterval(attesa);
            this.crudService.api_get_ElencoAulaCorsoTag(this.productID, this.arrayLive['id_corsista']).subscribe(responseData => {
                const elenco: any[] = Array.isArray(responseData) ? responseData : [];
                const idSvolgimento = this.arrayLive['id_corso_svolgimento'];
                const live = elenco.find(e => idSvolgimento && e['id_corso_svolgimento'] == idSvolgimento);
                if (live && !Array.isArray(this.arrayLive)) {
                    // Si completano solo i campi vuoti: la stanza resta quella della live.
                    ['tokenMeet', 'serverMeet', 'nome_aula'].forEach(k => {
                        if (!String(this.arrayLive[k] || '').trim() && live[k]) this.arrayLive[k] = live[k];
                    });
                }
                this.preparandoAula = false;
                if (this.datiAulaDallaLive()) this.procedEntraInAulaMeet();
                else this.avvisoAulaNonPronta();
            }, () => {
                this.preparandoAula = false;
                this.avvisoAulaNonPronta();
            });
        }, 300);
    }

    avvisoAulaNonPronta() {
        Swal.fire({
            title: 'Aula non ancora pronta',
            text: "Non riesco a recuperare i dati dell'aula virtuale. Controlla la connessione e premi di nuovo «Entra in aula» tra qualche secondo.",
            icon: 'warning',
            confirmButtonColor: '#6993FF',
            confirmButtonText: 'OK'
        });
    }

    // <app-jitsi> ha trovato i dati vuoti e non ha aperto la stanza.
    onAulaNonPronta() {
        setTimeout(() => {
            this.showMeet = false;
            this.showMeetPreload = false;
            this.meetDati = null;
            this.avvisoAulaNonPronta();
        });
    }

    procedEntraInAulaMeet() {
        const datiAula = this.datiAulaDallaLive();
        if (!datiAula) {
            this.attendiDatiAula();
            return;
        }
        this.meetDati = datiAula;

        //controllo se è attivo il TIME CHECK attivo il timer
        this.timeCheck = (this.timeCheckBackup > 0) ? this.timeCheckBackup : this.timeCheck;
        this.checkIsActiveTimeInattivo();

        this.showMeet=true;
        this.showMeetPreload=true;

        setTimeout(() => {
            var tk=document.getElementById('jitsi-iframe') as HTMLInputElement;
            if (tk) tk.style.display="block";

            this.showMeetPreload=false;
        }, 2000);



        /*
         let arrayDetails={'idCorsista':this.arrayLive['id_corsista'],
                           'idCorsoSvolgimento': this.arrayLive['id_corso_svolgimento'],
                           'idCorsoHeader':this.arrayLive['id_corso_header'],
                           'durata': this.arrayLive['durata'],
                           'nome_aula':this.arrayLive['nome_aula'],
                           'link_aula':this.arrayLive['link_aula'],
                           'dataInizio': this.arrayLive['data_ora'],
                           'dataFine': this.arrayLive['data_ora_fine_full']};
         this.crudService.set_entraInAulaCorsista(arrayDetails).subscribe(responseData => {
             this.showMeet=true;

             var tk=document.getElementById('jitsi-iframe') as HTMLInputElement;
             tk.style.display="block";

             if(responseData==1) {}
         });
         */
    }

  openLinkografia(url) {
    if(!url){
        return null;
      } else{
        if (!url.match(/^https?:\/\//i)) {
            url = 'http://' + url;
        }
        window.open(url, '_blank');
      }
  }

  loadDetailsCorso(idCorso, isOnlyDAD){
    var idCorsista='';
    if(this.detailUser) {
        idCorsista=this.detailUser['id_corsista'];
    }

    this.crudService.api_get_DetailCorso(idCorso, idCorsista, this.reportForData, this.resetTimeFadEveryDays).subscribe(product => {
        console.log(product);
        console.log("scheda corso ----");

        //se non si tratta di un evento in LIVE (cioè di oggi) mi prendo ID_CORSO_SVOLGIMENTO di default
        //quello associato al corso e non all'evento, così mi registro tutti gli eventi associati
        if(this.arrayLive['isLive']!=1 && (this.elencoDataCorso.length==0)) {
            this.arrayLive['id_corso_svolgimento']=product['id_corso_svolgimento_default'];
            this.arrayLive['limita_moduloUC']=1;
        }
        //console.log(this.arrayLive);


        let idCorso=product['id_corso'];
        this.isMiur=product['isMiur'];
        this.isMim=product['isMim'];
        this.courseViewer=product['viewer'] || 'standard';
        this.idCorsoGlobal=product['id_corso'];
        this.idCorsoSvolgimentoDefaultCorso=product['id_corso_svolgimento_default'];

        this.detailEsameCorsoSetting=product['esame_corso'];
        this.sponsorCorso=product['sponsor'];

        let durataLabel=product['durata']['durata_label']=='h' ? 'ore' : product['durata']['durata_label'];
        this.detallCorso={
            durataNumero: product['durata']['durata_numero'],
            durata: product['durata']['durata_numero']+' ' +durataLabel,
            titolo: product['titolo'],
            descrizione: product['descrizione'],
            categoria: product['sottocategoria_corsi'][0],
            coin: product['numero_crediti_corsista_value'],
            costo: parseFloat(product['costo']),
            cfu: product['cfu'],
            image: product['image'],
            programma: product['programma'],
            moduliUC: product['moduloUC'],
            tokenMeet: product['tokenMeet'],
            haveBuy: product['haveBuy'],
            totaleDAD: product['totaleDAD'],
            totaleFAD: product['totaleFAD'],
            totaleDADFAD: this.sommaDurate(product['totaleDAD'], product['totaleFAD'])
        };
        //console.log(this.detallCorso);

        if(this.arrayLive.hasOwnProperty('isToday')==false) {
            if(this.arrayLive['isToday']==1) {
                if(this.detallCorso['haveBuy']) {
                    this.lockModuliUC=0;
                    this.isInLive=1;
                }
            }
        }

        this.costoCorso=parseFloat(product['costo']).toFixed(2).toString().replace(".",",");
        this.linkEsterno=product['link_esterno'];
        this.cartTotalPrice=parseFloat(product['costo']);

        if(parseFloat(product['costo_scontato'])>0) {
            this.costoCorsoScontato=parseFloat(product['costo_scontato']).toFixed(2).toString().replace(".",",");
            this.cartTotalPrice=parseFloat(product['costo_scontato']);
        }

        this.timeCheck=(product['time_check']*60);

        /*
        fetch(environment.urlImageCorso+"scheda/"+product['id_corso']+'.txt')
            .then(response => response.text())
            .then(data => {
  	            // Do something with your data
  	            console.log(data);
            }
        );
        */
        document.getElementById("programmaHTML").innerHTML=product['programma'];
        this.ModuloUC_frequenza=product['ModuloUC_frequenza'];
        this.nModuliUC=product['moduloUC'].length;
        this.nPropostaCorsi=product['propostaCorsi'];

        if(product['moduloUC'].length)
            this.videoPreview+=product['moduloUC'][0]['paragrafi'][0]['sotto-paragrafi'][0]['video'];

        product['moduloUC'].forEach(element => {
            this.nParagrafi+=element['paragrafi'].length;
        });
        this.moduliUC=product['moduloUC'];
        this.calcolaPercentualeModuli();

        // Override DAD-aware: sul corsista, il box "Fruizione N%" mostra il
        // valore autoritativo del backend (FAD + DAD-a-calendario). Senza
        // questo, il calcolo client (calcolaPercentualeModuli) resta FAD-only
        // e sui corsi 100% DAD il corsista vede sempre "Fruizione non iniziata"
        // pur avendo fatto 8h di aula live. Il backend calcola con
        // FunctionClaude::getPercentualeFruizioneDadAware (vedi api/corso.php).
        if (product['fruizioneDisplayPct'] !== undefined && product['fruizioneDisplayPct'] !== null) {
            this.fruizioneDisplayPercent = parseInt(product['fruizioneDisplayPct'], 10) || 0;
            this.fruizioneCompletata = this.fruizioneDisplayPercent >= 100;
        }

        console.log(this.moduliUC);
        console.log("-----moduli UC------");

        //controllo se l'amministratore ha attivato: PROGRESSIONE DEI CONTENUTI
        var isProgressioneModuli=0;
        if(this.elencoDataCorso.length) {
            isProgressioneModuli=this.elencoDataCorso[0]['canProgressiveModuli'];
        }

        console.log(this.elencoDataCorso);
        console.log("------elenco date corso------");

        this.moduloUC_TestValutazione=product['moduloUC_TestValutazione'];
        // Filtro visuale (solo test valutazione, esclude esami finali).
        this.moduloUC_TestValutazioneOnly = (this.moduloUC_TestValutazione || [])
            .filter((x:any) => Number(x?.['isTestValutazione']) === 1);
        console.log(this.moduloUC_TestValutazione);
        console.log("------test valutazione-----");

        // ECM — carica configurazione
        if(product['isECM'] == 1 && product['ecmConfig']) {
            this.isECM = true;
            this.ecmConfig = product['ecmConfig'];
            // Se deve_revisionare=1, carica mappa progresso revisione per tutti i sotto-paragrafi
            if(this.ecmConfig.deve_revisionare == 1 && this.detailUser) {
                this.crudService.api_ecmGetProgressoRevisioneAll(
                    this.detailUser['id_corsista'],
                    this.idCorsoGlobal,
                    this.schedaCorsistaGlobal['id_partner']
                ).subscribe((resp: any) => {
                    if(resp && resp.mappa) {
                        this.ecmRevisioneMap = resp.mappa;
                    }
                });
            }
        }

        // Consultazione: corso completato → accesso libero senza tracciamento DB
        if(this.isECM && this.ecmConfig) {
            // ECM: test superato E crediti assegnati → consultazione
            if(this.ecmConfig.test_superato == 1 && this.ecmConfig.crediti_assegnati == 1) {
                this.isConsultazione = true;
            }
        } else {
            // Non-ECM: il corso entra in consultazione libera (= no tracciamento DB) quando
            //   (1) tutti i moduli isComplete=1 e nessun esame di fine corso, OR
            //   (2) tutti i moduli isComplete=1 e tutti gli esami di fine corso superati, OR
            //   (3) il corso è configurato come FAD-sempre.
            // Why: `ModuloUC_frequenza` ritornato da api/corso.php usa `ceil` sul rapporto
            //   visto/totale, quindi diventa 100 gia' a 99.X%. Inoltre il backend forza 100
            //   sopra `sogliaFruizione`. Usare quella % come trigger di consultazione blocca
            //   il save quando il corsista non ha ancora aperto tutti gli SP (es. 2 SP
            //   parziali su 217 fanno 99.73% → ceil 100 → consultazione → tracking bloccato).
            //   `isComplete` di ogni modulo e' invece autoritativo: e' 1 solo se OGNI SP del
            //   modulo ha `tempoRestanteSec <= 2s` (function_modulo.php:354,433-437).
            //
            // Sorgente lista esami: `product['moduloUC_TestValutazione']` — restituito da
            // `api/corso.php::get_DetailCorsoTag`. Contiene SIA i test di valutazione
            // (isTestValutazione=1) SIA gli esami finali (isTestValutazione=0). Il campo
            // di completamento è `isSuperato` (0=non superato, 1=superato, 2=mai tentato).
            // (Il payload di `get_DetailCorso` NON ha la chiave `quiz`: quella è in
            // `get_DetailQuiz`, chiamata in seguito.)
            var allTestEsami = product['moduloUC_TestValutazione'] || [];
            // Esami finali (isTestValutazione=0): rilevanti per il "blocco" e per consultazione.
            var quizFineCorso = allTestEsami.filter((q: any) => q.isTestValutazione == 0);
            var hasEsameFineCorso = quizFineCorso.length > 0;
            var esameFineCorsoSuperato = hasEsameFineCorso &&
                                         quizFineCorso.every((q: any) => q.isSuperato == 1);
            // Test di valutazione (isTestValutazione=1): devono essere superati TUTTI prima
            // di considerare il corso "in consultazione". Senza questo check, se il corso
            // ha solo test di valutazione (es. corso 174 — 4 test, nessun esame finale),
            // appena tutti i moduli sono completi `isConsultazione=true` e il corsista
            // non puo' piu' fare/rifare i test → bloccato con "Modalita' consultazione".
            var hasAnyTestValutazione = allTestEsami.length > 0;
            var tuttiTestValutazioneSuperati = hasAnyTestValutazione &&
                                               allTestEsami.every((q: any) => q.isSuperato == 1);

            var isFADAlwaysCorso = (this.elencoDataCorso || []).some((d: any) => d['isFADAlways'] == 1);
            // Flag "Blocco calendario per il corsista" (DB: bloccoFAD_CorsoFULL):
            // quando attivo, al raggiungimento delle ore del corso DAD/FAD vengono
            // bloccate e il corso passa in modalita' "consultazione" (rivedibile
            // ma senza tracciamento tempo). Se NON attivo, il corsista puo'
            // continuare a rivedere e il tempo viene tracciato normalmente.
            var bloccoCorsoFullAttivo = (this.elencoDataCorso || []).some((d: any) => d['bloccoFAD_CorsoFULL'] == 1);

            // Tutti i moduli devono essere effettivamente completi (ogni SP al 100%
            // con tolleranza di 2s). NON usiamo `ModuloUC_frequenza >= 100` perche'
            // arrotonda per eccesso e forza 100 sopra sogliaFruizione.
            var tuttiModuliCompleti = Array.isArray(this.moduliUC) &&
                                      this.moduliUC.length > 0 &&
                                      this.moduliUC.every((m: any) => m['isComplete'] == 1);

            // isConsultazione: il corso e' DAVVERO completato E l'admin ha attivato
            // "Blocco calendario per il corsista" (bloccoFAD_CorsoFULL=1).
            //   - FAD-Always: libero accesso forzato dall'admin (caso speciale)
            //   - Altrimenti: tutti i moduli completi AND
            //                 (nessun test esistente OPPURE tutti i test superati) AND
            //                 bloccoFAD_CorsoFULL=1
            // Senza bloccoFAD_CorsoFULL, il corsista che completa il corso continua
            // a poter rivedere con tempo tracciato (richiesta esplicita).
            // "Tutti i test" include sia esami finali (isTestValutazione=0) sia
            // test di valutazione tra moduli (isTestValutazione=1).
            if (isFADAlwaysCorso) {
                // Always-FAD: video senza tracking, MA test eseguibili senza salvare
                // l'esito (caso speciale del corso configurato FAD-sempre dall'admin).
                this.isConsultazione = true;
                this.isAlwaysFadMode = true;
            } else if (tuttiModuliCompleti &&
                       (!hasAnyTestValutazione || tuttiTestValutazioneSuperati) &&
                       bloccoCorsoFullAttivo) {
                this.isConsultazione = true;
            }

            // Caso intermedio "in attesa esame finale": tutti i moduli sono completi
            // ma c'e' un esame di fine corso NON ancora superato. Il corsista non
            // dovrebbe rivedere i contenuti — deve focalizzarsi sull'esame. Quindi
            // moduli + SP vengono bloccati (vedi ricalcolaLockingModuliUC).
            this.bloccaTuttoPerEsameFinale = tuttiModuliCompleti &&
                                             hasEsameFineCorso &&
                                             !esameFineCorsoSuperato &&
                                             !isFADAlwaysCorso;
        }
        if(this.isConsultazione) {
            console.log("MODALITA CONSULTAZIONE: tracciamento DB disabilitato");
            this.lockModuliUC = 0;
        }
        if(this.bloccaTuttoPerEsameFinale) {
            console.log("ATTESA ESAME FINALE: moduli + SP bloccati");
            this.lockModuliUC = 1;
        }

        if(this.moduloUC_TestValutazioneSelected) {
            this.showTestValutazione=true;
        }

        //controllo se l'amministratore ha deciso di attivare il FLAG "isSequenzaModuliUC"
        //in tal caso mostro SOLO i moduli UC inseriti all'interno dell'evento
        if(this.isInLive) {
            if(this.arrayLive.isLive==1) {
                if(this.arrayLive.isSequenzaModuliUC==1) {
                    var newArray=new Array();
                    var indexElement=0;
                    var indexElementInner=0;
                    this.moduliUC.forEach(element => {
                        element['isLocked']=1;
                        this.arrayLive.isSequenzaModuliUC_Array.forEach(elementSequenza => {
                            if(element['id_modulo_header']==elementSequenza.id_modulo_header) {
                                //onsole.log(indexElement+"---"+element['id_modulo_header']+"---"+element['isComplete']+"---"+element['titolo']);
                                if(indexElement==0 || indexElementInner==0) {
                                    element['isLocked']=0;
                                }
                                else if(indexElement>0) {
                                    if(this.moduliUC[indexElement-1]['isComplete']==1)
                                        element['isLocked']=0;
                                    else {
                                        //modulo precedente non completo
                                        element['isLocked']=2;
                                    }
                                    /*
                                    console.clear();
                                    console.log(this.moduliUC[indexElement-1]['titolo']+"---"+this.moduliUC[indexElement-1]['isComplete']);
                                    console.log("aaaa"+element['titolo']+"----"+element['isLocked']);
                                    */
                                }
                                indexElementInner++;
                            }
                        });
                        newArray.push(element);
                        indexElement++;
                    });
                    this.moduliUC=newArray;
                    this.calcolaPercentualeModuli();
                }
                else if(isProgressioneModuli==1) {
                    var newArray=new Array();
                    var indexElement=0;
                    console.log("-------- test valutazione moduli UC ----------");
                    console.log(this.moduloUC_TestValutazione);
                    this.moduliUC.forEach(element => {
                        //blocco anche i TEST VALUTAZIONE se il modulo che lo precede non è stato completato
                        if(this.moduloUC_TestValutazione.length>0) {
                            if((this.moduloUC_TestValutazione.length-1)>=indexElement) {
                                if(this.moduliUC[indexElement]['isComplete']==1) {
                                    if(this.moduloUC_TestValutazione.length>(indexElement+1)) {
                                        this.moduloUC_TestValutazione[indexElement+1]['canEnableTestValutazione']=1;
                                    }
                                }
                                else {
                                    if(this.moduloUC_TestValutazione.length>(indexElement+1)) {
                                        this.moduloUC_TestValutazione[indexElement+1]['canEnableTestValutazione']=0;
                                    }
                                }
                            }
                        }

                        if(indexElement==0) {
                            element['isLocked']=0;
                        }
                        else if(indexElement>0) {
                            //controllo se il TEST VALUTAZIONE non è stato superato non abilita il modulo successivo
                            if(this.moduliUC[indexElement-1]['isComplete']==1) {
                                if((this.moduloUC_TestValutazione.length-1)>=(indexElement-1)) {
                                    if(this.moduloUC_TestValutazione[indexElement-1]['position']==indexElement) {
                                        if(this.moduloUC_TestValutazione[indexElement-1]['isSuperato']==1) {
                                            element['isLocked']=0;
                                        }
                                        else {
                                            element['isLocked']=2;
                                        }
                                    }
                                    else {
                                        element['isLocked']=0;
                                    }
                                }
                            }
                            else {
                                //modulo precedente non completo
                                element['isLocked']=2;
                            }
                        }

                        if(this.moduloUC_TestValutazione.length) {
                            if((this.moduloUC_TestValutazione[0]['position']==0) && (this.moduloUC_TestValutazione[0]['isSuperato']!=1) && (isProgressioneModuli==1)) {
                                element['isLocked']=2;
                            }
                        }
                        newArray.push(element);
                        indexElement++;
                    });

                    this.moduliUC=newArray;
                    this.calcolaPercentualeModuli();
                }
            }

            if(this.arrayLive.isLive==3) {
                if(this.arrayLive.isSequenzaModuliUC==1 || isProgressioneModuli==1) {
                    var newArray=new Array();
                    var indexElement=0;
                    this.moduliUC.forEach(element => {
                        if(indexElement==0) {
                            element['isLocked']=0;
                        }
                        else if(indexElement>0) {
                            if(this.moduliUC[indexElement-1]['isComplete']==1)
                                element['isLocked']=0;
                            else {
                                //modulo precedente non completo
                                element['isLocked']=2;
                            }
                        }
                        newArray.push(element);
                        indexElement++;
                    });

                    this.moduliUC=newArray;
                    this.calcolaPercentualeModuli();
                }
            }
        }
        //se non è in live o in calendario controllo se il corso è stato acquistato ed inserito in modo libero all'interno del corso, cioè senza calendario
        else {
            if(this.arrayLive.isLive==3) {
                if(this.arrayLive.isSequenzaModuliUC==1 || isProgressioneModuli==1) {
                    var newArray=new Array();
                    var indexElement=0;
                    this.moduliUC.forEach(element => {

                        //blocco anche i TEST VALUTAZIONE se il modulo che lo precede non è stato completato
                        if(this.moduloUC_TestValutazione.length>0) {
                            if((this.moduloUC_TestValutazione.length-1)>=indexElement) {
                                if(this.moduliUC[indexElement]['isComplete']==1) {
                                    this.moduloUC_TestValutazione[indexElement]['canEnableTestValutazione']=1;
                                }
                                else {
                                    this.moduloUC_TestValutazione[indexElement]['canEnableTestValutazione']=0;
                                }
                            }
                        }

                        if(indexElement==0) {
                            element['isLocked']=0;
                        }
                        else if(indexElement>0) {
                            //controllo se il TEST VALUTAZIONE non è stato superato non abilita il modulo successivo
                            if(this.moduliUC[indexElement-1]['isComplete']==1) {
                                if(((this.moduloUC_TestValutazione.length-1)>=(indexElement-1) && (this.moduloUC_TestValutazione[indexElement-1]['position']==indexElement))) {
                                    if(this.moduloUC_TestValutazione[indexElement-1]['isSuperato']==1) {
                                        element['isLocked']=0;
                                    }
                                    else {
                                        element['isLocked']=2;
                                    }
                                }
                            }
                            else {
                                //modulo precedente non completo
                                console.log("sono qui");
                                element['isLocked']=2;
                            }
                        }
                         if(this.moduloUC_TestValutazione.length) {
                            if((this.moduloUC_TestValutazione[0]['position']==0) && (this.moduloUC_TestValutazione[0]['isSuperato']!=1) && (isProgressioneModuli==1)) {
                                element['isLocked']=2;
                            }
                        }
                        newArray.push(element);
                        indexElement++;
                    });

                    this.moduliUC=newArray;
                    this.calcolaPercentualeModuli();
                }
            }
        }

        //se isFAD_Always è attivo, sblocco tutti i moduli e sotto-paragrafi
        //la consultazione libera non deve considerare la sequenza
        if(this.isFAD_Always==true) {
            this.moduliUC.forEach(elementUC => {
                elementUC['isLocked']=0;
                if(elementUC['paragrafi']) {
                    elementUC['paragrafi'].forEach(elementParagrafo => {
                        if(elementParagrafo['sotto-paragrafi']) {
                            elementParagrafo['sotto-paragrafi'].forEach(elementSotto => {
                                elementSotto['isFileLocked']=0;
                            });
                        }
                    });
                }
            });
        }

        //se la frequenza è minore di 100 allora mi controllo se si tratta SOLO di .pdf e me li controllo
        //controllo se tutti i .pdf sono stati aperti oppure no
        let backupModuloFrequenza=this.ModuloUC_frequenza;
        if(this.ModuloUC_frequenza<100) {
            this.ModuloUC_frequenza=100;
            this.moduliUC.forEach(elementUC => {
                elementUC['paragrafi'].forEach(elementSotto => {
                    elementSotto['sotto-paragrafi'].forEach(element => {
                        //console.log(element);
                        if(element['haveReadPDF']==0) {
                            //visto che i .pdf non sono completi ripristino il valore iniziale
                            //prelevato dalla fuzione assieme alla scheda del corso
                            this.ModuloUC_frequenza=backupModuloFrequenza;
                            return false;
                        }
                    });
                });
            });
        }

        //controllo dai setting se l'esame deve essere visualizzato SOLO nelle sessioni d'esame oppure NO
        if(this.detailEsameCorsoSetting['isEsameOnlySessione']==1)
                this.ModuloUC_frequenza=0;

        this.materialeDidattico=product['materiale_didattico'];
        this.materialeDocente=product['materiale_docente'] || [];
        console.log(this.materialeDidattico);
        console.log("-----materiale didattico-----");

        //this.checkUserIsEnabled(idCorso, idCorsista);

        this.detailAcquisto=product['haveBuyDetail'];
        if(this.detailAcquisto.length<=0)
            this.detailAcquisto="";


        //effettuo diversi controlli
        if(this.arrayLive['isLive']!=1) {
            if(this.isFAD_Always==true) {
                this.lockModuliUC=0;
                this.reportForData=1;
                this.isInLive=1;
                this.limita_moduloUC=1;
            }
        }

        //se è stata ATTIVATA la funzione FAD SEMPRE ATTIVA allora sblocco la FAD
        if(this.isFAD_Always==true) {
            this.lockModuliUC=0;
            this.isInLive=1;
        }
        //indica che il corsista ha acquistato il corso, quindi non ha eventi, il corso è LIBERO
        //oppure se ci sono eventi sono SOLO DAD e non ci sono eventi FAD in calendario
        //quindi può accedere alla visualizzazione dei video in modo libero
        else if((this.arrayLive.hasOwnProperty('isToday')==false) || (this.arrayLive['isToday']==0)) {
            if(this.detallCorso['haveBuy'] && isOnlyDAD) {
                this.lockModuliUC=0;
                this.isInLive=1;
            }
        }

        if(this.detailUser) {
            //controllo se è stato settato per il corsista la visualizzazione della barra di progressione per il lettore player
            this.crudService.api_canShowProgressPlayer(this.detailUser['id_corsista'], this.idCorsoGlobal).subscribe(canShow => {
                if(canShow['canShowProgressPlayer']==1)
                    this.canShowProgressPlayer=true;
            });

            //getElencoSessioniEsameFrontEnd
            this.crudService.api_getElencoSessioniEsameFrontEnd(this.detailUser.id_corsista, this.idCorsoGlobal).subscribe(response => {
                //console.log(response);
                this.sessioneEsame=response;
            });

            this.crudService.api_getSessioneEsameCorsista(this.detailUser.id_corsista, idCorso).subscribe(response => {
                this.sessioneEsameCorsista=response;
                //console.log(this.sessioneEsameCorsista);

                if(this.sessioneEsameCorsista.secondiInizioSessione>0) {
                    setTimeout(() => {
                        this.refreshStatusInizioEsame();
                    }, (parseInt(this.sessioneEsameCorsista.secondiInizioSessione)+1)*1000);
                }

                if((this.sessioneEsameCorsista.isDayEsame==1 && this.sessioneEsameCorsista.isInLiveEsameCorsista==1) && !(this.sessioneEsameCorsista.id_esame_type_documento && this.sessioneEsameCorsista.n_documento)) {
                    this.timerHandleEsaminatore=setInterval(() => {
                        this.refreshStatusEsaminatoreDocumenti();
                    }, 10000);
                }

                setTimeout(() => {
                    if(this.sessioneEsameCorsista.isDayEsame==1 && this.sessioneEsameCorsista.isInLiveEsameCorsista==1 && this.detailQuiz['isSuperatoQuiz']==0) {

                        if(this.detailQuiz.time_esame_secondi>0) {
                            //tolgo il tempo trascorso per fare in precedenza, cadute di connessione, etc....dal tempo totale del test a disposizione
                             this.tempoRestanteLimiteTEST=((this.detailQuiz.time_esame_secondi+1)-this.detailQuiz.tempoTrascorso);
                             this.aggiornaTempoLimiteTEST();
                        }
                        else {
                            this.tempoRestanteLimiteTEST=this.sessioneEsameCorsista.secondiFineSessione;
                            this.timerHandle=setInterval(() => {
                                this.aggiornaTempoLimiteTEST();
                            }, 1000);
                        }
                    }
                }, 2000);

                //mi ricavo la lista degli esami presenti all'interno del corso
                let idCorsoSvolgimento=(this.arrayLive['id_corso_svolgimento']);
                this.crudService.api_get_DetailQuiz(idCorso, idCorsista, idCorsoSvolgimento).subscribe(product => {
                    console.log(product);
                    console.log("dettaglio quiz------");
                    //console.log(this.sessioneEsameCorsista);

                    //controllo se sono stati selezionati deggli esami per la sessione d'esame
                    //che deve sostenere
                    if(this.sessioneEsameCorsista.sessioneEsamePrenotato?.length) {
                        var arrayNewQuiz=new Array();
                        //visualizzo solo per la sessione d'esame SOLO gli esami che sono stati scelti
                        product['quiz'].forEach(elementQuiz => {
                            this.sessioneEsameCorsista.sessioneEsamePrenotato.forEach(elementSessione => {
                                if(((elementSessione['id_quiz_header']==elementQuiz['id_quiz_header']) && this.sessioneEsameCorsista.isDayEsame==1)) {
                                    arrayNewQuiz.push(elementQuiz);
                                    //console.log(elementQuiz);
                                }
                            });
                        });
                        //aggiorno la lista dei TEST con quelli scelti per la sessione d'esame
                        if(arrayNewQuiz.length)
                            product['quiz']=arrayNewQuiz;
                    }

                    //console.log(product['quiz']);

                    var dataSessione="";
                    if(this.sessioneEsameCorsista?.hasOwnProperty('data_ora_esame'))
                        dataSessione=this.sessioneEsameCorsista.data_ora_esame.split(' ')[0];
                    var dataTestEffettuato="";

                    //controllo la variabile, setting per il corso impostato, quanti N esami per volta
                    //si possono fare (n_esami_max), logicamente NON conteggiando quelli superati
                    var indexQuizEsame=0;
                    var nEsameMax=0;
                    if(this.sessioneEsameCorsista.settingEsameCorso?.hasOwnProperty('n_esami_max'))
                        nEsameMax=this.sessioneEsameCorsista.settingEsameCorso.n_esami_max;

                    if(product['quiz'].length>=nEsameMax) {
                        //console.log(nEsameMax);
                        var arrayNewQuiz=new Array();

                        product['quiz'].forEach(element => {
                            //console.log("-------element----------");
                            //console.log(element);
                            //se l'esame è stato superato lo metto solo nella visualizzazione ma no nel conteggio degli
                            //esami da sostenere
                            if(element.isSuperatoQuiz==1) {
                                dataTestEffettuato=element.quizEffettuati[0].data_create.split(' ')[0];
                                if(dataSessione==dataTestEffettuato) {
                                    arrayNewQuiz.push(element);
                                    indexQuizEsame++;
                                }
                                /*
                                else if(dataSessione=="" && dataTestEffettuato!="") {
                                    arrayNewQuiz.push(element);
                                    indexQuizEsame++;
                                }
                                */
                            }
                            if(element.isSuperatoQuiz==0) {
                                //console.log(nEsameMax+"---"+indexQuizEsame);

                                if(nEsameMax>indexQuizEsame) {
                                    if(element.quizEffettuati.length) {
                                        dataTestEffettuato=element.quizEffettuati[0].data_create.split(' ')[0];
                                    }
                                    //console.log(dataSessione+"---"+dataTestEffettuato);
                                    if(dataSessione!=dataTestEffettuato) {
                                        element['quizEffettuati']=new Array();
                                    }
                                    arrayNewQuiz.push(element);
                                    indexQuizEsame++;

                                }
                            }
                        });

                        if(arrayNewQuiz.length)
                            product['quiz']=arrayNewQuiz;
                        //console.log(arrayNewQuiz);
                    }

                    //memorizzo tutti i TEST VALUTAZIOME e TEST ESAMI associati al corso
                    this.detailQuizOnlyTEST=product['quiz'];
                    this.durataEsameTotale=product['timeEsameTotaleFormattato'];

                    //visualizzo quanti esami ci sono all'interno del corso
                    //console.log(this.detailQuizOnlyTEST);

                    //inizializzo il QUIZ che deve affrontate il corsista
                    //se ha effettuato tutti i quiz l'array detailQuiz è vuoto, quindi non visualizza nulla da fare, perchè tutti
                    //gli esami sono stati fatti
                    // Bug fix tab "Esame Finale" mostrato per errore: detailQuiz deve essere
                    // popolato SOLO con un ESAME FINALE (isTestValutazione=0). Prima il primo
                    // forEach assegnava il primo quiz qualunque (incluso test di valutazione),
                    // facendo apparire il tab "Esame Finale" su corsi che ne sono privi.
                    var isSelectedQuiz=0;
                    product['quiz'].forEach(element => {
                        if(element.length || (typeof this.detailQuiz['isSuperatoQuiz'] != 'undefined')) {
                            if(element['quizEffettuati'].length==0 && isSelectedQuiz==0 && element['isTestValutazione']==0) {
                                this.detailQuiz=element;
                                //if(dataSessione==dataTestEffettuato) {
                                    isSelectedQuiz=1;
                                //}
                            }
                        }
                    });

                    //significa che non ci sono sessioni d'esame e quindi controllo se ci sono TEST ESAMI
                    //associati al corso, mi prendo il primo (se ci sono più esami bisogna creare la gestione multipla che per adesso è singola per
                    //gli esami non presenti nella sessione d'esame)
                    if(product['quiz'].length && isSelectedQuiz==0 && (this.sessioneEsameCorsista.length==0)) {
                        //this.detailQuiz=product['quiz'][0];
                        product['quiz'].forEach(element => {
                            // Bug fix precedenza operatori: "A && B || C" e' equivalente a
                            // "(A && B) || C", quindi quando isCorsoCompletoCheck=1 veniva
                            // assegnato come "esame finale" anche un test di valutazione.
                            // Parentesi corrette: il check isTestValutazione=0 e' obbligatorio.
                            if(element['isTestValutazione']==0 && (this.ModuloUC_frequenza>=100 || this.arrayLive['isCorsoCompletoCheck']==1)) {
                                this.detailQuiz=element;
                                //console.log(this.detailQuiz);
                            }
                        });
                        this.showEsameFattiDay=true;
                    }

                    //significa che sono i quiz ed ha effettuato tutti gli esami
                    if(this.sessioneEsameCorsista.sessioneEsamePrenotato?.length) {
                        if(product['quiz'].length && (this.sessioneEsameCorsista.isInLiveEsameCorsista==2 && this.sessioneEsameCorsista.isDayEsame==1)) {
                            this.showEsameFattiDay=true;
                        }
                    }

                    //controllo se c'è solo un TEST (per i corsi come Dattilografia, Sicurezza, etc...)
                    //per il rilascio dell'attestato
                    if(product['quiz'].length==1) {
                        //controllo che il TEST unico NON sia di valutazione ma sia L'ESAME
                        if(product['quiz'][0].isTestValutazione==0)
                            this.detailQuiz=product['quiz'][0];
                    }

                    this.detailQuiz['corsista']=product['corsista'];
                    this.detailQuiz['id_corso']=idCorso;

                    //ATTESTATO PER COMPLETAMENTO: sui corsi SENZA esame finale il gate
                    //"esame superato" non scatta mai, quindi il diritto all'attestato nasce dal
                    //completamento della fruizione. Il flag lo calcola il backend (api/corso.php,
                    //case get_DetailQuiz) con la stessa regola dell'Elenco Corsisti.
                    this.attestatoPerCompletamento = (product['attestatoPerCompletamento']==1);

                    if(this.detailQuiz['terminaTEST']>1) {
                        if(this.detailQuiz['isSuperatoQuiz']==0) {
                            this.tempoRestanteLimiteTEST=this.detailQuiz['terminaTEST'];

                            this.isInEsame=true;
                            this.tempoRestanteLimiteTEST=((this.detailQuiz['terminaTEST'])-this.detailQuiz.tempoTrascorso);
                            this.labelTempoRestanteLimiteTEST=this.secondsToHms(this.tempoRestanteLimiteTEST);

                            clearInterval(this.timerHandle);
                            this.timerHandle=setInterval(() => {
                                this.aggiornaTempoLimiteTEST();
                            }, 1000);
                        }
                    }

                    if(this.detailQuiz['isSuperatoQuiz']==1) {
                        clearInterval(this.timerHandle);
                    }

                    /*
                    console.log(this.sessioneEsame);
                    console.log(this.isEnabledUser);
                    console.log(this.detailQuiz['isDataLimitata']==0);
                    console.log(this.sessioneEsameCorsista.isInLiveEsameCorsista!=1);
                    console.log(this.detailQuiz['isSuperatoQuiz']==0);
                    console.log(this.detailQuiz);
                    */


                     //controllo se non c'è nessun QUIZ setto a 0 così abilita la FAD con gli altri controlli
                    if ((this.detailQuiz['isSuperatoQuiz'] === 'undefined') || (!('isSuperatoQuiz' in this.detailQuiz))) {
                        this.detailQuiz['isSuperatoQuiz']=0;

                    }

                    if (this.arrayLive?.detailExtraInfoAula?.extraLogo) {
                        this.logoFondo =environment.urlImageMedia+"logos/"+this.arrayLive.detailExtraInfoAula.extraLogo;
                    }

                      if (this.arrayLive?.onFocusVideo) {
                        this.onFocusVideo =this.arrayLive.onFocusVideo;
                    }

                    console.log("----element----");
                    console.log(this.detailQuiz);
                    console.log("----modulo frequenza----");
                    console.log(this.ModuloUC_frequenza);
                    console.log("live:"+this.isInLive);
                    console.log("array live-------------------------");
                    console.log(this.arrayLive);
                     console.log("array detail body-------------------------");
                    console.log(this.detailQuiz);
                    });
            });
        }

        //console.log(this.isInLive);
        //console.log(this.arrayLive);
        /*
        if(this.isInLive==1 && (this.arrayLive.time_check>0) && this.detailUser) {
            if(this.timeCheck>0 && this.arrayLive.limita_moduloUC==1) {
                //console.log(product);

                this.timeCheck=this.timeCheck*60;
                this.timeCheckBackup=this.timeCheck;
                this.timerHandleCheck=setInterval(() => {
                    this.countTimeCheck();
                }, 1000);
            }
        }
        */

        /*
        console.log(this.arrayLive);
        console.log(this.isEnabledUser);
        console.log(this.isInLive);
        console.log(this.lockModuliUC);
        console.log(this.detailQuiz['isSuperatoQuiz']);
        */

        //controllo se ci sono delle live registrate da mostrare
        if(this.detailUser) {
            var arrayDetail={'idCorso': this.idCorsoGlobal, 'idCorsoSvolgimento': this.arrayLive['id_corso_svolgimento'], 'idPartner': this.schedaCorsistaGlobal['id_partner']};
            this.crudService.getLiveFromIdCorsoAndPartner(arrayDetail).subscribe(product => {
                console.log("----- live registrate ----");
                console.log(product);
                this.liveVideoRegistrazione=product;
            });

        }

        //inizializzo i meta tag per le gestione social
        this.initiSocialMeta();

        /*
        console.log("------------");
        console.log(this.detailQuiz);
        console.log(this.ModuloUC_frequenza);
        console.log(this.sessioneEsameCorsista.length);
        //console.log(this.detailQuizOnlyTEST);
        */

        // Questionario di gradimento per corsi SENZA esame finale
        // Se tutti i moduli UC sono completati e non esiste un test esame → mostra questionario
        if (this.detailUser && this.ModuloUC_frequenza >= 100) {
            let hasEsameFinale = false;
            // Controlla quiz standard (isTestValutazione=0)
            if (this.detailQuizOnlyTEST && this.detailQuizOnlyTEST.length) {
                hasEsameFinale = true;
            }
            // Controlla anche test di valutazione (isTestValutazione=1)
            if (this.moduloUC_TestValutazione && this.moduloUC_TestValutazione.length > 0) {
                hasEsameFinale = true;
            }
            if (!hasEsameFinale) {
                this.showQuestionarioGradimento();
            }
            else {
                // Corsi CON esame/test finale: mostra il gradimento anche al RIENTRO
                // nella pagina, non solo nel popup transitorio post-esame (quizSuperato).
                // Quel popup era "usa e getta" e si perdeva se il corsista rientrava in
                // un'altra sessione o se l'apertura dell'attestato (window.open) rubava
                // il focus.
                // Uso detailQuizOnlyTEST (lista completa dei quiz col loro stato,
                // popolata in QUESTO stesso subscribe) invece di this.detailQuiz, la cui
                // assegnazione dipende da piu' condizioni e a corso completato puo'
                // restare non valorizzata.
                // showQuestionarioGradimento ricontrolla comunque config attiva + non
                // gia' compilato/saltato + frequenza 100%, quindi e' innocuo.
                // Fonte AFFIDABILE dello stato esame: moduloUC_TestValutazione arriva
                // da get_DetailCorso (corso-level) e contiene SIA i test di valutazione
                // (isTestValutazione=1) SIA l'esame finale (isTestValutazione=0) col loro
                // isSuperato. NON uso this.detailQuiz ne' this.detailQuizOnlyTEST: la loro
                // valorizzazione dipende dallo svolgimento corrente (arrayLive) e a corso
                // completato risultano vuoti/non assegnati (bug verificato: quizList=[]).
                let tv = (this.moduloUC_TestValutazione || []).map(q => ({ tv: q['isTestValutazione'], sup: q['isSuperato'] }));
                let dq = (this.detailQuizOnlyTEST || []).map(q => ({ tv: q['isTestValutazione'], sup: q['isSuperatoQuiz'] }));
                let all = tv.concat(dq);
                let esamiFinali = all.filter(x => x.tv == 0);
                let superato = esamiFinali.length
                    ? esamiFinali.every(x => x.sup == 1)   // tutti gli esami finali superati
                    : all.some(x => x.sup == 1);           // niente esame finale → basta un test superato
                if (superato) {
                    this.showQuestionarioGradimento();
                }
            }
        }

        // Questionario ECM: se il test è stato superato, mostra il questionario
        // finché il corsista non lo compila o non clicca "Salta" (check solo server-side)
        if (this.detailUser && this.isECM && this.ecmConfig && this.ecmConfig.test_superato == 1) {
            if (this.ecmConfig.gradimento_compilato != 1) {
                setTimeout(() => this.showQuestionarioGradimento(), 500);
            }
        }

        // Consultazione: sblocco tutto dopo il caricamento completo
        if(this.isConsultazione) {
            this.bloccoVisualizzazioneRipetuta = 0;
            if(this.detailQuiz) {
                this.detailQuiz['isSuperatoQuiz'] = 0;
            }
            this.lockModuliUC = 0;
            this.isLimiteRaggiunto = false;
            this.ricalcolaLockingModuliUC();
        }
    });
  }

  checkIsActiveTimeInattivo() {

    //console.log(this.arrayLive);
    //console.log(this.isInLive);

    if(this.timerHandleCheck) {
        return;
    }

    if(this.isInLive==1 && (this.timeCheck>0) && this.detailUser) {
        if(this.timeCheck>0) {
            //console.log(product);

            //this.timeCheck=this.timeCheck*60;
            this.timeCheckBackup=this.timeCheck;
            this.timerHandleCheck=setInterval(() => {
                this.countTimeCheck();
            }, 1000);
        }
    }
  }

  refreshStatusInizioEsame() {
    //getElencoSessioniEsameFrontEnd
    this.crudService.api_getSessioneEsameCorsista(this.detailUser.id_corsista, this.idCorsoGlobal).subscribe(response => {
        this.sessioneEsameCorsista=response;
        if((this.sessioneEsameCorsista.isDayEsame==1 && this.sessioneEsameCorsista.isInLiveEsameCorsista==1) && !(this.sessioneEsameCorsista.id_esame_type_documento && this.sessioneEsameCorsista.n_documento)) {
            this.timerHandleEsaminatore=setInterval(() => {
                this.refreshStatusEsaminatoreDocumenti();
            }, 10000);
        }

        setTimeout(() => {
            if(this.sessioneEsameCorsista.isDayEsame==1 && this.sessioneEsameCorsista.isInLiveEsameCorsista==1 && this.detailQuiz['isSuperatoQuiz']==0) {
                if(this.detailQuiz.time_esame_secondi>0) {
                    this.tempoRestanteLimiteTEST=this.detailQuiz.time_esame_secondi;
                }
                else {
                    this.tempoRestanteLimiteTEST=this.sessioneEsameCorsista.secondiFineSessione;
                }
                this.timerHandle=setInterval(() => {
                    this.aggiornaTempoLimiteTEST();
                }, 1000);

                Swal.fire({
                    title: 'Inizio Sessione d\'esame',
                    text: "è iniziata la sessione d\'esame.",
                    icon: 'success',
                    showCancelButton: false,
                    confirmButtonColor: '#3085d6',
                    cancelButtonColor: '#d33',
                    confirmButtonText: 'Chiudi',
                    cancelButtonText: 'Annulla'
                  }).then((result) => {
                    if (result.isConfirmed) {
                    }
                })
            }
        }, 250);


    });
  }

  refreshStatusEsaminatoreDocumenti() {
    this.crudService.api_getSessioneEsameCorsista(this.detailUser.id_corsista, this.idCorsoGlobal).subscribe(response => {
        this.sessioneEsameCorsista=response;

        if((this.sessioneEsameCorsista.isDayEsame==1 && this.sessioneEsameCorsista.isInLiveEsameCorsista==1) && (this.sessioneEsameCorsista.id_esame_type_documento && this.sessioneEsameCorsista.n_documento)) {
            this.tempoRestanteLimiteTEST=this.sessioneEsameCorsista.time_esame_secondi;
            clearInterval(this.timerHandleEsaminatore);
            Swal.fire({
                title: 'Documenti convalidati',
                text: "l'esaminatore ha approvato i tuoi documenti, puoi procedere con la sessione d'esame.",
                icon: 'success',
                showCancelButton: false,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Inizia l\'esame',
                cancelButtonText: 'Annulla'
              }).then((result) => {
                if (result.isConfirmed) {
                }
            })
        }
    });
  }



  GetAllSelectRadioButtons() {
    var arrInput = document.getElementsByTagName("input"), arrRadio = [];
    var j = 0;
    for (var i = 0; i < arrInput.length; i++) {
           if (arrInput[i].type == "radio" && arrInput[i].checked) {
                //var arrayDetail={'value': arrInput[i].value, 'name':arrInput[i].name};
                  arrRadio[j] = arrInput[i];
                  j++;
           }
    }
    return arrRadio;
}

// ===================================================================
// Helper per Test di Valutazione multi-tipo (vf, multi, aperta,
// ordinamento, abbinamento). La tipologia 'multipla' resta gestita
// dai radio nativi (GetAllSelectRadioButtons). Le altre risposte
// dell'utente sono raccolte qui in `userAnswers` per id_domanda.
// ===================================================================
public userAnswers: {[idDomanda: string]: any} = {};
public abbDxCache: {[idDomanda: string]: string[]} = {};

// Ritorna il tipo effettivo di una riga quizBody
getTipoDomanda(detailBody: any): string {
    if (!detailBody || !detailBody['domanda']) return 'multipla';
    const t = detailBody['domanda']['tipo'];
    const isLibera = detailBody['domanda']['isRispostaLibera'];
    if ((!t || t === 'multipla') && isLibera == 1) return 'aperta';
    return t || 'multipla';
}

// Ritorna array delle opzioni della domanda (parsed da opzioni_json/opzioni)
getOpzioni(detailBody: any): any[] {
    if (!detailBody || !detailBody['domanda']) return [];
    let opz = detailBody['domanda']['opzioni'];
    if (typeof opz === 'string') {
        try { opz = JSON.parse(opz); } catch (e) { opz = []; }
    }
    return Array.isArray(opz) ? opz : [];
}

// Lettera per opzione checkbox: A, B, C, D, ...
getLetter(i: number): string { return String.fromCharCode(65 + i); }

// Range 1..N per il select posizione dell'ordinamento
getOrdRange(detailBody: any): number[] {
    const n = this.getOpzioni(detailBody).length;
    const r = []; for (let i = 1; i <= n; i++) r.push(i); return r;
}

// Colonna destra dell'abbinamento — shuffled una-tantum per id_domanda,
// stabile per tutta la sessione del test (con seeding-free shuffle basico).
getAbbinamentoDx(detailBody: any): string[] {
    if (!detailBody || !detailBody['domanda']) return [];
    const id = detailBody['domanda']['id_domanda'];
    if (this.abbDxCache[id]) return this.abbDxCache[id];
    const coppie = this.getOpzioni(detailBody);
    const dx = coppie.map(c => Array.isArray(c) ? (c[1] || '') : '');
    // Fisher-Yates shuffle
    for (let i = dx.length - 1; i > 0; i--) {
        const j = Math.floor(Math.random() * (i + 1));
        [dx[i], dx[j]] = [dx[j], dx[i]];
    }
    this.abbDxCache[id] = dx;
    return dx;
}

// Ritorna true se il paragrafo ha almeno un sotto-paragrafo con contenuto
// reale (durata > 0). Serve a non mostrare paragrafi "orfani" tipo
// "Introduzione al corso" con durata=0 (corsi 100% DAD) che appaiono come
// label vuote in fondo al modulo UC.
paragrafoHaContenuto(paragrafo: any): boolean {
    if (!paragrafo || !paragrafo['sotto-paragrafi']) return false;
    const sp = paragrafo['sotto-paragrafi'];
    if (!Array.isArray(sp)) return false;
    for (let i = 0; i < sp.length; i++) {
        const d = parseFloat(sp[i]?.['durata']);
        if (!isNaN(d) && d > 0) return true;
    }
    return false;
}

// ===== Assistenza in aula (flag docente `assistenza=1` sul corsista) =====
// Colora in verde le opzioni corrette come aiuto visivo durante il test.
// Il case 'multipla' già lo fa via elenco_risposte['isCorrect']. Per i 5 tipi
// nuovi la fonte di verita' e' domanda['risposta_corretta'] (esposto dal
// backend in getDetailDomandaQuiz).
isRispostaCorrettaVf(detailBody: any, valore: 'vero'|'falso'): boolean {
    const corr = detailBody?.['domanda']?.['risposta_corretta'];
    if (corr === true)  return valore === 'vero';
    if (corr === false) return valore === 'falso';
    return false;
}

isRispostaCorrettaMulti(detailBody: any, index: number): boolean {
    const corr = detailBody?.['domanda']?.['risposta_corretta'];
    if (!Array.isArray(corr)) return false;
    return corr.map((x:any)=>parseInt(x,10)).indexOf(parseInt(index as any,10)) !== -1;
}

// Per l'ordinamento: dato l'indice originale dell'elemento, ritorna la
// posizione corretta (1-based) o null se non deducibile.
getPosizioneCorrettaOrd(detailBody: any, indexOrig: number): number|null {
    const corr = detailBody?.['domanda']?.['risposta_corretta'];
    if (!Array.isArray(corr)) return null;
    const pos = corr.map((x:any)=>parseInt(x,10)).indexOf(parseInt(indexOrig as any,10));
    return pos >= 0 ? pos + 1 : null;
}

// Per l'abbinamento: la scelta destra corretta per la riga sinistra `iSx`
// e' la label `coppie[iSx][1]` che dopo lo shuffle si trova nell'array dx
// a un certo indice j. Ritorna true se j === jCandidato.
isAbbinamentoDxCorretta(detailBody: any, iSx: number, jCandidato: number): boolean {
    const coppie = this.getOpzioni(detailBody);
    if (!Array.isArray(coppie) || !coppie[iSx]) return false;
    const dxAtteso = String(coppie[iSx][1] ?? '');
    const dxShuffled = this.getAbbinamentoDx(detailBody);
    return dxShuffled[jCandidato] === dxAtteso;
}

// Setter risposta utente (VF, aperta)
setUserAnswer(idDomanda: any, tipo: string, valore: any): void {
    this.userAnswers[idDomanda] = { tipo, valore };
}

// Toggle checkbox per multi-selezione — salva array di indici scelti
toggleMultiAnswer(idDomanda: any, indexOpzione: number, ev: any): void {
    const cur = this.userAnswers[idDomanda];
    let arr: number[] = (cur && cur.tipo === 'multi' && Array.isArray(cur.valore)) ? cur.valore.slice() : [];
    const checked = ev && ev.target ? !!ev.target.checked : false;
    const already = arr.indexOf(indexOpzione);
    if (checked && already === -1) arr.push(indexOpzione);
    if (!checked && already !== -1) arr.splice(already, 1);
    arr.sort((a,b) => a - b);
    this.userAnswers[idDomanda] = { tipo: 'multi', valore: arr };
}

// Ordinamento: salva mappa posizione -> index elemento
setOrdinamentoPos(idDomanda: any, indexElem: number, posStr: string, totale: number): void {
    const pos = parseInt(posStr, 10);
    const cur = this.userAnswers[idDomanda];
    // Struttura: array di lunghezza N dove ogni elemento e' l'index originale nella posizione i
    let arr: number[] = (cur && cur.tipo === 'ordinamento' && Array.isArray(cur.valore))
        ? cur.valore.slice()
        : new Array(totale).fill(-1);
    // Rimuovi indexElem da eventuale posizione precedente
    for (let i = 0; i < arr.length; i++) if (arr[i] === indexElem) arr[i] = -1;
    if (!isNaN(pos) && pos >= 1 && pos <= totale) arr[pos - 1] = indexElem;
    this.userAnswers[idDomanda] = { tipo: 'ordinamento', valore: arr };
}

// Abbinamento: salva mappa indexSinistra -> indexDestra (nel dx SHUFFLED)
setAbbinamento(idDomanda: any, indexSx: number, indexDxStr: string): void {
    const indexDx = parseInt(indexDxStr, 10);
    const cur = this.userAnswers[idDomanda];
    let map: {[k: string]: number} = (cur && cur.tipo === 'abbinamento' && typeof cur.valore === 'object' && cur.valore) ? {...cur.valore} : {};
    if (isNaN(indexDx)) {
        delete map[indexSx];
    } else {
        // Traduco index nel dx-shuffled -> valore stringa reale, cosi' il backend puo' matchare
        const dxArr = this.abbDxCache[idDomanda] || [];
        const nomeDx = dxArr[indexDx];
        map[indexSx] = nomeDx as any;
    }
    this.userAnswers[idDomanda] = { tipo: 'abbinamento', valore: map };
}

// Ritorna la risposta utente in formato per il backend (checkRispostaIsCorrectByTipo)
getUserAnswerForBackend(idDomanda: any): any {
    const a = this.userAnswers[idDomanda];
    return a ? a.valore : null;
}


GetAllRispostaMultipla() {
    var arrInput = document.getElementsByTagName("textarea"), arrRadio = [];
    var j = 0;
    for (var i = 0; i < arrInput.length; i++) {
           //if (arrInput[i].type == "radio" && arrInput[i].checked) {
                //var arrayDetail={'value': arrInput[i].value, 'name':arrInput[i].name};
                  arrRadio[j] = arrInput[i];
                  j++;
           //}
    }
    return arrRadio;
}

GetAllSelectRadioButtonsTEST() {
    var arrInput = document.getElementsByTagName("input"), arrRadio = [];
    var j = 0;
    for (var i = 0; i < arrInput.length; i++) {
        if (arrInput[i].type == "radio") {
            //var idRisposta="";
            //if(arrInput[i].checked)
                //idRisposta=arrInput[i].checked.;
            //var arrayDetail={'value': arrInput[i].value, 'name':arrInput[i].name};
            arrRadio[j] = arrInput[i];
            j++;
        }

    }
    return arrRadio;
}

 controllaQuizTEST(isFromSessioneEsame) {
    // Real consultazione (corso davvero completato + bloccoCorsoFULL): blocco l'invio
    // Always-FAD: l'esame parte, ma sul backend non viene salvato (flag inoltrato).
    if(this.isConsultazione && !this.isAlwaysFadMode) {
        Swal.fire({
            title: 'Modalità consultazione',
            text: 'Hai già completato questo corso. Il materiale è disponibile solo per consultazione.',
            icon: 'info', confirmButtonColor: 'var(--mainColor)', confirmButtonText: 'OK'
        });
        return;
    }

    // ECM — controlli pre-test (deve_revisionare include anche tentativi esauriti, gestito lato server)
    if(this.isECM && this.ecmConfig && this.ecmConfig.deve_revisionare == 1) {
        let msg = 'Devi rivedere l\'intero corso prima di poter riprovare il test .';
        if(this.ecmConfig.max_tentativi > 0) {
            msg += '\n\nTentativi utilizzati: ' + this.ecmConfig.tentativi_usati + ' / ' + this.ecmConfig.max_tentativi;
        }
        Swal.fire({
            title: 'Revisione obbligatoria',
            text: msg,
            icon: 'warning', allowOutsideClick: false, confirmButtonText: 'Torna al corso'
        }).then(() => { location.reload(); });
        return;
    }

    var arrayQuiz=this.GetAllSelectRadioButtonsTEST();
    var arrayRisposte=new Array();

    let idQuizHeader=this.detailQuiz['id_quiz_header'];
    let idCorsista=this.detailUser['id_corsista'];
    let idCorsoSvolgimento=this.arrayLive['id_corso_svolgimento'];
    let idCorso=this.detailQuiz['id_corso'];

    //mi serve per la gestione della generazione dell'attestato
    var arrayDetail={'id_corso': idCorso, 'id_corsista': idCorsista, 'id_corso_svolgimento': idCorsoSvolgimento};

    var domandaPrecedente="";
    var risposta="";
    var initIndex=0;
    var domanda="";

    if(arrayQuiz.length>0)
        domandaPrecedente=arrayQuiz[0].name;


    //raggruppo l'array in base alle domande
    arrayQuiz = arrayQuiz.reduce(function (r, a) {
        r[a.name] = r[a.name] || [];
        r[a.name].push(a);
        return r;
    }, Object.create(null));

    //controllo se si tratta di un esame con la SESSIONE D'ESAME impostazione con le date
    var idEsameBody="";
    if(isFromSessioneEsame==1) {
        idEsameBody=this.sessioneEsameCorsista['id_esame_body'];
    }

    var isRispostaLibera="";
    for (var key in arrayQuiz) {
        var value = arrayQuiz[key];
        risposta="";

        var idQuizBody="";
        value.forEach(element => {
            if(element.checked==true) {
                this.detailQuiz['body'].forEach(element => {
                    if(element['domanda']['id_domanda']==key) {
                        idQuizBody=element['id_quiz_body'];
                    }
                });

                risposta=element.value;
                isRispostaLibera=element.getAttribute('isRispostaLibera');
            }
        });

        arrayRisposte.push({"idEsameBody": idEsameBody,
                            "id_corso":idCorso,
                            "id_quiz_body": idQuizBody,
                            "id_header":idQuizHeader,
                            "id_corsista":idCorsista,
                            "id_corso_svolgimento":idCorsoSvolgimento,
                            "id_domanda":key,
                            "id_risposta":risposta,
                            "isTestValutazione": '0',
                            "isRispostaLibera": isRispostaLibera,
                            "isAlwaysFadMode": this.isAlwaysFadMode ? 1 : 0});
    };

    if(document.getElementById('btnTest')!==null)
        document.getElementById('btnTest').remove();

    this.crudService.api_verifica_quiz(arrayRisposte).subscribe(product => {
        //console.log(product);
        // ENFORCEMENT lato server (max_repeat / wait_time): tentativi esauriti o attesa non ancora trascorsa.
        // Il backend NON ha salvato il tentativo: mostro il messaggio e non proseguo con la valutazione.
        if(product && product['blocked']==1) {
            Swal.fire({
                title: 'Test non disponibile',
                text: product['msg'] || 'Non puoi ripetere il test in questo momento.',
                icon: 'warning',
                allowOutsideClick: false,
                confirmButtonColor: 'var(--mainColor)',
                confirmButtonText: 'Ho capito'
            }).then(() => { location.reload(); });
            return;
        }
        let corrette=product['corrette'];
        let nonCorrette=product['non_corrette'];
        let numeroDomande=product['numero_domande'];
        let sogliaMinimaPercentuale=product['soglia_minima_percentuale'];
        let sogliaMinimaDomande=product['soglia_minima_domande'];
        let sogliaCorrettePercentuale=product['soglia_corrette_percentuale'];
        // ECM — registra tentativo e aggiorna conteggio locale subito
        if(this.isECM && this.ecmConfig) {
            let superato = (corrette >= sogliaMinimaDomande) ? 1 : 0;
            this.ecmConfig.tentativi_usati++;
            this.ecmRegistraTentativo(corrette, numeroDomande, superato);
        }

        if(corrette>=sogliaMinimaDomande) {
            if(this.detailUser['canDownloadAttestato']==0) {
                //test superato
                this.quizSuperato(corrette, numeroDomande);
                return;
            }

            //genero l'attestato
            this.crudService.api_GeneraAttestato(arrayDetail).subscribe(product => {
                //console.log(product);
                let nomeCorsista=product['nome_corsista'];
                let data_nascita=product['data_nascita'];
                let provincia_nascita=product['provincia_nascita'];
                let comune_nascita=product['comune_nascita'];
                let data_attestato=product['data_attestato'];
                let cf=product['cf'];
                let codiceAteco=product['codice_ateco'];
                let isPresent=product['isPresent'];
                let attestato=product['attestato'];
                let dataStart=product['dataStart'];
                if(isPresent.hasOwnProperty('id_certificato')) {
                    window.open(environment.urlAttestati+isPresent.file);

                    setTimeout(() => {
                        //test superato
                        this.quizSuperato(corrette, numeroDomande);
                    }, 250);
                }
                else {
                    if(attestato) {
                        var detail='?id_corso='+idCorso+'&id_corso_svolgimento='+idCorsoSvolgimento+'&id_corsista='+idCorsista+'&nome_corsista='+nomeCorsista+'&data_nascita='+data_nascita+'&provincia_nascita='+provincia_nascita+'&comune_nascita='+comune_nascita+'&data_attestato='+data_attestato+'&dataStart='+dataStart+'&cf='+cf+'&protocollo='+this.protocollo+'&mansione='+this.mansione+'&codiceAteco='+codiceAteco;
                        window.open(environment.urlAttestatiDaCreare+attestato+".php"+detail);

                        setTimeout(() => {
                            //test superato
                            this.quizSuperato(corrette, numeroDomande);
                        }, 250);
                    }
                    else {
                        Swal.fire({
                            title: 'Errore!',
                            text: "non è stasto creato l\'attestato .pdf, non posso procedere alla generazione dell\'attestato",
                            icon: 'error',
                            showCancelButton: false,
                            confirmButtonColor: '#3085d6',
                            cancelButtonColor: '#d33',
                            confirmButtonText: 'Risolvi',
                            cancelButtonText: 'Annulla'
                          }).then((result) => {
                            if (result.isConfirmed) {
                            }
                        })
                    }
                }
            });
        }
        else {
            //test non superato
            this.quizNonSuperato(corrette, nonCorrette);
        }

    });
 }

  entraInMeetEsame(idEsameBody) {
    var arrayDetail={'idCorsista': this.detailUser.id_corsista, 'idEsameBody': idEsameBody, 'tipologia': 'in_meet_esame'};
    this.crudService.set_entraInMeetEsame(arrayDetail).subscribe(response => {
        //console.log(response);
    });
  }

  controllaQuiz() {
    // Real consultazione (corso davvero completato + bloccoCorsoFULL): blocco l'invio.
    // Always-FAD: il test parte, ma sul backend non viene salvato (flag inoltrato).
    if(this.isConsultazione && !this.isAlwaysFadMode) {
        Swal.fire({
            title: 'Modalità consultazione',
            text: 'Hai già completato questo corso. Il materiale è disponibile solo per consultazione.',
            icon: 'info', confirmButtonColor: 'var(--mainColor)', confirmButtonText: 'OK'
        });
        return;
    }

    // ECM — controlli pre-test (deve_revisionare include anche tentativi esauriti, gestito lato server)
    if(this.isECM && this.ecmConfig && this.ecmConfig.deve_revisionare == 1) {
        let msg = 'Devi rivedere l\'intero corso prima di poter riprovare il test .';
        if(this.ecmConfig.max_tentativi > 0) {
            msg += '\n\nTentativi utilizzati: ' + this.ecmConfig.tentativi_usati + ' / ' + this.ecmConfig.max_tentativi;
        }
        Swal.fire({
            title: 'Revisione obbligatoria',
            text: msg,
            icon: 'warning', allowOutsideClick: false, confirmButtonText: 'Torna al corso'
        }).then(() => { location.reload(); });
        return;
    }

    // ENFORCEMENT tentativi/attesa (max_repeat / wait_time) per l'ESAME: blocco l'invio se non puo' ritentare ora.
    var _exId = this.detailQuiz ? this.detailQuiz['id_quiz_header'] : null;
    var _exItem = (this.moduloUC_TestValutazione || []).find(t => t && t['id_quiz_header']==_exId);
    if(_exItem && _exItem['canRetry']==0 && _exItem['isSuperato']!=1) {
        Swal.fire({
            title: 'Esame non disponibile',
            text: _exItem['retryMsg'] || 'Non puoi ripetere l\'esame in questo momento.',
            icon: 'warning',
            confirmButtonColor: 'var(--mainColor)',
            confirmButtonText: 'OK'
        });
        return;
    }

    var arrayRisposte=new Array();

            let idQuizHeader=this.detailQuiz['id_quiz_header'];
            let idCorsista=this.detailUser['id_corsista'];
            let idCorsoSvolgimento=this.arrayLive['id_corso_svolgimento'];
            let idCorso=this.detailQuiz['id_corso'];

            //mi serve per la gestione della generazione dell'attestato
            var arrayDetail={'id_corso': idCorso, 'id_corsista': idCorsista, 'id_corso_svolgimento': idCorsoSvolgimento};

            //controllo se si tratta di un esame con la SESSIONE D'ESAME impostazione con le date
            var idEsameBody="";
            if(this.sessioneEsameCorsista.hasOwnProperty("id_esame_body")) {
                idEsameBody=this.sessioneEsameCorsista['id_esame_body'];
            }

            // Loop su tutte le domande dell'esame: emette 1 payload per domanda,
            // con tipo + risposta_user nel formato aspettato dal backend.
            this.detailQuiz['body'].forEach(row => {
                const domanda = row['domanda'];
                const idDomanda = domanda['id_domanda'];
                const tipo = this.getTipoDomanda(row);

                let idRisposta: any = 0;
                let rispostaUser: any = null;
                let hasAnswer = false;
                let isRispostaLiberaFlag = '0';

                if (tipo === 'multipla') {
                    // NUOVO MODELLO opzioni_json: userAnswers[idDomanda] contiene l'indice scelto
                    const ansIdx = this.getUserAnswerForBackend(idDomanda);
                    if (ansIdx !== null && ansIdx !== undefined && ansIdx !== '') {
                        rispostaUser = parseInt(ansIdx, 10);
                        hasAnswer = true;
                    } else {
                        // Legacy: radio nativo
                        const radios = this.GetAllSelectRadioButtons();
                        for (let k = 0; k < radios.length; k++) {
                            if (radios[k].name == idDomanda) {
                                idRisposta = radios[k].value;
                                hasAnswer = true;
                                break;
                            }
                        }
                    }
                } else if (tipo === 'aperta') {
                    // Textarea legacy (isRispostaLibera=1) via GetAllRispostaMultipla + fallback userAnswers
                    const areas = this.GetAllRispostaMultipla();
                    for (let k = 0; k < areas.length; k++) {
                        if (areas[k].name == idDomanda && areas[k].value && areas[k].value.trim() !== '') {
                            idRisposta = areas[k].value;
                            hasAnswer = true;
                            isRispostaLiberaFlag = '1';
                            break;
                        }
                    }
                    if (!hasAnswer) {
                        const ans = this.getUserAnswerForBackend(idDomanda);
                        if (ans !== null && String(ans).trim() !== '') {
                            rispostaUser = ans;
                            hasAnswer = true;
                            isRispostaLiberaFlag = '1';
                        }
                    }
                } else if (tipo === 'vf') {
                    const ans = this.getUserAnswerForBackend(idDomanda);
                    if (ans === 'vero' || ans === 'falso') { rispostaUser = ans; hasAnswer = true; }
                } else if (tipo === 'multi') {
                    const ans = this.getUserAnswerForBackend(idDomanda);
                    if (Array.isArray(ans) && ans.length > 0) { rispostaUser = ans; hasAnswer = true; }
                } else if (tipo === 'ordinamento') {
                    const ans = this.getUserAnswerForBackend(idDomanda);
                    if (Array.isArray(ans) && ans.every(x => x !== -1 && x !== null && x !== undefined)) {
                        rispostaUser = ans; hasAnswer = true;
                    }
                } else if (tipo === 'abbinamento') {
                    const ans = this.getUserAnswerForBackend(idDomanda);
                    const nOpz = this.getOpzioni(row).length;
                    if (ans && typeof ans === 'object' && Object.keys(ans).length === nOpz) {
                        rispostaUser = ans; hasAnswer = true;
                    }
                }

                if (!hasAnswer) return;

                const idQuizBody = row['id_quiz_body'] || '';
                arrayRisposte.push({
                    "idEsameBody": idEsameBody,
                    "id_corso": idCorso,
                    "id_header": idQuizHeader,
                    "id_corsista": idCorsista,
                    "id_quiz_body": idQuizBody,
                    "id_corso_svolgimento": idCorsoSvolgimento,
                    "id_domanda": idDomanda,
                    "id_risposta": idRisposta,
                    "tipo": tipo,
                    "risposta_user": rispostaUser,
                    "isTestValutazione": '0',
                    "isRispostaLibera": isRispostaLiberaFlag,
                    "isAlwaysFadMode": this.isAlwaysFadMode ? 1 : 0
                });
            });
    //controllo se l'utente ha risposto a tutte le domande, in caso contrario visualizzo il msg
    if(arrayRisposte.length<this.detailQuiz['body'].length) {
        this.quizNonCompleto();
        return;
    }

    Swal.fire({
        icon: 'question',
        title: 'Sei sicuro?',
        text: 'vuoi confermare e procedere con la verifica del TEST?',
        showCancelButton: true,
        confirmButtonColor: 'var(--mainColor)',
        cancelButtonColor: '#dadada',
        confirmButtonText: 'Si, confermo!',
        cancelButtonText: 'Annulla',
        width: '400px',
        allowOutsideClick: false,
      }).then((result) => {
        if (result.isConfirmed) {

            document.getElementById('btnTest').remove();

            this.crudService.api_verifica_quiz(arrayRisposte).subscribe(product => {
                //console.log(product);
                // ENFORCEMENT lato server (max_repeat / wait_time): tentativi esauriti o attesa non trascorsa.
                if(product && product['blocked']==1) {
                    Swal.fire({
                        title: 'Esame non disponibile',
                        text: product['msg'] || 'Non puoi ripetere l\'esame in questo momento.',
                        icon: 'warning',
                        allowOutsideClick: false,
                        confirmButtonColor: 'var(--mainColor)',
                        confirmButtonText: 'Ho capito'
                    }).then(() => { location.reload(); });
                    return;
                }
                let corrette=product['corrette'];
                let nonCorrette=product['non_corrette'];
                let numeroDomande=product['numero_domande'];
                let sogliaMinimaPercentuale=product['soglia_minima_percentuale'];
                let sogliaMinimaDomande=product['soglia_minima_domande'];
                let sogliaCorrettePercentuale=product['soglia_corrette_percentuale'];
                if(corrette>=sogliaMinimaDomande) {
                    if(this.detailUser['canDownloadAttestato']==0) {
                        //test superato
                        this.quizSuperato(corrette, numeroDomande);
                        return;
                    }

                    //genero l'attestato
                    this.crudService.api_GeneraAttestato(arrayDetail).subscribe(product => {
                        //console.log(product);
                        let nomeCorsista=product['nome_corsista'];
                        let data_nascita=product['data_nascita'];
                        let provincia_nascita=product['provincia_nascita'];
                        let comune_nascita=product['comune_nascita'];
                        let data_attestato=product['data_attestato'];
                        let cf=product['cf'];
                        let codiceAteco=product['codice_ateco'];
                        let isPresent=product['isPresent'];
                        let attestato=product['attestato'];
                        let dataStart=product['dataStart'];
                        if(isPresent.hasOwnProperty('id_certificato')) {
                            window.open(environment.urlAttestati+isPresent.file);

                            setTimeout(() => {
                                //test superato
                                this.quizSuperato(corrette, numeroDomande);
                            }, 250);
                        }
                        else {
                            if(attestato) {
                                var detail='?id_corso='+idCorso+'&id_corso_svolgimento='+idCorsoSvolgimento+'&id_corsista='+idCorsista+'&nome_corsista='+nomeCorsista+'&data_nascita='+data_nascita+'&provincia_nascita='+provincia_nascita+'&comune_nascita='+comune_nascita+'&data_attestato='+data_attestato+'&dataStart='+dataStart+'&cf='+cf+'&protocollo='+this.protocollo+'&mansione='+this.mansione+'&codiceAteco='+codiceAteco;
                                window.open(environment.urlAttestatiDaCreare+attestato+".php"+detail);

                                setTimeout(() => {
                                    //test superato
                                    this.quizSuperato(corrette, numeroDomande);
                                }, 250);
                            }
                            else {
                                Swal.fire({
                                    title: 'Errore!',
                                    text: "non è stasto creato l\'attestato .pdf, non posso procedere alla generazione dell\'attestato",
                                    icon: 'error',
                                    showCancelButton: false,
                                    confirmButtonColor: '#3085d6',
                                    cancelButtonColor: '#d33',
                                    confirmButtonText: 'Risolvi',
                                    cancelButtonText: 'Annulla'
                                  }).then((result) => {
                                    if (result.isConfirmed) {
                                    }
                                })
                            }
                        }
                    });
                }
                else {
                    //test non superato
                    this.quizNonSuperato(corrette, nonCorrette);
                }

            });
        }
    })


  }

  quizSuperato(risposteCorrette, numeroTotaleDomande) {
    Swal.fire({
        title:'Complimenti!',
        text: 'hai superato il test con il numero di '+risposteCorrette+' risposte corrette su un totale di '+numeroTotaleDomande+' domande',
        icon: 'success',
        showCancelButton: false,
        confirmButtonColor: '#6993FF',
        cancelButtonColor: '#dadada',
        confirmButtonText: 'Grazie',
        allowOutsideClick: false,
     }).then((result) => {
        if (result.isConfirmed) {
            this.showQuestionarioGradimento();
        }
    });
  }

  // URL di download del materiale didattico, robusto rispetto a DUE convenzioni
  // storiche del campo `materiale`:
  //   - pulito: solo il nome file (es. "1788..._LA CELLULA.pdf") → il file fisico
  //     sta in materiale-didattico/{id_partner}/{nome}, quindi antepongo id_partner.
  //   - storico "sporco": gia' "{id_partner}/{nome}" (es. "1/1788..._LA CELLULA.pdf")
  //     → il partner e' GIA' nel valore: NON lo antepongo di nuovo, altrimenti esce
  //     il doppio segmento (.../1/1/...) e il download va in 404.
  // Discriminante: se `materiale` contiene una "/" e' gia' un percorso partner/nome.
  public materialeHref(m: any): string {
    let file = (m && m['materiale']) ? String(m['materiale']) : '';
    if (file.indexOf('/') !== -1) {
        return this.materialeDidatticoPath + file;
    }
    let idp = (m && m['id_partner']) ? m['id_partner'] : 1;
    return this.materialeDidatticoPath + idp + '/' + file;
  }

  showQuestionarioGradimento() {
    let idCorso = this.idCorsoGlobal;
    let idPartner = this.detailUser ? this.detailUser['id_partner'] : 0;
    let idCorsista = this.detailUser ? this.detailUser['id_corsista'] : 0;

    // Controlla isAttivo server-side prima di mostrare il questionario.
    //
    // BUG fix loop: precedentemente si faceva `location.reload()` ogni volta che
    // config era null, isAttivo!=1, o giaCompilato==1. Questo causava loop
    // infiniti perche' la funzione e' chiamata in init (ngOnInit branch a riga
    // ~2023 quando il corso non ha esami): se gradimento non e' attivo sul corso,
    // ad ogni init reload → init → reload → ...
    // Corso 128 (Operatore Amministrativo Contabile) / aula OAC-9 / corsisti che
    // hanno completato il corso senza gradimento attivo entravano in loop.
    //
    // Nuova logica:
    //   - config null / isAttivo!=1 → return senza reload (l'UI e' gia' nello stato
    //     corretto, nessuna transizione da segnalare)
    //   - giaCompilato==1 → return senza reload (semantica analoga; senza reload
    //     il bottone "compila gradimento" resta visibile ma nessuna azione lo
    //     mostra perche' giaCompilato=1, quindi e' inerte)
    //   - ECM gradimento_compilato==1 → idem
    this.crudService.api_getGradimentoConfig(idCorso, idPartner, idCorsista).subscribe((config: any) => {
        if (!config || config.isAttivo != 1) return;
        if (config.giaCompilato == 1) return;

        // Se ECM attivo → questionario ECM (non dipende da ModuloUC_frequenza)
        if (this.isECM && this.ecmConfig) {
            if (this.ecmConfig.gradimento_compilato == 1) return;
            this.showQuestionarioGradimentoEcm(idCorso, idPartner);
            return;
        }

        // Non-ECM: il questionario richiede completamento (moduli UC al 100%).
        // Se non al 100% non lo mostriamo (no reload — verra' richiamato quando
        // il corsista completera').
        if (this.ModuloUC_frequenza < 100) return;

        // Non-ECM: questionario Accordo Stato-Regioni.
        // Le domande non sono piu' fisse: arrivano dal server e sono quelle scelte
        // per questo corso. Se il server non ne manda (piattaforma non aggiornata)
        // si ricade sulle quattro storiche, cosi' nulla si rompe.
        let domandeGrad = (config.domande && config.domande.length) ? config.domande : [
            { codice: 'qualita_didattica',     testo: 'Qualità didattica',            descrizione: '', tipo: 'scala' },
            { codice: 'qualita_organizzativa', testo: 'Qualità organizzativa',        descrizione: '', tipo: 'scala' },
            { codice: 'utilita_percepita',     testo: 'Utilità percepita',            descrizione: '', tipo: 'scala' },
            { codice: 'aspettative',           testo: 'Rispondenza alle aspettative', descrizione: '', tipo: 'scala' },
            { codice: 'commento',              testo: 'Suggerimenti o commenti',      descrizione: '', tipo: 'testo' }
        ];

        let escGrad = (s) => String(s == null ? '' : s)
            .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');

        let corpoGrad = '';
        domandeGrad.forEach((d) => {
            let etichetta = '<label style="display:block;font-weight:600;margin-bottom:6px;font-size:14px">' + escGrad(d.testo);
            if (d.tipo === 'testo') etichetta += ' <span style="font-weight:400;color:#999">(opzionale)</span>';
            etichetta += '</label>';
            if (d.descrizione) {
                etichetta += '<div style="font-size:12px;color:#999;margin:-4px 0 6px">' + escGrad(d.descrizione) + '</div>';
            }

            corpoGrad += '<div class="swal-grad-row" style="margin-bottom:16px">' + etichetta;
            if (d.tipo === 'testo') {
                corpoGrad += '<textarea class="swal-grad-testo" data-codice="' + escGrad(d.codice) + '" rows="3" ' +
                    'style="width:100%;border:1px solid #ddd;border-radius:8px;padding:10px;font-size:14px;resize:vertical" ' +
                    'placeholder="Scrivi qui..."></textarea>';
            } else {
                corpoGrad += '<div class="swal-stars" data-codice="' + escGrad(d.codice) + '">';
                for (let v = 1; v <= 5; v++) corpoGrad += '<span class="swal-star" data-value="' + v + '">★</span>';
                corpoGrad += '</div>';
            }
            corpoGrad += '</div>';
        });

            Swal.fire({
                title: 'Questionario di Gradimento',
                html: `
                    <p style="font-size:14px;color:#666;margin-bottom:20px">
                        Aiutaci a migliorare! La tua opinione è anonima.
                    </p>
                    <div style="text-align:left;max-width:400px;margin:0 auto">` + corpoGrad + `</div>
                    <style>
                        .swal-stars { display:flex; gap:4px; }
                        .swal-star { font-size:28px; color:#ddd; cursor:pointer; transition:color 0.15s; user-select:none; }
                        .swal-star.active { color:#FFC107; }
                        .swal-star:hover { color:#FFD54F; }
                    </style>
                `,
                showCancelButton: true,
                confirmButtonColor: 'var(--mainColor)',
                cancelButtonColor: '#dadada',
                confirmButtonText: 'Invia',
                cancelButtonText: 'Salta',
                allowOutsideClick: false,
                allowEscapeKey: true,
                width: 520,
                didOpen: () => {
                    document.querySelectorAll('.swal-stars').forEach(group => {
                        group.querySelectorAll('.swal-star').forEach(star => {
                            star.addEventListener('click', (e: any) => {
                                let val = parseInt(e.target.getAttribute('data-value'));
                                group.querySelectorAll('.swal-star').forEach((s: any) => {
                                    if (parseInt(s.getAttribute('data-value')) <= val)
                                        s.classList.add('active');
                                    else
                                        s.classList.remove('active');
                                });
                            });
                        });
                    });
                },
                preConfirm: () => {
                    let risposte: any = {};
                    let mancanti = 0;
                    document.querySelectorAll('.swal-stars').forEach((group: any) => {
                        let voto = group.querySelectorAll('.swal-star.active').length;
                        if (voto == 0) mancanti++;
                        risposte[group.getAttribute('data-codice')] = voto;
                    });

                    if (mancanti > 0) {
                        Swal.showValidationMessage('Seleziona almeno una stella per ogni voce');
                        return false;
                    }

                    document.querySelectorAll('.swal-grad-testo').forEach((box: any) => {
                        risposte[box.getAttribute('data-codice')] = box.value || '';
                    });
                    return risposte;
                }
            }).then((result) => {
                if (result.isConfirmed && result.value) {
                    this.crudService.api_salvaGradimentoDomande(
                        idCorso, idPartner, idCorsista, result.value
                    ).subscribe(() => {
                        location.reload();
                    }, () => {
                        location.reload();
                    });
                } else {
                    // Corsista ha saltato: registra nel DB per non ripresentarlo
                    this.crudService.api_saltaGradimento(idCorso, idPartner, idCorsista).subscribe(() => {
                        location.reload();
                    }, () => {
                        location.reload();
                    });
                }
            });
    }, () => {
        // Errore API: ricarica la pagina per mostrare comunque lo stato aggiornato
        // (esame superato, eventuale attestato). Senza reload il corsista resta
        // bloccato sul vecchio stato senza capire cosa fare.
        location.reload();
    });
  }

  showQuestionarioGradimentoEcm(idCorso, idPartner) {
    let makeStarsRow = (field, label, desc) => `
        <div class="swal-grad-row" style="margin-bottom:14px">
            <label style="display:block;font-weight:600;margin-bottom:2px;font-size:14px">${label}</label>
            <span style="font-size:11px;color:#999;display:block;margin-bottom:6px">${desc}</span>
            <div class="swal-stars" data-field="${field}">
                <span class="swal-star" data-value="1">★</span>
                <span class="swal-star" data-value="2">★</span>
                <span class="swal-star" data-value="3">★</span>
                <span class="swal-star" data-value="4">★</span>
                <span class="swal-star" data-value="5">★</span>
            </div>
        </div>`;

    Swal.fire({
        title: 'Questionario di Gradimento ECM',
        html: `
            <p style="font-size:13px;color:#666;margin-bottom:16px">La tua opinione è anonima. Valuta ogni area da 1 a 5 stelle.</p>
            <div style="text-align:left;max-width:420px;margin:0 auto">
                ${makeStarsRow('rilevanza', 'Rilevanza', 'Pertinenza degli argomenti rispetto al tuo bisogno formativo')}
                ${makeStarsRow('qualita_educativa', 'Qualità educativa', 'Chiarezza dei contenuti e efficacia della metodologia didattica')}
                ${makeStarsRow('efficacia', 'Efficacia', 'Utilità per migliorare la tua pratica professionale')}
                ${makeStarsRow('organizzazione', 'Organizzazione', 'Qualità della piattaforma, supporto tecnico e materiali')}
                ${makeStarsRow('sponsorizzazione', 'Indipendenza da sponsor', 'Assenza di influenza commerciale sui contenuti formativi')}
                ${makeStarsRow('giudizio_complessivo', 'Giudizio complessivo', 'Valutazione globale dell\'evento formativo')}
                <div class="swal-grad-row">
                    <label style="display:block;font-weight:600;margin-bottom:6px;font-size:14px">Suggerimenti o commenti <span style="font-weight:400;color:#999">(opzionale)</span></label>
                    <textarea id="swal-gradimento-commento" rows="3" style="width:100%;border:1px solid #ddd;border-radius:8px;padding:10px;font-size:14px;resize:vertical" placeholder="Scrivi qui..."></textarea>
                </div>
            </div>
            <style>
                .swal-stars { display:flex; gap:4px; }
                .swal-star { font-size:26px; color:#ddd; cursor:pointer; transition:color 0.15s; user-select:none; }
                .swal-star.active { color:#FFC107; }
                .swal-star:hover { color:#FFD54F; }
            </style>
        `,
        showCancelButton: true,
        confirmButtonColor: 'var(--mainColor)',
        cancelButtonColor: '#dadada',
        confirmButtonText: 'Invia questionario',
        cancelButtonText: 'Salta',
        allowOutsideClick: false,
        allowEscapeKey: true,
        width: 560,
        didOpen: () => {
            document.querySelectorAll('.swal-stars').forEach(group => {
                group.querySelectorAll('.swal-star').forEach(star => {
                    star.addEventListener('click', (e: any) => {
                        let val = parseInt(e.target.getAttribute('data-value'));
                        group.querySelectorAll('.swal-star').forEach((s: any) => {
                            if (parseInt(s.getAttribute('data-value')) <= val)
                                s.classList.add('active');
                            else
                                s.classList.remove('active');
                        });
                    });
                });
            });
        },
        preConfirm: () => {
            let fields = ['rilevanza','qualita_educativa','efficacia','organizzazione','sponsorizzazione','giudizio_complessivo'];
            let values: any = {};
            let allFilled = true;
            fields.forEach(f => {
                values[f] = document.querySelectorAll('.swal-stars[data-field="' + f + '"] .swal-star.active').length;
                if (values[f] == 0) allFilled = false;
            });
            if (!allFilled) {
                Swal.showValidationMessage('Seleziona almeno una stella per ogni voce');
                return false;
            }
            values.commento = (document.getElementById('swal-gradimento-commento') as HTMLTextAreaElement).value || '';
            return values;
        }
    }).then((result) => {
        let idCorsistaEcm = this.detailUser ? this.detailUser['id_corsista'] : 0;
        if (result.isConfirmed && result.value) {
            let v = result.value;
            this.crudService.api_salvaGradimentoEcm(
                idCorso, idPartner, idCorsistaEcm,
                v.rilevanza, v.qualita_educativa, v.efficacia, v.organizzazione, v.sponsorizzazione, v.giudizio_complessivo, v.commento
            ).subscribe(() => {
                location.reload();
            }, () => {
                location.reload();
            });
        } else {
            // Corsista ha saltato: registra nel DB per non ripresentarlo
            this.crudService.api_saltaGradimentoEcm(idCorso, idPartner, idCorsistaEcm).subscribe(() => {
                location.reload();
            }, () => {
                location.reload();
            });
        }
    });
  }

  quizNonSuperato(risposteCorrette, risposteNonCorrette) {
    let msgExtra = '';
    let btnText = 'Riprova';
    if(this.isECM && this.ecmConfig) {
        let tentativiRimasti = this.ecmConfig.max_tentativi - this.ecmConfig.tentativi_usati;
        if(tentativiRimasti <= 0) {
            msgExtra = '\n\nHai esaurito i ' + this.ecmConfig.max_tentativi + ' tentativi disponibili per questo ciclo. Dovrai rivedere l\'intero corso prima di poter riprovare il test .';
            btnText = 'Torna al corso';
        } else {
            msgExtra = '\n\nTentativi rimasti: ' + tentativiRimasti + ' su ' + this.ecmConfig.max_tentativi + '.';
        }
    }
    Swal.fire({
        title:'Test Fallito!',
        text: 'non hai superato il test, hai sbagliato '+risposteNonCorrette+' risposte, hai risposto in modo esatto solo a '+risposteCorrette+' domande.' + msgExtra,
        icon: 'error',
        showCancelButton: false,
        confirmButtonColor: '#6993FF',
        cancelButtonColor: '#dadada',
        confirmButtonText: btnText,
        allowOutsideClick: false,
     }).then((result) => {
        if (result.isConfirmed) {
            location.reload();
        }
    });
  }

  quizNonCompleto() {
    Swal.fire({
        title:'Test Incompleto!',
        text: 'devi rispondere a tutte le domande, verifica',
        icon: 'error',
        showCancelButton: false,
        confirmButtonColor: '#6993FF',
        cancelButtonColor: '#dadada',
        confirmButtonText: 'Riprova',
        allowOutsideClick: false,
     }).then((result) => {
        if (result.isConfirmed) {

        }
    });
  }

  quizSuperatoValutazione(risposteCorrette, numeroTotaleDomande) {
    Swal.fire({
        title:'Complimenti!',
        text: 'hai superato il test di valutazione con il numero di '+risposteCorrette+' risposte corrette su un totale di '+numeroTotaleDomande+' domande',
        icon: 'success',
        showCancelButton: false,
        confirmButtonColor: '#6993FF',
        cancelButtonColor: '#dadada',
        confirmButtonText: 'Grazie',
        allowOutsideClick: false,
     }).then((result) => {
        if (result.isConfirmed) {
            // Chiudi SEMPRE il modal test valutazione dopo il "Grazie".
            // Se il questionario di gradimento non e' attivo/gia' compilato,
            // showQuestionarioGradimento fa early return senza chiudere il
            // modal → il corsista resta bloccato sul test superato.
            this.chiudiTestValutazione();
            this.showQuestionarioGradimento();
        }
    });
  }

sommaDurate(dad: string, fad: string): string {
    const parse = (s: string): number => {
        if (!s) return 0;
        let min = 0;
        const h = s.match(/(\d+)h/);
        const m = s.match(/(\d+)m/);
        if (h) min += parseInt(h[1]) * 60;
        if (m) min += parseInt(m[1]);
        return min;
    };
    const tot = parse(dad) + parse(fad);
    if (tot <= 0) return '';
    const h = Math.floor(tot / 60);
    const m = tot % 60;
    if (h > 0 && m > 0) return h + 'h ' + m + 'm';
    if (h > 0) return h + 'h';
    return m + 'm';
}

getEffectiveDuration(v: HTMLMediaElement): number {
  // Per live con duration = Infinity, usa l'estremo destro del range "seekable"
  // (è lo "spazio" di timeline effettivamente navigabile). :contentReference[oaicite:2]{index=2}
  if (v.duration === Infinity && v.seekable.length > 0) {
    return v.seekable.end(v.seekable.length - 1);
  }
  return v.duration; // può essere NaN finché non arrivano i metadati. :contentReference[oaicite:3]{index=3}
}

getRemainingSeconds(v: HTMLMediaElement): number | null {
  const dur = this.getEffectiveDuration(v);
  if (!Number.isFinite(dur)) return null;            // durata sconosciuta
  const raw = Math.max(0, dur - v.currentTime);      // secondi di media rimanenti
  // Se vuoi i secondi "di orologio" con velocità ≠ 1x:
  return raw / (v.playbackRate || 1);
}

updateRemaining(v: HTMLMediaElement) {
  const rem = this.getRemainingSeconds(v);
  if (rem == null) {
    //console.log("Durata sconosciuta (live senza seekable o metadati non pronti).");
  } else {
    const out   = document.getElementById("timeRestantePlayVideo") as HTMLSpanElement | null;
    out!.textContent = this.secondsToHms(Math.ceil(rem));
    console.log(this.secondsToHms(Math.ceil(rem)));
  }
}

  countTimer() {
    console.log(this.tempoTrascorso+"----"+this.isPauseVideo);

    var myVideo: any = document.getElementById("myVideo");
    if(myVideo==null)
        return;

    // Attendi i metadati per avere una duration valida
    if (Number.isNaN(myVideo.duration)) {
        myVideo.addEventListener("loadedmetadata", () => this.updateRemaining(myVideo), { once: true });
    } else {
        this.updateRemaining(myVideo);
    }


    if(myVideo.ended) {
        //conta l'ultimo tratto, fino alla fine del video
        this.tempoTrascorso+=this.secondiVideoVisti(myVideo);
        //cap: non superare la durata reale del video
        var maxDuration = Math.floor(myVideo.duration);
        if(this.tempoTrascorso > maxDuration)
            this.tempoTrascorso = maxDuration;
        clearInterval(this.timerHandle);
        this.videoEndedNaturally = true;
        setTimeout(() => {
            if(Swal.isVisible()) {
                Swal.clickConfirm();
            } else {
                this.chiudiVideo();
            }
        }, 250);
    }


    if (!myVideo.paused && !myVideo.ended) {
        var precedenteTempo=this.tempoTrascorso;
        var secondi=this.secondiVideoVisti(myVideo);
        //con il limite giornaliero non si conta oltre il tempo che resta
        if(parseFloat(this.arrayLive['limita_moduloUC_durata'])>0 && this.limiteGiorno>0 && this.tempoRestanteLimite>0)
            secondi=Math.min(secondi, this.tempoRestanteLimite);
        this.tempoTrascorso+=secondi;

        // Auto-save periodico ogni tempoAutoSaveVideo secondi
        this.tempoAutoSaveVideoCnt+=secondi;
        if(this.tempoAutoSaveVideoCnt >= this.tempoAutoSaveVideo && this.canSave) {
            this.tempoAutoSaveVideoCnt=0;
            this.salvaTempoVideoAutomatico();
        }

        // ECM Antifrode — ogni N minuti mostra domanda di verifica (non in consultazione)
        if(this.isECM && this.ecmConfig && this.ecmConfig.intervallo_antifrode > 0 && !this.isConsultazione) {
            this.ecmAntifrodeMinutiTrascorsi+=secondi;
            let intervalloSec = this.ecmConfig.intervallo_antifrode * 60;
            if(this.ecmAntifrodeMinutiTrascorsi >= intervalloSec) {
                this.ecmAntifrodeMinutiTrascorsi = 0;
                this.ecmMostraAntifrode(myVideo);
            }
        }

        if(parseFloat(this.arrayLive['limita_moduloUC_durata'])>0) {
            if(this.limiteGiorno>0) {
                if(precedenteTempo!=this.tempoTrascorso)
                    this.aggiornaTempoLimite(secondi);
            }
        }
    }
    else if(!myVideo.ended) {
        //in pausa: l'orologio riparte da qui quando il video riprende
        this.secondiVideoVisti(myVideo);
    }
 }

 // Secondi di video visti dall'ultimo scatto: quanto e' avanzato il video, mai piu' del
 // tempo reale passato (un salto in avanti conta solo il tempo davvero trascorso).
 // Se il browser fa scattare il timer una volta al minuto, qui arriva il minuto intero.
 secondiVideoVisti(myVideo): number {
    var o=this.orologioVideo;
    var ora=Date.now();
    var ct=myVideo.currentTime;
    if(o.ct===null || (myVideo.paused && !myVideo.ended)) {
        o.ct=ct; o.ora=ora;
        return 0;
    }
    var avanzato=ct-o.ct;
    var reale=(ora-o.ora)/1000;
    o.ct=ct; o.ora=ora;
    if(!(avanzato>0))
        return 0;
    var s=Math.min(avanzato, reale)+o.resto;
    var interi=Math.floor(s);
    o.resto=s-interi;
    return interi;
 }

 // Secondi interi di orologio reale passati dall'ultima chiamata con la stessa chiave
 secondiOrologio(chiave): number {
    var ora=Date.now();
    var o=this.orologi[chiave];
    if(!o) {
        this.orologi[chiave]={ora: ora, resto: 0};
        return 1;
    }
    var s=(ora-o.ora)/1000+o.resto;
    var interi=Math.floor(s);
    o.ora=ora;
    o.resto=s-interi;
    return interi;
 }

 countTimerNoLimite() {
    this.aggiornaTempoLimite(this.secondiOrologio('noLimite'));
 }

 confermaPresenza() {
    clearInterval(this.timerHandleControlloPresenza);
    this.timeControlloPresenza=60;

    this.showControlloPresenza=false;

    var now = new Date();
    var strDateTime = [[this.AddZero(now.getFullYear()),
        this.AddZero(now.getMonth() + 1),
        now.getDate()].join("-"),
        [this.AddZero(now.getHours()),
        this.AddZero(now.getMinutes()),
        this.AddZero(now.getSeconds())].join(":")].join(" ");

    this.salvaCheckTime(strDateTime, 1);
 }

 confermaAssenza() {
    clearInterval(this.timerHandleControlloPresenza);
    this.timeControlloPresenza=60;

    this.showControlloPresenza=false;

    var now = new Date();
    var strDateTime = [[this.AddZero(now.getFullYear()),
        this.AddZero(now.getMonth() + 1),
        now.getDate()].join("-"),
        [this.AddZero(now.getHours()),
        this.AddZero(now.getMinutes()),
        this.AddZero(now.getSeconds())].join(":")].join(" ");

    this.salvaCheckTime(strDateTime, 0);
 }


 countDownTimeConfermaPresenza() {
    if(this.timeControlloPresenza>=0) {
        document.getElementById('secondiPresenza').innerText=this.timeControlloPresenza.toString();
        this.timeControlloPresenza--;
    }
    else {
        clearInterval(this.timerHandleControlloPresenza);
        this.timeControlloPresenza=60;

        this.confermaAssenza();
    }

 }

 showTimecheck() {
    let timerInterval;

    var now = new Date();
    var strDateTime = [[this.AddZero(now.getFullYear()),
        this.AddZero(now.getMonth() + 1),
        now.getDate()].join("-"),
        [this.AddZero(now.getHours()),
        this.AddZero(now.getMinutes()),
        this.AddZero(now.getSeconds())].join(":")].join(" ");

    Swal.fire({
        allowOutsideClick: false,
        title: 'Controllo presenza',
        icon: 'warning',
        html: 'clicca sul pulsante <span class="fw-bolder">"Si, sono presente!"</span> per conferma che sei presente online.<br>Tempo residuo <b></b> secondi',
        timer: 60000,
        timerProgressBar: true,
        showCancelButton: false,
        confirmButtonText: 'Si, sono presente!',
        cancelButtonText: 'No, cancel!',
        confirmButtonColor: 'var(--mainColor)',
        didOpen: () => {
            clearInterval(this.timerHandleCheck);
            this.timerHandleCheck = null;
            window.focus();

            const b = Swal.getHtmlContainer().querySelector('b');
            timerInterval = setInterval(() => {
              b.textContent = parseInt((Swal.getTimerLeft()/1000).toFixed(0)).toString();
            }, 100)
        },
        willClose: () => {
            clearInterval(timerInterval);
        }
    }).then((result) => {
        if (result.isConfirmed) {
            //sono presente
            this.salvaCheckTime(strDateTime, 1);
        }
        if (result.dismiss === Swal.DismissReason.timer) {
            //tempo check scaduto
            this.salvaCheckTime(strDateTime, 0);
        }
    })
 }


 salvaCheckTime(dateTimeInizio, isPresent) {
    var now = new Date();
    var strDateTime = [[this.AddZero(now.getFullYear()),
        this.AddZero(now.getMonth() + 1),
        now.getDate()].join("-"),
        [this.AddZero(now.getHours()),
        this.AddZero(now.getMinutes()),
        this.AddZero(now.getSeconds())].join(":")].join(" ");

    let idCorsoSvolgimento=(this.arrayLive['id_corso_svolgimento']);
    let idCorsista=this.detailUser['id_corsista'];

    //controllo se si tratta di una DAD o FAD
    if(isPresent==0 && (this.arrayLive['limita_moduloUC']==0)) {
        //essendo una DAD chiudo la connessione e butto fuori il corsista dall'aula
        this.chiudiMeetFromTimeCheck();
    }
    else {
        //essendo una FAD mi registro il tempo di inattività
        this.crudService.salvaCheckTime(dateTimeInizio, strDateTime, isPresent, idCorsoSvolgimento, idCorsista, this.idCorsoGlobal, (this.timeCheckBackup/60)).subscribe(product => {
            //se non è PRESENTE ma ha il video APERTO chiudo il video e mi salvo INATTIVITA'
            if (document.getElementById('myVideo') && isPresent==0) {
                this.chiudiVideo();
            }
            else {
                //se è PRESENTE mi registro la presenza
                clearInterval(this.timerHandleCheck);
                this.timeCheck=this.timeCheckBackup;
                this.timerHandleCheck = null;

                this.checkIsActiveTimeInattivo();
            }
        });
    }
 }

 chiudiMeetFromTimeCheck() {
    let idCorsoSvolgimento=(this.arrayLive['id_corso_svolgimento']);
    let idCorsista=this.detailUser['id_corsista'];

    // Ferma tutti i timer per evitare zombie
    clearInterval(this.timerHandle);
    clearInterval(this.timerHandleCheck);
    clearInterval(this.timerHandleEsaminatore);
    clearInterval(this.timerHandleControlloPresenza);
    this.timerHandle = null;
    this.timerHandleCheck = null;
    this.timerHandleEsaminatore = null;
    this.timerHandleControlloPresenza = null;

    if(idCorsista!="" && idCorsoSvolgimento!="") {
        this.crudService.api_setTImeoutCorsista(idCorsista, idCorsoSvolgimento, 0).subscribe(productData => {
            this.showMeet=false;
            setTimeout(() => {
                Swal.fire({
                    title:'Connessione interrotta',
                    text: 'per eccesso inattività di tempo la connessione è stata interrotta.',
                    icon: 'warning',
                    showCancelButton: false,
                    confirmButtonColor: '#6993FF',
                    cancelButtonColor: '#dadada',
                    confirmButtonText: 'Ok',
                    allowOutsideClick: false,
                 }).then((result) => {
                    if (result.isConfirmed) {
                        location.reload();
                    }
                });
            }, 1000);
        },(err)=>{
            console.error('chiudiMeetFromTimeCheck error:', err);
        });
    }
 }

 AddZero(num) {
    return (num >= 0 && num < 10) ? "0" + num : num + "";
}

 countTimeCheck() {
    console.log("TimeCheck:"+this.timeCheck);
    //console.log(this.arrayLive);

    if(this.timeCheck<=1) {
        clearInterval(this.timerHandleCheck);
        if(this.arrayLive['limita_moduloUC']==1) {
            this.showControlloPresenza=true;
            this.timerHandleControlloPresenza=setInterval(() => {
                this.countDownTimeConfermaPresenza();
            }, 1000);
        }
        else {
            this.showTimecheck();
        }
    }
    this.timeCheck-=1;
 }

 countTimerAula() {
    if(this.limiteGiornoAula>0) {
        this.aggiornaTempoLimiteAula();
    }
 }

  startTimer(idCorso, idPartner, id_modulo_body, id_modulo_body_paragrafo, canShow) {
    this.arraySaveDatiUC_Tempo['idCorso']=idCorso;
    this.arraySaveDatiUC_Tempo['idPartner']=this.schedaCorsistaGlobal['id_partner'];
    this.arraySaveDatiUC_Tempo['idModuloBody']=id_modulo_body;
    this.arraySaveDatiUC_Tempo['idModuloBodyParagrafo']=id_modulo_body_paragrafo;
    this.arraySaveDatiUC_Tempo['idCorsista']=this.detailUser['id_corsista'];

    this.orologioVideo={ct: null, ora: 0, resto: 0};
    this.timerHandle=setInterval(() => {
        this.countTimer();
    }, 1000);

    this.initVideoPlayer(canShow);
  }

  showToast(message) {
    var toast = document.createElement('div');
    toast.textContent = message;
    toast.style.cssText = 'position:fixed;top:20px;right:20px;z-index:99999;background:var(--mainColor);color:#fff;padding:12px 24px;border-radius:8px;font-size:14px;font-weight:500;box-shadow:0 4px 12px rgba(0,0,0,.15);opacity:0;transition:opacity .3s';
    document.body.appendChild(toast);
    setTimeout(() => { toast.style.opacity = '1'; }, 50);
    setTimeout(() => {
        toast.style.opacity = '0';
        setTimeout(() => { toast.remove(); }, 300);
    }, 10000);
  }

  // Avviso quando il corsista prova ad aprire un contenuto in stato
  // "attesa esame finale" (tutti i moduli completi ma esame non ancora superato).
  // I moduli sono bloccati per forzare il sostenimento dell'esame.
  mostraAvvisoAttesaEsameFinale() {
    Swal.fire({
        title: 'Esame finale da sostenere',
        html: '<div style="font-size:14px;line-height:1.5">' +
              'Hai completato tutti i contenuti del corso. ' +
              'Per concludere il percorso devi sostenere l\'<b>esame finale</b>.<br><br>' +
              'I moduli e i contenuti sono temporaneamente bloccati: ' +
              'una volta superato l\'esame potrai rivedere liberamente il materiale.' +
              '</div>',
        icon: 'warning',
        confirmButtonColor: '#6993FF',
        confirmButtonText: 'Vai all\'esame finale',
        allowOutsideClick: false,
    });
  }

  // Avviso esplicito per il corsista in modalita' consultazione (corso al 100%).
  // Why: senza questo, i corsisti che rivedono i contenuti dopo il completamento
  // pensano che il sistema "non funzioni" perche' il tempo non si aggiorna
  // (mentre invece e' by-design: il corso e' gia' completato).
  // Banner top-center NON modale (non blocca il player), con dismiss button +
  // auto-close 15s. Coesiste con il Swal del player aperto sotto.
  mostraAvvisoConsultazione() {
    var existing = document.getElementById('consultazioneNoticeBanner');
    if (existing) return; // non duplichiamo se gia' visibile
    var banner = document.createElement('div');
    banner.id = 'consultazioneNoticeBanner';
    banner.style.cssText = 'position:fixed;top:20px;left:50%;transform:translateX(-50%);z-index:99999;' +
        'background:#6993FF;color:#fff;padding:14px 22px;border-radius:10px;' +
        'font-size:14px;font-weight:500;line-height:1.5;max-width:560px;' +
        'box-shadow:0 8px 24px rgba(0,0,0,.25);display:flex;align-items:flex-start;gap:14px;' +
        'opacity:0;transition:opacity .3s';
    // Always-FAD: banner dedicato (l'esito test non viene salvato, ma il test parte)
    // Real consultazione: corso davvero completato + bloccoCorsoFULL
    var bannerTitle, bannerText;
    if (this.isAlwaysFadMode) {
        bannerTitle = 'Modalit&agrave; always-FAD';
        bannerText = 'Stai eseguendo in modalit&agrave; always-FAD, <b>l\'esito non verr&agrave; registrato</b>.';
    } else {
        bannerTitle = 'Corso gi&agrave; completato';
        bannerText = 'Puoi rivedere liberamente i contenuti, ma il tempo di visualizzazione <b>non viene pi&ugrave; tracciato</b> perch&eacute; hai gi&agrave; raggiunto il 100% di fruizione.';
    }
    banner.innerHTML =
        '<i class="fa fa-info-circle" style="font-size:20px;margin-top:1px;flex-shrink:0"></i>' +
        '<div style="flex:1">' +
        '<div style="font-weight:700;margin-bottom:4px">' + bannerTitle + '</div>' +
        '<div style="font-weight:400">' + bannerText + '</div>' +
        '</div>' +
        '<span id="consultazioneNoticeClose" style="cursor:pointer;font-size:18px;line-height:1;opacity:.8;flex-shrink:0">&times;</span>';
    document.body.appendChild(banner);
    setTimeout(() => { banner.style.opacity = '1'; }, 50);
    var closeFn = () => {
        banner.style.opacity = '0';
        setTimeout(() => { if (banner.parentNode) banner.remove(); }, 300);
    };
    var closeBtn = document.getElementById('consultazioneNoticeClose');
    if (closeBtn) closeBtn.addEventListener('click', closeFn);
    setTimeout(closeFn, 15000);
  }

  // ============================
  // ECM — Metodi
  // ============================

  // Antifrode: pausa video e mostra domanda
  ecmMostraAntifrode(videoElement) {
    if(!videoElement) return;
    // Consultazione: nessuna verifica antifrode
    if(this.isConsultazione) return;

    videoElement.pause();
    let minuteCorso = Math.floor(this.tempoTrascorso / 60);
    let idCorso = this.arraySaveDatiUC_Tempo['idCorso'];
    let idPartner = this.arraySaveDatiUC_Tempo['idPartner'];
    let idCorsista = this.detailUser['id_corsista'];

    this.crudService.api_getEcmAntifrodeQuestion(idCorso, idPartner).subscribe((resp: any) => {
        if(resp.success != 1) {
            videoElement.play();
            return;
        }
        let risposte = resp.risposte;
        let htmlRisposte = risposte.map((r, i) =>
            '<label class="d-block text-left p-2 mb-2 rounded" style="border:1px solid #E4E6EF;cursor:pointer">' +
            '<input type="radio" name="ecmAntifrode" value="'+i+'" class="mr-2">'+r+'</label>'
        ).join('');

        Swal.fire({
            title: 'Verifica presenza ECM',
            html: '<p class="text-muted mb-4">Rispondi correttamente per continuare la fruizione del corso.</p>' +
                  '<p class="font-weight-bold mb-3" style="font-size:15px">'+resp.domanda+'</p>' +
                  '<div id="ecmAntifrodeRisposte">'+htmlRisposte+'</div>',
            icon: 'question',
            confirmButtonText: 'Conferma',
            allowOutsideClick: false,
            allowEscapeKey: false,
            showCancelButton: false,
            preConfirm: () => {
                let selected = document.querySelector('input[name="ecmAntifrode"]:checked') as HTMLInputElement;
                if(!selected) {
                    Swal.showValidationMessage('Seleziona una risposta');
                    return false;
                }
                return risposte[parseInt(selected.value)];
            }
        }).then((result) => {
            if(result.isConfirmed) {
                let rispostaData = result.value;
                let esito = (rispostaData == resp.corretta) ? 1 : 0;
                // Log risposta
                this.crudService.api_logEcmAntifrode(idCorsista, idCorso, idPartner, resp.id_domanda, rispostaData, esito, minuteCorso).subscribe(() => {});

                if(esito == 1) {
                    videoElement.play();
                } else {
                    Swal.fire({
                        title: 'Risposta errata',
                        text: 'La risposta non e\' corretta. Riprova con attenzione.',
                        icon: 'error',
                        confirmButtonText: 'Riprova',
                        allowOutsideClick: false
                    }).then(() => {
                        this.ecmMostraAntifrode(videoElement);
                    });
                }
            }
        });
    });
  }

  // ECM — Registra tentativo test e gestisci logica
  ecmRegistraTentativo(corrette, totali, superato) {
    if(this.isConsultazione) return;
    let idCorsista = this.detailUser['id_corsista'];
    let idCorso = this.arraySaveDatiUC_Tempo['idCorso'] || this.idCorsoGlobal;
    let idPartner = this.arraySaveDatiUC_Tempo['idPartner'] || this.schedaCorsistaGlobal['id_partner'];
    let punteggio = totali > 0 ? Math.round((corrette / totali) * 100) : 0;

    this.crudService.api_registraEcmTentativo(idCorsista, idCorso, idPartner, punteggio, corrette, totali, superato).subscribe((resp: any) => {
        if(superato == 1) {
            this.ecmConfig.test_superato = 1;
            this.ecmConfig.tentativi_usati = resp.numero_tentativo;
            // Assegna crediti subito dopo il superamento del test
            this.ecmAssegnaCrediti();
        } else {
            this.ecmConfig.tentativi_usati = resp.numero_tentativo;
            // Solo se i tentativi sono esauriti → deve revisionare
            if(this.ecmConfig.max_tentativi > 0 && resp.numero_tentativo >= this.ecmConfig.max_tentativi) {
                this.ecmConfig.deve_revisionare = 1;
            }
        }
    });
  }

  // ECM — Assegna crediti dopo gradimento
  ecmAssegnaCrediti() {
    if(this.isConsultazione) return;
    let idCorsista = this.detailUser['id_corsista'];
    let idCorso = this.arraySaveDatiUC_Tempo['idCorso'] || this.idCorsoGlobal;
    let idPartner = this.arraySaveDatiUC_Tempo['idPartner'] || this.schedaCorsistaGlobal['id_partner'];

    this.crudService.api_assegnaEcmCrediti(idCorsista, idCorso, idPartner).subscribe((resp: any) => {
        if(resp.success == 1) {
            this.ecmConfig.crediti_assegnati = 1;
        }
    });
  }

  // ECM — Segna corso revisionato (chiamato quando il corsista rivede i contenuti dopo fallimento)
  ecmSetRevisionato() {
    // Consultazione: non registrare revisione
    if(this.isConsultazione) return;

    let idCorsista = this.detailUser['id_corsista'];
    let idCorso = this.arraySaveDatiUC_Tempo['idCorso'] || this.idCorsoGlobal;
    let idPartner = this.arraySaveDatiUC_Tempo['idPartner'] || this.schedaCorsistaGlobal['id_partner'];

    this.crudService.api_ecmSetRevisionato(idCorsista, idCorso, idPartner).subscribe(() => {
        this.ecmConfig.deve_revisionare = 0;
    });
  }

  secondsToHms(d) {
    d = Number(d);
    var h = Math.floor(d / 3600);
    var m = Math.floor((d / 60) % 60);
    var s = (d % 60);

    var hDisplay = h > 0 ? h + (h == 1 ? "h " : "h ") : "";
    var mDisplay = m > 0 ? m + (m == 1 ? "m " : "m ") : "";
    var sDisplay = s > 0 ? s + (s == 1 ? "s " : "s") : "";
    return hDisplay + mDisplay + sDisplay;
}

  ecmFormatSec(sec) {
    sec = Number(sec) || 0;
    let m = Math.floor(sec / 60);
    let s = sec % 60;
    return m + ':' + (s < 10 ? '0' : '') + s;
  }

  secondToMinute(duration) {
    // Hours, minutes and seconds
    var hrs = ~~(duration / 3600);
    var mins = ~~((duration % 3600) / 60);
    var secs = ~~duration % 60;

    // Output like "1:01" or "4:03:59" or "123:03:59"
    var ret = "";

    if (hrs > 0) {
        //ret += "" + hrs + ":" + (mins < 10 ? "0" : "");
        mins=(hrs*60)+mins;
    }

    ret += "" + mins + "." + (secs < 10 ? "0" : "");
    ret += "" + secs;
    return ret;
}

  playVideo(videoFile, titolo, idCorso, idPartner, id_modulo_body, id_modulo_body_paragrafo, minuteStart, tempoRestante, isLocked, forceRestart = false) {
    //console.log((parseFloat(minuteStart)+(this.tempoTrascorso/100)));
    //minuteStart=Math.round(((parseFloat(minuteStart)+(this.tempoTrascorso/100)))).toFixed(2).toString();

    if(this.isPlayVideo==true)
        return;

    // Avviso preventivo: il corso e' al 100% → tempo non tracciato.
    if(this.isConsultazione) this.mostraAvvisoConsultazione();

    this.isPlayVideo=true;
    this.tempoTrascorso=0;
    this.tempoAutoSaveVideoCnt=0;

    //mi recupero ID_PARTNER associato al corsista (per la gestione dei sotto-partner)
    if(this.schedaCorsistaGlobal['id_partner']>0) {
        idPartner=this.schedaCorsistaGlobal['id_partner'];
    }

    //mi prelevo id_corso_svolgimento per capire se visualizzare o no la barra per tornare indietro il video
    //setting da parte dell'utente
    let idCorsoSvolgimento=this.arrayLive['id_corso_svolgimento'];

    //controllo se la sessione è terminata, se la pagina non è andata in risparmio energetico
    //se la sessione è terminata chiudo la sessione

    this.crudService.checkIfSessioneIsTerminata(idCorsoSvolgimento).subscribe(timeRestante => {
        if(this.arrayLive.isLive==1 && !this.isConsultazione) {
            this.tempoRestanteSessione=parseInt(timeRestante.toString());

            if(parseInt(timeRestante.toString())<=0) {
                this.limiteRaggiunto(1);
                return;
            }
        }

        this.crudService.resetTimeFadEveryDays(idCorsoSvolgimento).subscribe(resetTimeFadEveryDays => {
        if(resetTimeFadEveryDays==0)
                this.reportForData=0;

        this.crudService.canShowBarraVideo(idCorsoSvolgimento).subscribe(canShow => {
            //console.log(idCorsoSvolgimento+"---"+canShow);

            this.crudService.getTimeVideoVisualizzato(this.detailUser['id_corsista'], idCorso, idPartner, id_modulo_body, id_modulo_body_paragrafo, this.reportForData).subscribe(responseData => {

                // ECM revisione: se deve_revisionare=1, leggo il progresso dalla tabella revisione
                // e uso quello come punto di partenza (sovrascrive responseData)
                if(this.isECM && this.ecmConfig && this.ecmConfig.deve_revisionare == 1) {
                    let idCorsRev = this.detailUser['id_corsista'];
                    let idCorsoRev = this.arraySaveDatiUC_Tempo['idCorso'] || this.idCorsoGlobal;
                    let idPartnerRev = this.schedaCorsistaGlobal['id_partner'] || idPartner;
                    this.crudService.api_ecmGetProgressoRevisione(idCorsRev, idCorsoRev, idPartnerRev, id_modulo_body_paragrafo).subscribe((respRev: any) => {
                        if(respRev && respRev.tempoSecondi > 0) {
                            // Converti secondi in formato MM.SS per compatibilità
                            let minRev = Math.floor(respRev.tempoSecondi / 60);
                            let secRev = respRev.tempoSecondi % 60;
                            responseData = minRev + '.' + (secRev < 10 ? '0' : '') + secRev;
                        } else {
                            responseData = '0';
                        }
                        this.ecmRevisionePlayVideoResumePoint = respRev ? respRev.tempoSecondi : 0;
                        this._continuePlayVideo(responseData, videoFile, titolo, idCorso, idPartner, id_modulo_body, id_modulo_body_paragrafo, tempoRestante, isLocked, forceRestart, canShow, resetTimeFadEveryDays);
                    });
                    return; // esce dal subscribe, la continuazione è nel callback sopra
                }

                // Flusso normale (ECM=0 o deve_revisionare=0): prosegui direttamente
                this._continuePlayVideo(responseData, videoFile, titolo, idCorso, idPartner, id_modulo_body, id_modulo_body_paragrafo, tempoRestante, isLocked, forceRestart, canShow, resetTimeFadEveryDays);
            });

        });
    });
    });



  }

  _continuePlayVideo(responseData, videoFile, titolo, idCorso, idPartner, id_modulo_body, id_modulo_body_paragrafo, tempoRestante, isLocked, forceRestart, canShow, resetTimeFadEveryDays) {
                //controllo se è attivo il TIME CHECK attivo il timer
                this.timeCheck = (this.timeCheckBackup > 0) ? this.timeCheckBackup : this.timeCheck;
                this.checkIsActiveTimeInattivo();

                //converto tempoRestante MM.SS in secondi (parso stringa senza parseFloat per preservare zeri finali)
                var tempoRestanteSecondi=0;
                var strTempoRestante=tempoRestante.toString();
                if(strTempoRestante!="0" && strTempoRestante!="") {
                    var ar=strTempoRestante.split(".");
                    if(ar.length) {
                        var minuti=parseInt(ar[0]) || 0;
                        var secondi=(ar.length>1) ? parseInt(ar[1]) : 0;
                        tempoRestanteSecondi=(minuti*60)+secondi;
                    }
                }

                //converto minuteStart MM.SS in secondi (tempo già visualizzato)
                var strMinuteStart=responseData.toString();
                var minuteStartSec=0;
                var arStart=strMinuteStart.split(".");
                if(arStart.length) {
                    var minStart=parseInt(arStart[0]) || 0;
                    var secStart=(arStart.length>1) ? parseInt(arStart[1]) : 0;
                    minuteStartSec=(minStart*60)+secStart;
                }

                if(minuteStartSec>=tempoRestanteSecondi && tempoRestanteSecondi>0) {
                    // Consultazione: riparti da 0 senza chiedere conferma
                    if(this.isConsultazione) {
                        minuteStartSec=0;
                    }
                    // ECM revisione: se completato questo video, mostra messaggio diverso
                    else if(this.isECM && this.ecmConfig && this.ecmConfig.deve_revisionare == 1) {
                        if(!forceRestart) {
                            this.isPlayVideo=false;
                            Swal.fire({
                                title:'Revisione completata',
                                text: 'Hai già rivisto questo contenuto per intero. Prosegui con gli altri contenuti da revisionare.',
                                icon: 'success',
                                confirmButtonColor: '#6993FF',
                                confirmButtonText: 'OK',
                                allowOutsideClick: false,
                            });
                            return;
                        }
                        minuteStartSec=0;
                    }
                    else if(!forceRestart) {
                        this.isPlayVideo=false;
                        Swal.fire({
                            title:'Visualizzazione completata',
                            text: 'Hai già visualizzato questo video per intero. Vuoi rivederlo dall\'inizio?',
                            icon: 'info',
                            showCancelButton: true,
                            confirmButtonColor: '#6993FF',
                            cancelButtonColor: '#dadada',
                            confirmButtonText: 'Rivedi dall\'inizio',
                            cancelButtonText: 'Torna al corso',
                            allowOutsideClick: false,
                        }).then((result) => {
                            if (result.isConfirmed) {
                                this.playVideo(videoFile, titolo, idCorso, idPartner, id_modulo_body, id_modulo_body_paragrafo, '0', tempoRestante, isLocked, true);
                            }
                        });
                        return;
                    }
                    minuteStartSec=0;
                }

                videoFile=videoFile.trim();
                this.entraInAula();

                //imposto il tempo iniziale da dove ho lasciato quando il video corso è stato chiuso
                this.timeStartVideo=minuteStartSec;
                //console.log("K."+this.timeStartVideo);

                var canShowBarra='none';
                if(canShow==1 || (this.canShowProgressPlayer==true) || this.isConsultazione) {
                    canShowBarra='';
                }
                // ECM revisione: nasconde la barra (il corsista deve rivedere tutto senza saltare)
                if(this.isECM && this.ecmConfig && this.ecmConfig.deve_revisionare == 1) {
                    canShowBarra='none';
                }
                // ECM completato (crediti assegnati): mostra la barra per consultazione libera
                if(this.isECM && this.ecmConfig && this.ecmConfig.crediti_assegnati == 1) {
                    canShowBarra='';
                }

                var logoExtraFondo="";
                if(this.logoFondo!="") {
                    logoExtraFondo='<img style="max-height:80px; max-width:600px; margin-left:15px" src="'+this.logoFondo+'">';
                }

                var lblTimeRestante="";
                // ECM revisione: mostra etichetta "Revisione obbligatoria"
                if(this.isECM && this.ecmConfig && this.ecmConfig.deve_revisionare == 1) {
                    lblTimeRestante='<div class="">\
                                    <span class="text-warning" style="font-weight: normal; font-size:10pt">\
                                    <i class="fas fa-redo mr-1"></i>\
                                    Revisione obbligatoria — Tempo rimasto: <span id="timeRestantePlayVideo" style="font-weight:bolder">'+this.secondsToHms(tempoRestanteSecondi-minuteStartSec)+'</span>\
                                    </span>\
                                </div>';
                } else {
                    lblTimeRestante='<div class="">\
                                    <span class="text-danger" style="font-weight: normal; font-size:10pt">\
                                    <i class="fa fa-clock-o" aria-hidden="true"></i>\
                                    Tempo visualizzazione rimasto: <span id="timeRestantePlayVideo" style="font-weight:bolder">'+this.secondsToHms(tempoRestanteSecondi-minuteStartSec)+'</span>\
                                    </span>\
                                </div>';
                }

                //richiedo un token firmato per lo streaming video protetto
                var relativeVideoPath = videoFile.replace(this.urlVideoCorso, '');
                this.crudService.getVideoToken(relativeVideoPath).subscribe(token => {
                    var streamUrl = environment.web_api_url_base.replace('/api/', '/pages/stream_video.php') + '?t=' + encodeURIComponent(token.toString());

                    Swal.fire({
                        html: '<img style="max-height:100px" src="'+this.logoPartner+'">'+logoExtraFondo+'<br><hr>\
                                <span style="font-weight:800; font-size:18px; color:var(--blackColor)">'+titolo+lblTimeRestante+'</span>\
                               <video #myVideo height="419px" width="100%" style="margin-top:15px;" oncontextmenu="return false;" id="myVideo" autoplay playsinline controls controlsList="nodownload noplaybackrate" src="'+streamUrl+'#t='+(this.timeStartVideo)+'">\
                               </video>\
                               <style>\
                                video::-webkit-media-controls-timeline { display: '+canShowBarra+' !important; }\
                               </style>',
                        width: '800px',
                        heightAuto: false,
                        showCancelButton: false,
                        confirmButtonColor: '#6993FF',
                        cancelButtonColor: '#dadada',
                        confirmButtonText: 'Salva e ritorna al corso',
                        allowOutsideClick: false,
                    }).then((result) => {

                        if (result.isConfirmed) {
                            clearInterval(this.timerHandle);
                            this.chiudiVideo();
                        }
                    });

                    setTimeout(() => {
                        //avvio il timer
                        this.startTimer(idCorso, idPartner, id_modulo_body, id_modulo_body_paragrafo, canShow);
                    }, 250);
                });
  }

  playVideoLive(titolo, videoFile) {
    var relativeVideoPath = videoFile.replace(this.urlVideoCorso, '');
    this.crudService.getVideoToken(relativeVideoPath).subscribe(token => {
        var streamUrl = environment.web_api_url_base.replace('/api/', '/pages/stream_video.php') + '?t=' + encodeURIComponent(token.toString());

        Swal.fire({
            html: '<span style="font-weight:800; font-size:18px; color:var(--blackColor)">'+titolo+'</span>\
                   <video #myVideo height="419px" width="100%" style="margin-top:15px;" oncontextmenu="return false;" id="myVideo" autoplay playsinline controls controlsList="nodownload noplaybackrate" src="'+streamUrl+'#t='+(this.timeStartVideo)+'"></video>',
            width: '800px',
            heightAuto: false,
            showCancelButton: false,
            confirmButtonColor: '#6993FF',
            cancelButtonColor: '#dadada',
            confirmButtonText: 'Chiudi',
            allowOutsideClick: false,
        }).then((result) => {
            if (result.isConfirmed) {
            }
        });
    });
  }

  openRoom() {
   this.showMeet=true;
  }

  initVideoPlayer(canShow) {
    var myVideo: any = document.getElementById("myVideo");

    var supposedCurrentTime = 0;
    myVideo.addEventListener('timeupdate', function() {
        if (!myVideo.seeking) {
            supposedCurrentTime = myVideo.currentTime;
        }
    });

    myVideo.addEventListener('pause', function() {
        console.log("pause");
    });

    myVideo.addEventListener('playing', () => {
        console.log("play");
        //l'orologio del video parte dal primo fotogramma, non dal primo scatto del timer
        if(this.orologioVideo.ct===null) {
            this.orologioVideo.ct=myVideo.currentTime;
            this.orologioVideo.ora=Date.now();
        }
    });

    //myVideo.currentTime = 50;
    myVideo.removeEventListener('seeking', this.onSeeking());

    if(canShow==0) {
        //alert(canShow);
        myVideo.addEventListener('loadedmetadata', () => {
            setTimeout(() => {
                myVideo.addEventListener('seeking', function() {
                    // guard agains infinite recursion:
                    // user seeks, seeking is fired, currentTime is modified, seeking is fired, current time is modified, ....
                    var delta = myVideo.currentTime - supposedCurrentTime;
                    // delta = Math.abs(delta); // disable seeking previous content if you want
                    if (delta > 0.01) {
                        myVideo.currentTime = supposedCurrentTime;
                    }
                    else if(delta < 0) {
                        myVideo.currentTime = supposedCurrentTime;
                    }
                });
            }, 1000);
        }, 5000);
    }
  }

  onSeeking () {

  }

  dettaglioConnessioniVideo(idCorso, idCorsoSvolgimento, data, idCorsista) {
    if(!idCorso || !idCorsista || !data)
        return;

    var arrayDetail={'idCorso': idCorso, 'idCorsista': idCorsista, 'dataDay': data};

    this.crudService.api_getDetailTempoConnessioneDay(arrayDetail).subscribe(responseData => {
        var arrayData: any=[];
        this.arrayConnessioniVideo.splice(0);
        arrayData=responseData;
        arrayData.forEach(element => {
            this.arrayConnessioniVideo.push({'titoloUC': element['titoloUC'], 'paragrafo': element['paragrafo'], 'titolo': element['titolo'], 'durata': element['durataFormattata']});
        });

        this.showDetailVideoConnessioni(this.arrayConnessioniVideo, idCorsoSvolgimento);
    });
  }

  hasFiles(row: any): boolean {
    return row.files && Object.keys(row.files).length > 0;
  }

  chiudiVideo(isChiusuraAutomaticaParam: boolean = null) {
    console.log("-----chiudi video-----");
    this.isPlayVideo=false;
    clearInterval(this.timerHandleCheck);
    clearInterval(this.timerHandle);

    this.timeCheck=this.timeCheckBackup;
    this.timerHandleCheck = null;

    //se il parametro è passato (retry), uso quello; altrimenti leggo la sentinella
    var isChiusuraAutomatica = (isChiusuraAutomaticaParam !== null) ? isChiusuraAutomaticaParam : this.sentinellaOutFinestra;
    this.sentinellaOutFinestra=false;

    if(this.tempoTrascorso<=0)
        return;

    // Consultazione: non salvare tempo video nel DB
    if(this.isConsultazione) {
        console.log("CONSULTAZIONE: chiudiVideo senza salvataggio DB");
        // Promemoria al corsista: ribadisco perche' il tempo non e' stato salvato
        // (in alcuni casi il banner iniziale puo' essere stato dismissed o non visto).
        this.mostraAvvisoConsultazione();
        this.tempoTrascorso=0;
        this.tempoAutoSaveVideoCnt=0;
        return;
    }

    //se un auto-save è in volo, aspetto che finisca prima di salvare il tempo finale
    if(!this.canSave) {
        setTimeout(() => this.chiudiVideo(isChiusuraAutomatica), 500);
        return;
    }

    // ECM revisione: salvo nella tabella revisione separata, NON nel report normale
    if(this.isECM && this.ecmConfig && this.ecmConfig.deve_revisionare == 1) {
        let idCorsRev = this.detailUser['id_corsista'];
        let idCorsoRev = this.arraySaveDatiUC_Tempo['idCorso'] || this.idCorsoGlobal;
        let idPartnerRev = this.schedaCorsistaGlobal['id_partner'];
        let idParRev = this.arraySaveDatiUC_Tempo['idModuloBodyParagrafo'];
        // Il tempo da salvare è il resume point + il tempo trascorso in questa sessione
        let tempoTotaleRevisione = this.ecmRevisionePlayVideoResumePoint + this.tempoTrascorso;

        this.crudService.api_ecmSalvaProgressoRevisione(idCorsRev, idCorsoRev, idPartnerRev, idParRev, tempoTotaleRevisione).subscribe((resp: any) => {
            this.tempoTrascorso=0;
            this.tempoAutoSaveVideoCnt=0;

            // Aggiorna la mappa revisione locale per aggiornamento badge in tempo reale
            this.crudService.api_ecmGetProgressoRevisioneAll(idCorsRev, idCorsoRev, idPartnerRev).subscribe((respMap: any) => {
                if(respMap && respMap.mappa) {
                    this.ecmRevisioneMap = respMap.mappa;
                }
            });

            // Controlla se TUTTI i contenuti sono stati revisionati
            this.crudService.api_ecmCheckRevisioneCompleta(idCorsRev, idCorsoRev, idPartnerRev).subscribe((respCheck: any) => {
                if(respCheck && respCheck.completo == 1) {
                    // Revisione completata: chiama ecmSetRevisionato per sbloccare i test
                    this.crudService.api_ecmSetRevisionato(idCorsRev, idCorsoRev, idPartnerRev).subscribe((respSet: any) => {
                        Swal.fire({
                            title: 'Revisione completata!',
                            text: 'Hai rivisto tutti i contenuti del corso. I tentativi per il test sono stati ripristinati. Puoi riprovare il test.',
                            icon: 'success',
                            confirmButtonColor: '#6993FF',
                            confirmButtonText: 'Continua',
                            allowOutsideClick: false,
                        }).then(() => {
                            location.reload();
                        });
                    });
                } else {
                    this.videoTempoAggiornato(isChiusuraAutomatica);
                }
            });
        }, (err) => {
            console.error('Errore salvataggio revisione ECM:', err);
            this.tempoTrascorso=0;
            this.videoTempoAggiornato(isChiusuraAutomatica);
        });
        return;
    }

    //invio il tempo CUMULATIVO totale → PHP aggiorna lo stesso record (o ne crea uno se non c'era auto-save)
    //autoSave=0 indica a PHP di finalizzare il record (isAutosave=0)
    console.log("-----chiudi video finale: "+this.tempoTrascorso+"s cumulativi-----");
    this.arraySaveDatiUC_Tempo['autoSave']=0;
    this.arraySaveDatiUC_Tempo['tempoTrascorsoInSecondi']=this.tempoTrascorso;
    this.arraySaveDatiUC_Tempo['tempoTrascorso']=this.secondToMinute(this.tempoTrascorso);
    this.arraySaveDatiUC_Tempo['idCorsoSvolgimento']=this.elencoDataCorso[0]['id_corso_svolgimento'];
    this.arraySaveDatiUC_Tempo['isInLive']=this.reportForData;
    this.arraySaveDatiUC_Tempo['idPartner']=this.schedaCorsistaGlobal['id_partner'];
    this.arraySaveDatiUC_Tempo['isPDF']='0';

    let check_idModuloBody=this.arraySaveDatiUC_Tempo['idModuloBody'];
    var positionAttualeVideoSalvato=0;
    this.moduliUC.forEach(element => {
        element['paragrafi'].forEach(elementParagrafi => {
            if(elementParagrafi['id_modulo_body']==check_idModuloBody) {
                positionAttualeVideoSalvato=element['position'];
            }
        });
    });

    // Salvo il numero di moduli completati PRIMA del refresh per confronto
    let moduliCompletatiPrima = 0;
    this.moduliUC.forEach(el => { if(el['isComplete'] == 1) moduliCompletatiPrima++; });
    let frequenzaPrima = this.ModuloUC_frequenza;
    let videoFinished = this.videoEndedNaturally;
    this.videoEndedNaturally = false;

    if(this.isFAD_Always==false) {
        this.crudService.salveTempoTrascorsoVideo(this.arraySaveDatiUC_Tempo).subscribe(responseData => {
            console.log("----salvataggio video finale OK-----");
            console.log(responseData);

            this.tempoAutoSaveVideoCnt=0;

            document.getElementById("video_"+this.arraySaveDatiUC_Tempo['idModuloBodyParagrafo']).innerHTML=responseData.toString();
            document.getElementById("video_"+this.arraySaveDatiUC_Tempo['idModuloBodyParagrafo']).classList.remove("d-none");
            this.tempoTrascorso=0;

            var isHaveElencoDate=1;
            if(this.elencoDataCorso.length<=1)
                isHaveElencoDate=0;

            this.crudService.api_get_refreshModuloComplete(this.idCorsoGlobal, this.detailUser.id_corsista, isHaveElencoDate).subscribe(response => {
                var indexModulo=0;
                var arrayResponse=new Array(response);
                var arrTMP: any=[];
                arrTMP=arrayResponse[0];

                arrTMP.forEach(element => {
                    if(element['isComplete']==1) {
                        indexModulo++;
                    }
                });

                //aggiorno moduliUC in tempo reale senza reload
                // L'alert "Nuovo modulo sbloccato" ha senso SOLO se il corso usa la
                // progressione obbligatoria (`canProgressiveModuli=1`): in quel caso
                // il modulo successivo si sblocca davvero dopo il completamento di un
                // SP. Altrimenti tutti i moduli sono gia' sbloccati e il confronto
                // `moduliUC[i].isLocked != arrTMP[i].isLocked` puo' essere triggerato
                // solo dalle modifiche runtime di `ricalcolaLockingModuliUC` (re-sync
                // con il DB), producendo un falso "modulo sbloccato".
                var isProgressioneModuliCheck = 0;
                if(this.elencoDataCorso && this.elencoDataCorso.length) {
                    isProgressioneModuliCheck = this.elencoDataCorso[0]['canProgressiveModuli'];
                }
                var titoloModuloSbloccato = '';
                if(isProgressioneModuliCheck == 1 && positionAttualeVideoSalvato > 0) {
                    if((this.moduliUC.length-1)>=indexModulo) {
                        if(this.moduliUC[indexModulo]['isLocked']!=arrTMP[indexModulo]['isLocked']) {
                            titoloModuloSbloccato = this.moduliUC[indexModulo]['titolo'];
                        }
                    }
                }

                this.moduliUC = arrTMP;
                this.calcolaPercentualeModuli();
                // Ricalcola lock, test valutazione e progressione (stessa logica del load iniziale)
                this.ricalcolaLockingModuliUC();

                // Ricalcola frequenza moduli UC
                let totModuli = arrTMP.length;
                let completati = 0;
                arrTMP.forEach(el => { if(el['isComplete'] == 1) completati++; });
                let nuovaFrequenza = totModuli > 0 ? Math.round((completati / totModuli) * 100) : 0;
                this.ModuloUC_frequenza = nuovaFrequenza;

                // Se la frequenza ha raggiunto 100%, popola detailQuiz per abilitare il tab "Esame Finale"
                if(nuovaFrequenza >= 100 && this.detailQuizOnlyTEST && this.detailQuizOnlyTEST.length) {
                    if(!this.detailQuiz || !this.detailQuiz['body']) {
                        this.detailQuizOnlyTEST.forEach(element => {
                            if(element.isTestValutazione == 0 && element['body']) {
                                this.detailQuiz = element;
                                this.detailQuiz['corsista'] = this.detailUser;
                                this.detailQuiz['id_corso'] = this.idCorsoGlobal;
                                this.showEsameFattiDay = true;
                            }
                        });
                    }
                }

                if(titoloModuloSbloccato) {
                    this.nuovoModuloSloccato(titoloModuloSbloccato);
                } else if(completati > moduliCompletatiPrima) {
                    if(nuovaFrequenza >= 100) {
                        Swal.fire({
                            title: 'Percorso completato!',
                            text: 'Hai completato tutti i moduli. Ora puoi procedere con il test.',
                            icon: 'success',
                            confirmButtonColor: '#6993FF',
                            confirmButtonText: 'Continua',
                            allowOutsideClick: false,
                        });
                    } else {
                        Swal.fire({
                            title: 'Modulo completato!',
                            text: 'Il contenuto è stato completato, puoi procedere al successivo.',
                            icon: 'success',
                            confirmButtonColor: '#6993FF',
                            confirmButtonText: 'Continua',
                            allowOutsideClick: false,
                        });
                    }
                } else {
                    this.videoTempoAggiornato(isChiusuraAutomatica);
                }
            });

        }, (err) => {
            console.error('Errore salvataggio video:', err);
            var formData = new FormData();
            formData.append("type", 'salveTempoTrascorsoVideo');
            formData.append("isInLive", this.arraySaveDatiUC_Tempo['isInLive']);
            formData.append("autoSave", '0');
            formData.append("idCorso", this.arraySaveDatiUC_Tempo['idCorso']);
            formData.append("idCorsoSvolgimento", this.arraySaveDatiUC_Tempo['idCorsoSvolgimento']);
            formData.append("idCorsista", this.arraySaveDatiUC_Tempo['idCorsista']);
            formData.append("idPartner", this.arraySaveDatiUC_Tempo['idPartner']);
            formData.append("idModuloBody", this.arraySaveDatiUC_Tempo['idModuloBody']);
            formData.append("idModuloBodyParagrafo", this.arraySaveDatiUC_Tempo['idModuloBodyParagrafo']);
            formData.append("tempoTrascorso", this.arraySaveDatiUC_Tempo['tempoTrascorso']);
            formData.append("tempoTrascorsoInSecondi", this.arraySaveDatiUC_Tempo['tempoTrascorsoInSecondi']);
            formData.append("isPDF", '0');
            navigator.sendBeacon(environment.web_api_url_base + 'corso.php', formData);
            this.tempoTrascorso=0;
            this.videoTempoAggiornato(isChiusuraAutomatica);
        });
    }
  }

  salvaTempoVideoAutomatico() {
    // Consultazione: non salvare nel DB
    if(this.isConsultazione) {
        return;
    }

    //blocco salvataggi sovrapposti (chiudiVideo aspetta che canSave torni true)
    this.canSave=false;

    // ECM revisione: auto-save nella tabella revisione separata
    if(this.isECM && this.ecmConfig && this.ecmConfig.deve_revisionare == 1) {
        let tempoTotaleRevisione = this.ecmRevisionePlayVideoResumePoint + this.tempoTrascorso;
        let idCorsRev = this.detailUser['id_corsista'];
        let idCorsoRev = this.arraySaveDatiUC_Tempo['idCorso'] || this.idCorsoGlobal;
        let idPartnerRev = this.schedaCorsistaGlobal['id_partner'];
        let idParRev = this.arraySaveDatiUC_Tempo['idModuloBodyParagrafo'];

        this.crudService.api_ecmSalvaProgressoRevisione(idCorsRev, idCorsoRev, idPartnerRev, idParRev, tempoTotaleRevisione).subscribe((resp: any) => {
            this.showToast('Avanzamento revisione salvato');
            this.canSave=true;
        }, (err) => {
            console.error('Errore auto-save revisione ECM:', err);
            this.canSave=true;
        });
        return;
    }

    // Per presentazioni AI: salva solo il tempo delle slide completate
    // Se nessuna slide è completata (presTempoCompletato=0), non salvare
    if(this.isPresentazioneAI && this.presTempoCompletato <= 0) {
        this.canSave=true;
        return;
    }
    var tempoEffettivo = this.isPresentazioneAI ? this.presTempoCompletato : this.tempoTrascorso;

    console.log("-----auto-save video cumulativo: "+tempoEffettivo+"s-----");
    this.arraySaveDatiUC_Tempo['autoSave']=1;
    //invio il tempo CUMULATIVO totale (non il delta) → PHP fa SET, non ADD
    this.arraySaveDatiUC_Tempo['tempoTrascorso']=this.secondToMinute(tempoEffettivo);
    this.arraySaveDatiUC_Tempo['tempoTrascorsoInSecondi']=tempoEffettivo;
    this.arraySaveDatiUC_Tempo['idCorsoSvolgimento']=this.elencoDataCorso[0]['id_corso_svolgimento'];
    this.arraySaveDatiUC_Tempo['isInLive']=this.reportForData;
    this.arraySaveDatiUC_Tempo['idPartner']=this.schedaCorsistaGlobal['id_partner'];
    this.arraySaveDatiUC_Tempo['isPDF']='0';

    if(this.isFAD_Always==false) {
        this.crudService.salveTempoTrascorsoVideo(this.arraySaveDatiUC_Tempo).subscribe(responseData => {
            console.log("----salvataggio video automatico OK-----");

            document.getElementById("video_"+this.arraySaveDatiUC_Tempo['idModuloBodyParagrafo']).innerHTML=responseData.toString();
            document.getElementById("video_"+this.arraySaveDatiUC_Tempo['idModuloBodyParagrafo']).classList.remove("d-none");

            this.showToast('Avanzamento video salvato automaticamente');
            this.canSave=true;
        }, (err) => {
            console.error('Errore auto-save video:', err);
            this.canSave=true;
        });
    }
  }

  chiudiVideoLimiteRaggiunto() {
    // Consultazione: non salvare nel DB
    if(this.isConsultazione) {
        this.mostraAvvisoConsultazione();
        this.tempoTrascorso=0;
        return;
    }

    this.arraySaveDatiUC_Tempo['tempoTrascorso']=this.secondToMinute(this.tempoTrascorso);
    if(this.tempoTrascorso>parseFloat(this.timeStartVideo))
        this.arraySaveDatiUC_Tempo['tempoTrascorso']=this.secondToMinute(this.tempoTrascorso-parseFloat(this.timeStartVideo));
    this.arraySaveDatiUC_Tempo['idCorsoSvolgimento']=this.elencoDataCorso[0]['id_corso_svolgimento'];
    this.arraySaveDatiUC_Tempo['isInLive']=this.reportForData;
    this.arraySaveDatiUC_Tempo['isPDF']='0';

    if(this.isFAD_Always==false) {
        this.crudService.salveTempoTrascorsoVideo(this.arraySaveDatiUC_Tempo).subscribe(responseData => {
            //console.log(responseData);
            //location.reload();
            let totaleAggiornato=(parseFloat(this.timeStartVideo)+(parseFloat(this.secondToMinute(this.tempoTrascorso))*100)).toString();
            document.getElementById("video_"+this.arraySaveDatiUC_Tempo['idModuloBodyParagrafo']).innerHTML=responseData.toString();
            document.getElementById("video_"+this.arraySaveDatiUC_Tempo['idModuloBodyParagrafo']).classList.remove("d-none");
            this.tempoTrascorso=0;
            this.limiteRaggiunto(1);
        });
    }
  }

  playPDF(pdfFile, titolo, idCorso, idPartner, id_modulo_body, id_modulo_body_paragrafo, minuteStart, durata, isLocked, forceRestart = false) {
    if(this.isPlayVideo==true)
        return;

    if(this.bloccaTuttoPerEsameFinale) {
        this.mostraAvvisoAttesaEsameFinale();
        return;
    }

    if(this.isConsultazione) this.mostraAvvisoConsultazione();

    this.isPlayVideo=true;
    this.tempoTrascorso=0;
    this.tempoAutoSaveVideoCnt=0;

    if(this.schedaCorsistaGlobal['id_partner']>0) {
        idPartner=this.schedaCorsistaGlobal['id_partner'];
    }

    let idCorsoSvolgimento=this.arrayLive['id_corso_svolgimento'];

    this.crudService.checkIfSessioneIsTerminata(idCorsoSvolgimento).subscribe(timeRestante => {
        if(this.arrayLive.isLive==1) {
            this.tempoRestanteSessione=parseInt(timeRestante.toString());
            if(parseInt(timeRestante.toString())<=0) {
                this.isPlayVideo=false;
                this.limiteRaggiunto(1);
                return;
            }
        }

        this.crudService.resetTimeFadEveryDays(idCorsoSvolgimento).subscribe(resetTimeFadEveryDays => {
        if(resetTimeFadEveryDays==0)
            this.reportForData=0;

        this.crudService.getTimeVideoVisualizzato(this.detailUser['id_corsista'], idCorso, idPartner, id_modulo_body, id_modulo_body_paragrafo, this.reportForData).subscribe(responseData => {

            this.timeCheck = (this.timeCheckBackup > 0) ? this.timeCheckBackup : this.timeCheck;
            this.checkIsActiveTimeInattivo();

            //converto durata MM.SS in secondi (parso la stringa SENZA parseFloat per preservare gli zeri finali)
            var durataSec=0;
            var arDurata=durata.toString().split(".");
            if(arDurata.length) {
                var minDurata=parseInt(arDurata[0]) || 0;
                var secDurata=(arDurata.length>1) ? parseInt(arDurata[1]) : 0;
                durataSec=(minDurata*60)+secDurata;
            }

            //converto minuteStart MM.SS in secondi (tempo già letto)
            var minuteStartSec=0;
            var strMinuteStart=responseData.toString();
            var arStart=strMinuteStart.split(".");
            if(arStart.length) {
                var minStart=parseInt(arStart[0]) || 0;
                var secStart=(arStart.length>1) ? parseInt(arStart[1]) : 0;
                minuteStartSec=(minStart*60)+secStart;
            }

            var tempoRestanteSecondi = (durataSec > minuteStartSec) ? (durataSec - minuteStartSec) : 0;

            if(tempoRestanteSecondi<=0) {
                if(!forceRestart) {
                    this.isPlayVideo=false;
                    Swal.fire({
                        title:'Lettura completata',
                        text: 'Hai già raggiunto il tempo di lettura previsto per questo documento. Vuoi rileggerlo dall\'inizio?',
                        icon: 'info',
                        showCancelButton: true,
                        confirmButtonColor: '#6993FF',
                        cancelButtonColor: '#dadada',
                        confirmButtonText: 'Rileggi dall\'inizio',
                        cancelButtonText: 'Torna al corso',
                        allowOutsideClick: false,
                    }).then((result) => {
                        if (result.isConfirmed) {
                            this.playPDF(pdfFile, titolo, idCorso, idPartner, id_modulo_body, id_modulo_body_paragrafo, '0', durata, isLocked, true);
                        }
                    });
                    return;
                }
                tempoRestanteSecondi = durataSec;
            }

            this.pdfDurataSec = durataSec;

            pdfFile=pdfFile.trim();
            this.entraInAula();

            var logoExtraFondo="";
            if(this.logoFondo!="") {
                logoExtraFondo='<img style="max-height:80px; max-width:600px; margin-left:15px" src="'+this.logoFondo+'">';
            }

            var lblTimeRestante='<div class="">\
                                    <span class="text-danger" style="font-weight: normal; font-size:10pt">\
                                    <i class="fa fa-clock-o" aria-hidden="true"></i>\
                                    Tempo di lettura rimasto: <span id="timeRestantePDF" style="font-weight:bolder">'+this.secondsToHms(tempoRestanteSecondi)+'</span>\
                                    </span>\
                                </div>';

            var relativeVideoPath = pdfFile.replace(this.urlVideoCorso, '');
            this.crudService.getVideoToken(relativeVideoPath).subscribe(token => {
                var streamUrl = environment.web_api_url_base.replace('/api/', '/pages/stream_video.php') + '?t=' + encodeURIComponent(token.toString());

                Swal.fire({
                    html: '<img style="max-height:100px" src="'+this.logoPartner+'">'+logoExtraFondo+'<br><hr>\
                            <div style="display:flex; justify-content:space-between; align-items:center;">\
                                <span style="font-weight:800; font-size:18px; color:var(--blackColor)">'+titolo+'</span>\
                                <button id="btnFullscreenPDF" type="button" style="background:none; border:1px solid #ccc; border-radius:6px; padding:6px 12px; cursor:pointer; font-size:13px; color:#555; display:flex; align-items:center; gap:5px;" title="Schermo intero">\
                                    <i class="fa fa-expand" aria-hidden="true"></i> Schermo intero\
                                </button>\
                            </div>\
                            '+lblTimeRestante+'\
                           <div id="pdfFullscreenContainer" style="position:relative; margin-top:15px; background:#525659;">\
                               <div id="pdfFullscreenBar" style="display:none; width:100%; background:#323639; padding:8px 16px; box-sizing:border-box; align-items:center; justify-content:space-between;">\
                                   <span style="color:#fff; font-size:14px; font-weight:500;"><i class="fa fa-file-pdf-o" aria-hidden="true"></i> '+titolo+'</span>\
                                   <button id="btnExitFullscreenPDF" type="button" style="background:#fff; color:#323639; border:none; border-radius:6px; padding:8px 18px; cursor:pointer; font-size:13px; font-weight:600; display:flex; align-items:center; gap:6px;">\
                                       <i class="fa fa-compress" aria-hidden="true"></i> Esci da schermo intero\
                                   </button>\
                               </div>\
                               <iframe id="myPDF" src="'+streamUrl+'" width="100%" height="500px" style="border:none;"></iframe>\
                           </div>',
                    width: '900px',
                    heightAuto: false,
                    showCancelButton: false,
                    confirmButtonColor: '#6993FF',
                    cancelButtonColor: '#dadada',
                    confirmButtonText: 'Salva e ritorna al corso',
                    allowOutsideClick: false,
                    didOpen: () => {
                        var container = document.getElementById('pdfFullscreenContainer');
                        var btnFs = document.getElementById('btnFullscreenPDF');
                        var btnExit = document.getElementById('btnExitFullscreenPDF');
                        var fsBar = document.getElementById('pdfFullscreenBar');
                        var iframe = document.getElementById('myPDF') as HTMLIFrameElement;

                        if(btnFs && container) {
                            btnFs.addEventListener('click', () => {
                                if(container.requestFullscreen) {
                                    container.requestFullscreen();
                                } else if((container as any).webkitRequestFullscreen) {
                                    (container as any).webkitRequestFullscreen();
                                } else if((container as any).msRequestFullscreen) {
                                    (container as any).msRequestFullscreen();
                                }
                            });
                        }

                        if(btnExit) {
                            btnExit.addEventListener('click', () => {
                                if(document.exitFullscreen) {
                                    document.exitFullscreen();
                                } else if((document as any).webkitExitFullscreen) {
                                    (document as any).webkitExitFullscreen();
                                } else if((document as any).msExitFullscreen) {
                                    (document as any).msExitFullscreen();
                                }
                            });
                        }

                        document.addEventListener('fullscreenchange', function onFsChange() {
                            if(document.fullscreenElement === container) {
                                if(fsBar) fsBar.style.display = 'flex';
                                if(iframe) iframe.style.height = 'calc(100vh - 48px)';
                            } else {
                                if(fsBar) fsBar.style.display = 'none';
                                if(iframe) iframe.style.height = '500px';
                            }
                            if(!document.getElementById('pdfFullscreenContainer')) {
                                document.removeEventListener('fullscreenchange', onFsChange);
                            }
                        });
                    },
                }).then((result) => {
                    if (result.isConfirmed) {
                        clearInterval(this.timerHandle);
                        this.chiudiVideo();
                    }
                });

                setTimeout(() => {
                    this.startTimerPDF(idCorso, idPartner, id_modulo_body, id_modulo_body_paragrafo, tempoRestanteSecondi);
                }, 250);
            });
        });
        });
    });
  }

  playPresentazione(presId, titolo, idCorso, idPartner, id_modulo_body, id_modulo_body_paragrafo, minuteStart, durata, isLocked) {
    if(this.isPlayVideo==true)
        return;

    if(this.bloccaTuttoPerEsameFinale) {
        this.mostraAvvisoAttesaEsameFinale();
        return;
    }

    if(this.isConsultazione) this.mostraAvvisoConsultazione();

    this.isPlayVideo=true;
    this.isPresentazioneAI=true;
    this.tempoTrascorso=0;
    this.tempoAutoSaveVideoCnt=0;

    if(this.schedaCorsistaGlobal['id_partner']>0) {
        idPartner=this.schedaCorsistaGlobal['id_partner'];
    }

    // Calcolo durata in secondi
    var durataSec=0;
    var arDurata=durata.toString().split(".");
    if(arDurata.length) {
        var minDurata=parseInt(arDurata[0]) || 0;
        var secDurata=(arDurata.length>1) ? parseInt(arDurata[1]) : 0;
        durataSec=(minDurata*60)+secDurata;
    }
    this.pdfDurataSec = durataSec;

    // Recupero tempo già visualizzato dal backend
    this.crudService.getTimeVideoVisualizzato(this.detailUser['id_corsista'], idCorso, idPartner, id_modulo_body, id_modulo_body_paragrafo, this.reportForData).subscribe(responseData => {

        // Converto tempo già visto MM.SS in secondi
        var minuteStartSec=0;
        var strMinuteStart=responseData.toString();
        var arStart=strMinuteStart.split(".");
        if(arStart.length) {
            var minStart=parseInt(arStart[0]) || 0;
            var secStart=(arStart.length>1) ? parseInt(arStart[1]) : 0;
            minuteStartSec=(minStart*60)+secStart;
        }

        var tempoRestanteSecondi = (durataSec > minuteStartSec) ? (durataSec - minuteStartSec) : 0;

        this.entraInAula();

        var logoExtraFondo="";
        if(this.logoFondo!="") {
            logoExtraFondo='<img style="max-height:80px; max-width:600px; margin-left:15px" src="'+this.logoFondo+'">';
        }

        var lblTimeRestante='';
        if(durataSec > 0) {
            lblTimeRestante='<div style="margin-top:4px">\
                                <span class="text-danger" style="font-weight: normal; font-size:10pt">\
                                <i class="fa fa-clock-o" aria-hidden="true"></i>\
                                Tempo rimanente: <span id="timeRestantePDF" style="font-weight:bolder">'+this.secondsToHms(tempoRestanteSecondi)+'</span>\
                                </span>\
                            </div>';
        }

        // URL viewer con tutti gli ID per salvataggio diretto al DB (stessa origine)
        // Routing dinamico: standard=viewer_presentazione.php (FNC), lingue=viewer_lingue.php
        var viewerPage = (this.courseViewer === 'lingue') ? 'viewer_lingue.php' : 'viewer_presentazione.php';
        // Exact-resume params: se abbiamo memorizzato slide+seek esatti dalla sessione
        // precedente di QUESTO paragrafo, passali. Il viewer (vedi notificaTempoCompletato)
        // li interpreta come "salta il probe, vai direttamente a quella slide+secondo".
        var exactResume = this.presResumeByParagrafo[String(id_modulo_body_paragrafo)];
        var exactResumeQS = '';
        if(exactResume && exactResume.slide > 0 && exactResume.seek >= 0) {
            exactResumeQS = '&startSlide=' + exactResume.slide + '&startSeek=' + exactResume.seek.toFixed(2);
        }
        var presUrl = environment.web_api_url_base.replace('/api/', '/pages/' + viewerPage)
                    + '?id=' + encodeURIComponent(presId)
                    + '&partner=' + encodeURIComponent(idPartner)
                    + '&startTime=' + minuteStartSec
                    + '&corsista=' + encodeURIComponent(this.detailUser['id_corsista'])
                    + '&corso=' + encodeURIComponent(idCorso)
                    + '&moduloBody=' + encodeURIComponent(id_modulo_body)
                    + '&paragrafo=' + encodeURIComponent(id_modulo_body_paragrafo)
                    + '&isInLive=' + this.reportForData
                    + '&svolgimento=' + encodeURIComponent(this.elencoDataCorso[0]['id_corso_svolgimento'])
                    + exactResumeQS
                    + (this.isConsultazione ? '&consultazione=1' : '');

        Swal.fire({
            html: '<img style="max-height:100px" src="'+this.logoPartner+'">'+logoExtraFondo+'<br><hr>\
                    <div style="display:flex; align-items:center; position:relative;">\
                        <span style="font-weight:800; font-size:18px; color:var(--blackColor); text-align:center; flex:1;">'+titolo+'</span>\
                        <button id="btnFullscreenPres" type="button" style="background:none; border:1px solid #ccc; border-radius:6px; padding:6px 12px; cursor:pointer; font-size:13px; color:#555; display:flex; align-items:center; gap:5px; position:absolute; right:0;" title="Schermo intero">\
                            <i class="fa fa-expand" aria-hidden="true"></i> Schermo intero\
                        </button>\
                    </div>\
                    '+lblTimeRestante+'\
                   <div id="presFullscreenContainer" style="position:relative; margin-top:15px; background:#211D38; border-radius:8px; overflow:hidden;">\
                       <div id="presFullscreenBar" style="display:none; width:100%; background:#211D38; padding:8px 16px; box-sizing:border-box; align-items:center; justify-content:space-between;">\
                           <span style="color:#fff; font-size:14px; font-weight:500;"><i class="fa fa-play-circle" aria-hidden="true"></i> '+titolo+'</span>\
                           <button id="btnExitFullscreenPres" type="button" style="background:#fff; color:#211D38; border:none; border-radius:6px; padding:8px 18px; cursor:pointer; font-size:13px; font-weight:600; display:flex; align-items:center; gap:6px;">\
                               <i class="fa fa-compress" aria-hidden="true"></i> Esci da schermo intero\
                           </button>\
                       </div>\
                       <iframe id="myPresentazione" src="'+presUrl+'" width="100%" style="border:none; aspect-ratio:16/9; display:block;" allow="autoplay; fullscreen" allowfullscreen></iframe>\
                   </div>',
            width: '1100px',
            heightAuto: false,
            showCancelButton: false,
            confirmButtonColor: '#5563F0',
            cancelButtonColor: '#dadada',
            confirmButtonText: 'Chiudi presentazione',
            allowOutsideClick: false,
            didOpen: () => {
                // Ascolta i messaggi dal viewer: tempo slide completate
                this.presTempoCompletato = 0;
                this.presLastSlide = -1;
                // Wall-clock dell'apertura del Swal: cap di sicurezza sul sessionDelta
                // che il viewer puo' mandare. Senza questo, il viewer cumula in
                // sessionDelta anche le slide completate naturalmente (es. cover
                // di 10s che parte in autoplay) sommate al partial della slide in
                // corso: l'utente vede "11s" ma riceviamo "21s" e salviamo 21s al
                // backend. Cappando al tempo reale trascorso evitiamo che vada
                // mai oltre quanto fisicamente possibile.
                var presOpenedAt = Date.now();
                this.presMessageHandler = (event) => {
                    if(event.data && event.data.type === 'presTempoCompletato') {
                        // Il viewer manda due valori: `secondi` = totale storico (pregresso DB + sessione),
                        // `sessionDelta` = solo il DELTA della sessione corrente.
                        // Il backend salveTempoTrascorsoVideo si aspetta il DELTA (lo SET sul record
                        // in-progress della giornata e fa SUM dei record per ottenere il totale).
                        // Usare `secondi` faceva sommare il pregresso al pregresso ad ogni sessione,
                        // accumulando il tempo (5→11→16→21…). Il `sessionDelta` è monotono crescente
                        // nella sessione, quindi tengo il massimo ricevuto, cappato al wall-clock.
                        var rawDelta = event.data.sessionDelta || 0;
                        var elapsedSec = Math.floor((Date.now() - presOpenedAt) / 1000);
                        var delta = Math.min(rawDelta, elapsedSec);
                        if(delta > this.presTempoCompletato) this.presTempoCompletato = delta;
                        this.presLastSlide = event.data.slide;
                        // Memorizza l'ultima posizione esatta per "exact resume" alla
                        // prossima apertura dello stesso paragrafo (bypassa il probe).
                        if(typeof event.data.currentSlide === 'number' && typeof event.data.audioTime === 'number') {
                            this.presResumeByParagrafo[String(id_modulo_body_paragrafo)] = {
                                slide: event.data.currentSlide,
                                seek: event.data.audioTime
                            };
                        }
                    }
                    // Fine presentazione: ultima slide terminata → salva e chiudi il Swal.
                    // Quando il viewer raggiunge genuinamente la fine manda `forceCompletion=true`
                    // con `completionDelta` = max(sessionDelta, gapDelta) dove gapDelta =
                    // durata_video - startTimeSec. Questo e' il delta MINIMO che, sommato al
                    // pregresso DB, porta SUM(backend) a durata → isFileComplete=1.
                    // NON e' la durata totale: il singolo record salvato vale solo il gap
                    // residuo (es. 9s) non l'intero video.
                    if(event.data && event.data.type === 'presEnded') {
                        if(event.data.forceCompletion && typeof event.data.completionDelta === 'number' && event.data.completionDelta > 0) {
                            this.presTempoCompletato = event.data.completionDelta;
                        } else {
                            var rawDeltaEnd = event.data.sessionDelta || 0;
                            var elapsedSecEnd = Math.floor((Date.now() - presOpenedAt) / 1000);
                            var deltaEnd = Math.min(rawDeltaEnd, elapsedSecEnd);
                            if(deltaEnd > this.presTempoCompletato) this.presTempoCompletato = deltaEnd;
                        }
                        // Reset dell'exact-resume per questo paragrafo: e' finito,
                        // non vogliamo che la prossima apertura riparta dall'ultima slide.
                        delete this.presResumeByParagrafo[String(id_modulo_body_paragrafo)];
                        // Chiude il dialog (il viewer ha gia' chiamato stopPlaying internamente).
                        // Il `.then()` del Swal eseguira' chiudiVideo() che salva al backend.
                        setTimeout(() => {
                            if(Swal.isVisible()) Swal.clickConfirm();
                        }, 100);
                    }
                    // Pausa/Resume: il viewer notifica quando il corsista mette in pausa
                    if(event.data && event.data.type === 'presPaused') {
                        clearInterval(this.timerHandle);
                    }
                    if(event.data && event.data.type === 'presResumed') {
                        clearInterval(this.timerHandle); // Sicurezza: evita timer duplicati
                        if(this.presTempoRestanteSec > 0) {
                            this.timerHandle = setInterval(() => {
                                this.countTimerPDF(this.presTempoRestanteSec);
                            }, 1000);
                        } else {
                            this.timerHandle = setInterval(() => {
                                this.tempoTrascorso++;
                                this.tempoAutoSaveVideoCnt++;
                                if(this.tempoAutoSaveVideoCnt >= this.tempoAutoSaveVideo && this.canSave) {
                                    this.tempoAutoSaveVideoCnt=0;
                                    this.salvaTempoVideoAutomatico();
                                }
                            }, 1000);
                        }
                    }
                };
                window.addEventListener('message', this.presMessageHandler);

                var container = document.getElementById('presFullscreenContainer');
                var btnFs = document.getElementById('btnFullscreenPres');
                var btnExit = document.getElementById('btnExitFullscreenPres');
                var fsBar = document.getElementById('presFullscreenBar');
                var iframe = document.getElementById('myPresentazione') as HTMLIFrameElement;

                if(btnFs && container) {
                    btnFs.addEventListener('click', () => {
                        if(container.requestFullscreen) {
                            container.requestFullscreen();
                        } else if((container as any).webkitRequestFullscreen) {
                            (container as any).webkitRequestFullscreen();
                        } else if((container as any).msRequestFullscreen) {
                            (container as any).msRequestFullscreen();
                        }
                    });
                }

                if(btnExit) {
                    btnExit.addEventListener('click', () => {
                        if(document.exitFullscreen) {
                            document.exitFullscreen();
                        } else if((document as any).webkitExitFullscreen) {
                            (document as any).webkitExitFullscreen();
                        } else if((document as any).msExitFullscreen) {
                            (document as any).msExitFullscreen();
                        }
                    });
                }

                document.addEventListener('fullscreenchange', function onFsChange() {
                    if(document.fullscreenElement === container) {
                        if(fsBar) fsBar.style.display = 'flex';
                        if(iframe) { iframe.style.width = '100%'; iframe.style.height = 'calc(100vh - 48px)'; }
                    } else {
                        if(fsBar) fsBar.style.display = 'none';
                        if(iframe) { iframe.style.width = '100%'; iframe.style.height = ''; iframe.style.setProperty('aspect-ratio', '16/9'); }
                    }
                    if(!document.getElementById('presFullscreenContainer')) {
                        document.removeEventListener('fullscreenchange', onFsChange);
                    }
                });
            },
        }).then((result) => {
            clearInterval(this.timerHandle);
            // Rimuovi listener postMessage
            if(this.presMessageHandler) {
                window.removeEventListener('message', this.presMessageHandler);
                this.presMessageHandler = null;
            }
            // Usa il tempo delle slide completate ricevuto dal viewer via postMessage
            this.tempoTrascorso = this.presTempoCompletato;
            this.isPresentazioneAI=false;
            if (result.isConfirmed) {
                this.chiudiVideo();
                // Se il viewer non ha comunicato nulla, aggiorna comunque i moduli (non in consultazione)
                if(this.presTempoCompletato <= 0 && !this.isConsultazione) {
                    var isHaveElencoDate = this.elencoDataCorso.length > 1 ? 1 : 0;
                    this.crudService.api_get_refreshModuloComplete(this.idCorsoGlobal, this.detailUser.id_corsista, isHaveElencoDate).subscribe(response => {
                        var arrTMP: any = new Array(response)[0];
                        this.moduliUC = arrTMP;
                        this.calcolaPercentualeModuli();
                    });
                }
            }
        });

        // Timer per tracciamento tempo + countdown
        // Per presentazioni AI: NON avviare il timer qui.
        // Il viewer controlla play/pausa e notifica via postMessage (presResumed/presPaused).
        // Avviare qui causerebbe un timer leaked che continua anche durante la pausa.
        var tempoRestantePerTimer = (tempoRestanteSecondi > 0) ? tempoRestanteSecondi : durataSec;
        this.presTempoRestanteSec = tempoRestantePerTimer;
        // Setup parametri per auto-save (servono quando il timer parte via presResumed)
        this.arraySaveDatiUC_Tempo['idCorso']=idCorso;
        this.arraySaveDatiUC_Tempo['idPartner']=this.schedaCorsistaGlobal['id_partner'];
        this.arraySaveDatiUC_Tempo['idModuloBody']=id_modulo_body;
        this.arraySaveDatiUC_Tempo['idModuloBodyParagrafo']=id_modulo_body_paragrafo;
        this.arraySaveDatiUC_Tempo['idCorsista']=this.detailUser['id_corsista'];
    });
  }

  startTimerPDF(idCorso, idPartner, id_modulo_body, id_modulo_body_paragrafo, tempoRestanteSec) {
    this.arraySaveDatiUC_Tempo['idCorso']=idCorso;
    this.arraySaveDatiUC_Tempo['idPartner']=this.schedaCorsistaGlobal['id_partner'];
    this.arraySaveDatiUC_Tempo['idModuloBody']=id_modulo_body;
    this.arraySaveDatiUC_Tempo['idModuloBodyParagrafo']=id_modulo_body_paragrafo;
    this.arraySaveDatiUC_Tempo['idCorsista']=this.detailUser['id_corsista'];

    this.timerHandle=setInterval(() => {
        this.countTimerPDF(tempoRestanteSec);
    }, 1000);
  }

  countTimerPDF(tempoRestanteSec) {
    this.tempoTrascorso++;

    //aggiorno il countdown del tempo rimasto
    var rimasto = tempoRestanteSec - this.tempoTrascorso;
    if(rimasto < 0) rimasto = 0;
    var elRimasto = document.getElementById("timeRestantePDF");
    if(elRimasto) elRimasto.textContent = this.secondsToHms(rimasto);

    //auto-save periodico
    this.tempoAutoSaveVideoCnt++;
    if(this.tempoAutoSaveVideoCnt >= this.tempoAutoSaveVideo && this.canSave) {
        this.tempoAutoSaveVideoCnt=0;
        this.salvaTempoVideoAutomatico();
    }

    //limite raggiunto: tempo di lettura rimanente completato
    if(this.tempoTrascorso >= tempoRestanteSec) {
        clearInterval(this.timerHandle);
        // Per le presentazioni AI, il viewer gestisce la completazione (ultima slide)
        // Non chiudere forzatamente il dialog: il countdown wall-clock può non coincidere
        // con il tempo reale delle slide audio
        if(!this.isPresentazioneAI) {
            setTimeout(() => {
                if(Swal.isVisible()) {
                    Swal.clickConfirm();
                } else {
                    this.chiudiVideo();
                }
            }, 250);
        }
    }
  }

  checkUserIsEnabled(idCorso, idCorsista) {
    let limiteConnessioneEffettuato=0;

    // Consultazione: non bloccare i moduli
    if(this.isConsultazione) {
        this.lockModuliUC=0;
    } else {
        this.lockModuliUC=1;
    }

    //evito errori nel caso in cui ci siano corsisti vuoti negli eventi (che è quasi impossibile)
    if(idCorsista<=0)
        idCorsista="";

    this.crudService.api_get_ElencoAulaCorsoTag(idCorso, idCorsista).subscribe(responseData => {
        if(responseData[0]) {
            console.log(responseData);
            console.log("elenco aule terminato -----");

            this.isEnabledUser=true;
            this.elencoDataCorso=responseData;

            this.arrayLive = this.elencoDataCorso[0];

            //variabile sentinella, controlla se nello stesso giorno ho più eventi
            var isInLiveTMP=0;
            this.elencoDataCorso.forEach(element => {
                //se nello stesso giorno non ho più eventi allora valuto la condizione
                //altrimenti significa che ho già trovato l'evento del giorno con la live in corso
                if(isInLiveTMP==0) {
                    if(element['isToday']==1) {
                        this.isInLive=element['isLive'];
                        this.protocollo=element['protocollo'];
                        this.limita_moduloUC=element['limita_moduloUC'];
                        this.isInLiveLinkAula=element['link_aula'];
                        this.arrayLive=element;
                        if(this.elencoDataCorso.length<=1) {
                            if(element['isLive']==3)
                                this.lockModuliUC=0;
                        }
                        //controllo se l'evento è in live
                        if(element['isLive']==1)
                            isInLiveTMP=1;
                        }
                        this.resetTimeFadEveryDays=this.arrayLive['resetTimeFadEveryDays'];
                    }
            });
            this.bloccoVisualizzazioneRipetuta=this.arrayLive['bloccoVisualizzazioneRipetuta'] || 0;
            console.log("bloccoVisualizzazioneRipetuta:", this.bloccoVisualizzazioneRipetuta, "arrayLive value:", this.arrayLive['bloccoVisualizzazioneRipetuta']);

            //mi trovo l'evento live ed aggiorno i riferimenti
            var isOnlyDAD=1;
            var isEventDaySelected=0;
            this.elencoDataCorso.forEach(elementDataCorso => {
                    //console.log(element);

                    //mi controllo se l'ente ha scelto di far vedere SEMPRE la FAD in ogni giorno (oltre a quelli in calendario)
                    //viene tracciata però SOLO quella in calendario
                    //controllo se la FAD deve essere visualizzata anche nell'evento del giorno
                    if((elementDataCorso['limita_moduloUC']==1) && (elementDataCorso['isLive']==1)) {
                        this.isFAD_Always=false;
                        isEventDaySelected=1;
                    }
                    else if((elementDataCorso['limita_moduloUC']==0) && (elementDataCorso['isFADAlways']==1) && isEventDaySelected==0) {
                            this.isFAD_Always=true;
                    }
                    else if(elementDataCorso['isFADAlways']==1 && isEventDaySelected==0)
                        this.isFAD_Always=true;


                    if(elementDataCorso['limita_moduloUC']==1)
                        isOnlyDAD=0;

                    if(this.lockModuliUC==1) {
                        if((elementDataCorso['limita_moduloUC']==1) && (!(elementDataCorso['isLive']==1))) {
                            this.lockModuliUC=1;
                        }
                    }
                    if(elementDataCorso['isLive']==5 || elementDataCorso['isLive']==2) {
                        this.reportForData=1;
                        this.limita_moduloUC=elementDataCorso['limita_moduloUC'];
                    }


                    if(elementDataCorso['isLive']==1) {
                        //console.log(element);
                        this.reportForData=1;


                        if(elementDataCorso['limita_moduloUC']==1) {
                            this.lockModuliUC=0;
                        }

                        this.limiteGiorno=0;
                        this.limiteGiornoAula=0;

                        //mi controllo se il limite giornaliero è stato raggiunto
                        if(elementDataCorso['limita_moduloUC']==1) {

                            //converto da minuti a secondi
                            if(parseFloat(elementDataCorso['limita_moduloUC_durata'])>0) {
                                this.limiteGiorno=(elementDataCorso['limita_moduloUC_durata']*60);
                                if(parseFloat(elementDataCorso['totaleConnessioneGiorno'])) {
                                    limiteConnessioneEffettuato=(parseFloat(elementDataCorso['totaleConnessioneGiorno']));
                                }

                                /*
                                if(parseFloat(element['totaleConnessioneGiorno'])>=parseFloat(element['limita_moduloUC_durata'])) {
                                    this.isLimiteRaggiunto=true;
                                }
                                */

                                if(limiteConnessioneEffettuato>=this.limiteGiorno) {
                                    this.isLimiteRaggiunto=true;
                                    this.lockModuliUC=1;
                                }

                                this.tempoRestanteLimite=(this.limiteGiorno-limiteConnessioneEffettuato);
                                this.labelTempoRestanteLimite=this.secondsToHms(this.tempoRestanteLimite);
                                this.tempoRestanteSessione=elementDataCorso['fineSeconds'];
                                this.labelTempoRestanteSessione=this.secondsToHms(this.tempoRestanteSessione);

                                this.timerHandle=setInterval(() => {
                                    this.aggiornaTempoSessione();
                                }, 1000);
                            }
                            else {
                                this.tempoRestanteLimite=elementDataCorso['fineSeconds'];
                                this.limiteGiorno=elementDataCorso['fineSeconds'];
                                this.isLimiteRaggiunto=false;
                                this.labelTempoRestanteLimite=this.secondsToHms(this.tempoRestanteLimite);
                                this.timerHandle=setInterval(() => {
                                    this.countTimerNoLimite();
                                }, 1000);
                            }

                        } else if((parseFloat(elementDataCorso['limita_aula_durata'])>0) && (elementDataCorso['limita_moduloUC']==0)) {
                            //converto da minuti a secondi
                            this.limiteGiornoAula=(elementDataCorso['limita_aula_durata']*60);
                            if(parseFloat(elementDataCorso['totaleConnessioneGiornoAula'])) {
                                limiteConnessioneEffettuato=(parseFloat(elementDataCorso['totaleConnessioneGiornoAula']));
                            }

                            this.tempoRestanteLimite=(this.limiteGiornoAula-limiteConnessioneEffettuato);
                            this.labelTempoRestanteLimite=this.secondsToHms(this.tempoRestanteLimite);

                            if(limiteConnessioneEffettuato>=this.limiteGiornoAula) {
                                this.isLimiteRaggiunto=true;
                            }
                            else {
                                if(this.tempoRestanteLimite>0) {
                                    this.tempoRestanteLimite--;
                                    // Invia il valore iniziale al worker
                                    this.worker.postMessage({
                                        command: 'start',
                                        startTime: Date.now(),
                                        tempoRestante: this.tempoRestanteLimite
                                    });

                                    // Ascolta i messaggi dal worker (tempo trascorso)
                                    this.worker.onmessage = ({ data }) => {
                                        console.log(`Timer dal worker: ${data} secondi`);
                                        this.tempoRestanteLimite=data;
                                        //this.countTimerAula();
                                    };

                                    this.timerHandle=setInterval(() => {
                                        this.countTimerAula();
                                    }, 1000);
                                }
                            }
                        }

                        //element['limita_moduloUC']=this.lockModuliUC;
                        this.isInLive=elementDataCorso['isLive'];
                        this.limita_moduloUC=elementDataCorso['limita_moduloUC'];
                        this.isInLiveLinkAula=elementDataCorso['link_aula'];

                        /*
                        if(element['isToday']==1) {
                            console.log("aaaaaa");
                            this.arrayLive=element;
                            console.log("okkkk."+this.arrayLive);
                        }
                        */

                    }
            });

            //"solo DAD" si decide sul calendario COMPLETO del corsista, non sulla finestra di date
            //dell'elenco: un'aula con giornate FAD fuori finestra non sblocca i video liberi
            if(this.elencoDataCorso[0]['haveFADInCalendario']==1)
                isOnlyDAD=0;
        }

        this.loadDetailsCorso(this.productID, isOnlyDAD);

        // Consultazione: forza sblocco moduli dopo tutto il setup
        if(this.isConsultazione) {
            this.lockModuliUC = 0;
            this.isLimiteRaggiunto = false;
        }

    });

  }

  calcolaPercentualeModuli() {
    if(!this.moduliUC) return;
    // Parser MM.SS → secondi. Lavora con stringhe ("20.56") o numeri (20.56).
    var mmSsToSec = (val: any): number => {
        if (val == null) return 0;
        var parts = String(val).split('.');
        var m = parseInt(parts[0]) || 0;
        var sec = parts.length > 1 ? (parseInt(parts[1]) || 0) : 0;
        return m * 60 + sec;
    };

    // Denominatore di fruizione: REPLICA esatta della logica del backend
    //   `FunctionClaude::getPercentualeFADVideo` (api/corso.php + function_claude.php).
    // Per ogni modulo:
    //   - se `durataManuale > 0` (minuti, settata dall'admin per accreditamento FNC/ECM)
    //     → denom = durataManuale * 60 (e watched per modulo cappato a questo)
    //   - altrimenti → denom = SUM(durate SP) del modulo
    // Senza questo cap, un modulo con durataManuale=20h ma SUM SP=20h30m verrebbe
    // calcolato sui 20h30m reali invece dei 20h dichiarati per accreditamento.
    var totaleVistoSec = 0;
    var totaleDurataSec = 0;
    var tuttiCompleti = this.moduliUC.length > 0;

    this.moduliUC.forEach(modulo => {
        if (modulo['isComplete'] != 1) tuttiCompleti = false;
        let totale = 0;
        let completati = 0;
        var moduloVistoSec = 0;
        var moduloSumDurataSpSec = 0;
        if(modulo['paragrafi']) {
            modulo['paragrafi'].forEach(par => {
                if(par['sotto-paragrafi']) {
                    par['sotto-paragrafi'].forEach(sp => {
                        totale++;
                        if(sp['isFileComplete']==1) completati++;
                        // Cap per-SP del watched (stesso comportamento del backend)
                        var dSec = mmSsToSec(sp['durata']);
                        var vSec = mmSsToSec(sp['tempoTrascorso']);
                        if (vSec > dSec) vSec = dSec;
                        moduloVistoSec += vSec;
                        moduloSumDurataSpSec += dSec;
                    });
                }
            });
        }
        modulo['percentualeCompletamento'] = totale > 0 ? Math.round((completati / totale) * 100) : 0;

        // Denominatore del modulo: il minimo tra `durataManuale*60` e la SUM reale
        // dei SP. Why min: se l'admin ha messo durataManuale > sumSP, il corsista
        // non potrebbe MAI raggiungere il 100% (max visto = sumSP). Vedi backend
        // function_modulo.php: stesso fix per `isComplete`.
        var durataManualeMin = parseInt(modulo['durataManuale']) || 0;
        var durataManualeSec = durataManualeMin * 60;
        var moduloDenomSec: number;
        if (durataManualeSec > 0) {
            moduloDenomSec = (moduloSumDurataSpSec > 0 && moduloSumDurataSpSec < durataManualeSec)
                             ? moduloSumDurataSpSec
                             : durataManualeSec;
        } else {
            moduloDenomSec = moduloSumDurataSpSec;
        }
        // Cap per-modulo del watched (se admin ha messo durataManuale < SUM SP,
        // i secondi visti oltre durataManuale non aggiungono fruizione)
        if (moduloDenomSec > 0 && moduloVistoSec > moduloDenomSec) {
            moduloVistoSec = moduloDenomSec;
        }
        totaleDurataSec += moduloDenomSec;
        totaleVistoSec += moduloVistoSec;
    });

    // Display di fruizione: la verita' osservabile. NO ceil, NO forced-100 di soglia.
    //   - se tutti i moduli sono `isComplete=1` (ogni SP entro tolleranza 2s) → 100%
    //   - altrimenti `floor(visto/totale * 100)` (mai mostra 100 finche' non lo e' davvero)
    // `ModuloUC_frequenza` (backend) resta come prima per le decisioni di gating.
    if (tuttiCompleti) {
        this.fruizioneDisplayPercent = 100;
        this.fruizioneCompletata = true;
    } else {
        this.fruizioneDisplayPercent = totaleDurataSec > 0
            ? Math.floor((totaleVistoSec / totaleDurataSec) * 100)
            : 0;
        this.fruizioneCompletata = false;
    }
  }

  changeBriciola() {
      this.detallCorso.titolo=this.cntClick+" Provami...";
      this.cntClick++;
  }

  limiteRaggiunto(isRefresh) {
    Swal.fire({
        title:'Limite Raggiunto!',
        text: 'hai raggiunto il limite giornaliero per la visualizzazione dei video, consula la lista degli eventi (\"Elenco Date\").',
        icon: 'warning',
        showCancelButton: false,
        confirmButtonColor: '#6993FF',
        cancelButtonColor: '#dadada',
        confirmButtonText: 'Chiudi',
        allowOutsideClick: false,
     }).then((result) => {
        if (result.isConfirmed) {
            if(isRefresh)
                location.reload();
        }
    });
  }

  videoTempoAggiornato(isChiusuraAutomatica = false) {
    if(isChiusuraAutomatica) {
        clearInterval(this.timerHandle);
        this.videoTempoAggiornatoOutFinestra();
        return;
    }

    Swal.fire({
        title:'Aggiornato!',
        text: 'il tempo di visualizzazione del video è stato aggiornato.',
        icon: 'success',
        showCancelButton: false,
        confirmButtonColor: '#6993FF',
        cancelButtonColor: '#dadada',
        confirmButtonText: 'Chiudi',
        allowOutsideClick: false,
     });
  }

   videoTempoAggiornatoOutFinestra() {
    Swal.fire({
        title:'Chiusura automatica',
        text: 'il video è stato salvato automaticamente perché non stai osservando il video.',
        icon: 'warning',
        showCancelButton: false,
        confirmButtonColor: '#6993FF',
        cancelButtonColor: '#dadada',
        confirmButtonText: 'Chiudi',
        allowOutsideClick: false,
     });
  }

  nuovoModuloSloccato(titolo) {
    Swal.fire({
        title:'Nuovo modulo sbloccato',
        html: '<b>'+titolo+"</b><br>è pronto per essere visualizzato.",
        icon: 'success',
        showCancelButton: false,
        confirmButtonColor: '#6993FF',
        cancelButtonColor: '#dadada',
        confirmButtonText: 'Chiudi',
        allowOutsideClick: false,
     });
  }

  showDetailVideoConnessioni(arrayElement, idCorsoSvolgimento) {
    var elements="";
    var titleUC="";
    var paragrafo="";

    //console.log(arrayElement);
    arrayElement.forEach(element => {
        if(titleUC!=element['titoloUC']) {
            titleUC=element['titoloUC'];
            elements+="<h6 class='fw-bolder pt-3 text-uppercase' style='color:var(--mainColor)'>"+titleUC+"</h6>";
        }
        if(paragrafo!=element['paragrafo']) {
            paragrafo=element['paragrafo'];
            elements+="<h6 class='fw-bolder pt-2' style='color:var(--bs-black)'>"+paragrafo+"</h6>";
        }
        elements+='<div class="pb-1 row">\
                        <span class="col-lg-2 fw-bold p-0" style="text-align:right; color: #2dbbc4; font-size: 11pt;">'+element['durata']+'</span>\
                        <span class="col-lg-9 text-lowercase">'+element['titolo']+'</span>\
                    </div>';
    });

    if(arrayElement.length>0) {
        var txt='<div class="">'+elements+'</div>';
        document.getElementById('accordion_'+idCorsoSvolgimento).innerHTML = txt;
    }
    else {
        if(document.getElementById('accordion_'+idCorsoSvolgimento))
            document.getElementById('accordion_'+idCorsoSvolgimento).innerHTML = "nessuna connessione effettuata";
    }

  }

  apriTestValutazione(target: any) {
    // Accetta sia indice (retrocompat) sia oggetto uc_TestValutazione dal loop
    // filtrato del template. Con l'oggetto evitiamo il disallineamento indice
    // originale (che includerebbe anche gli esami) vs indice filtrato.
    var _tvSel: any = null;
    if (typeof target === 'number') {
        _tvSel = this.moduloUC_TestValutazione ? this.moduloUC_TestValutazione[target] : null;
    } else {
        _tvSel = target;
    }

    // ECM: blocca apertura se deve revisionare (include anche tentativi esauriti, gestito lato server)
    if(this.isECM && this.ecmConfig && this.ecmConfig.deve_revisionare == 1) {
        let msg = 'Devi rivedere l\'intero corso prima di poter riprovare il test .';
        if(this.ecmConfig.max_tentativi > 0) {
            msg += '\n\nTentativi utilizzati: ' + this.ecmConfig.tentativi_usati + ' / ' + this.ecmConfig.max_tentativi;
        }
        Swal.fire({
            title: 'Revisione obbligatoria',
            text: msg,
            icon: 'warning',
            confirmButtonColor: 'var(--mainColor)',
            confirmButtonText: 'OK'
        });
        return;
    }

    // ENFORCEMENT tentativi/attesa (max_repeat / wait_time): se il corsista NON puo' ritentare ora
    // (tentativi esauriti o attesa non trascorsa) e non l'ha gia' superato, blocco l'apertura.
    if(_tvSel && _tvSel['canRetry']==0 && _tvSel['isSuperato']!=1) {
        Swal.fire({
            title: 'Test non disponibile',
            text: _tvSel['retryMsg'] || 'Non puoi ripetere il test in questo momento.',
            icon: 'warning',
            confirmButtonColor: 'var(--mainColor)',
            confirmButtonText: 'OK'
        });
        return;
    }

    if(_tvSel) {
        this.moduloUC_TestValutazioneSelected = _tvSel;
        this.showTestValutazione=true;
    }
  }

  stampaTestValutazione(idQuizHeader) {
    let idCorsista=this.detailUser['id_corsista'];

    window.open(this.urlStampa+"report-test-valutazione.php?idCorsista="+idCorsista+"&idCorso="+this.idCorsoGlobal+"&idQuizHeader="+idQuizHeader+"&isTestValutazione=1");
  }

  chiudiTestValutazione() {
    this.showTestValutazione=false;
    // Reset stato risposte multi-tipo (VF/multi/aperta/ordinamento/abbinamento)
    this.userAnswers = {};
    this.abbDxCache = {};
  }

  verificaTestValutazione(idQuizHeader) {
    // Real consultazione (corso davvero completato + bloccoCorsoFULL): blocco l'invio.
    // Always-FAD: il test parte, ma sul backend non viene salvato (flag inoltrato).
    if(this.isConsultazione && !this.isAlwaysFadMode) {
        Swal.fire({
            title: 'Modalità consultazione',
            text: 'Hai già completato questo corso. Il materiale è disponibile solo per consultazione.',
            icon: 'info', confirmButtonColor: 'var(--mainColor)', confirmButtonText: 'OK'
        });
        return;
    }

    var arrayRisposte=new Array();

    let idCorsista=this.detailUser['id_corsista'];
    let idCorsoSvolgimento=this.arrayLive['id_corso_svolgimento'];
    let idCorso=this.detailQuiz['id_corso'];

    // Loop su tutte le domande del quiz, non solo sui radio nativi:
    // ogni domanda emette UN payload col tipo e la risposta_user appropriata.
    this.moduloUC_TestValutazioneSelected['quizBody'].forEach(row => {
        const domanda = row['domanda'];
        const idDomanda = domanda['id_domanda'];
        const tipo = this.getTipoDomanda(row);

        let idRisposta: any = 0;
        let rispostaUser: any = null;
        let hasAnswer = false;
        let isRispostaLiberaFlag = '0';

        if (tipo === 'multipla') {
            // NUOVO MODELLO opzioni_json: userAnswers[idDomanda] contiene l'indice scelto
            // (settato da setUserAnswer nel template quando elenco_risposte e' vuoto).
            const ansIdx = this.getUserAnswerForBackend(idDomanda);
            if (ansIdx !== null && ansIdx !== undefined && ansIdx !== '') {
                rispostaUser = parseInt(ansIdx, 10);
                hasAnswer = true;
            } else {
                // Legacy: cerco il radio checked col name = id_domanda
                const radios = this.GetAllSelectRadioButtons();
                for (let k = 0; k < radios.length; k++) {
                    if (radios[k].name == idDomanda) {
                        idRisposta = radios[k].value;
                        hasAnswer = true;
                        break;
                    }
                }
            }
        } else if (tipo === 'aperta') {
            const ans = this.getUserAnswerForBackend(idDomanda);
            if (ans !== null && String(ans).trim() !== '') {
                rispostaUser = ans;
                hasAnswer = true;
                isRispostaLiberaFlag = '1';
            }
        } else if (tipo === 'vf') {
            const ans = this.getUserAnswerForBackend(idDomanda);
            if (ans === 'vero' || ans === 'falso') {
                rispostaUser = ans;
                hasAnswer = true;
            }
        } else if (tipo === 'multi') {
            const ans = this.getUserAnswerForBackend(idDomanda);
            if (Array.isArray(ans) && ans.length > 0) {
                rispostaUser = ans;
                hasAnswer = true;
            }
        } else if (tipo === 'ordinamento') {
            const ans = this.getUserAnswerForBackend(idDomanda);
            if (Array.isArray(ans) && ans.every(x => x !== -1 && x !== null && x !== undefined)) {
                rispostaUser = ans;
                hasAnswer = true;
            }
        } else if (tipo === 'abbinamento') {
            const ans = this.getUserAnswerForBackend(idDomanda);
            const nOpz = this.getOpzioni(row).length;
            if (ans && typeof ans === 'object' && Object.keys(ans).length === nOpz) {
                rispostaUser = ans;
                hasAnswer = true;
            }
        }

        if (!hasAnswer) return;

        const idQuizBody = row['id_quiz_body'] || '';
        arrayRisposte.push({
            "id_corso": idCorso,
            "isGenerazioneAutomatico": this.moduloUC_TestValutazioneSelected.isGenerazioneAutomatico,
            "id_header": idQuizHeader,
            "id_corsista": idCorsista,
            "id_corso_svolgimento": idCorsoSvolgimento,
            "id_quiz_body": idQuizBody,
            "id_domanda": idDomanda,
            "id_risposta": idRisposta,
            "tipo": tipo,
            "risposta_user": rispostaUser,
            "isTestValutazione": '1',
            "isRispostaLibera": isRispostaLiberaFlag,
            "isAlwaysFadMode": this.isAlwaysFadMode ? 1 : 0
        });
    });

     //controllo se l'utente ha risposto a tutte le domande, in caso contrario visualizzo il msg
     if(arrayRisposte.length<this.moduloUC_TestValutazioneSelected['quizBody'].length) {
       this.quizNonCompleto();
        return;
    }

    this.crudService.api_verifica_quiz(arrayRisposte).subscribe(product => {
        //console.log(product);

        // ENFORCEMENT lato server (max_repeat / wait_time): tentativi esauriti o attesa non trascorsa.
        // Il backend NON ha salvato il tentativo: mostro il messaggio e non proseguo con la valutazione.
        if(product && product['blocked']==1) {
            Swal.fire({
                title: 'Test non disponibile',
                text: product['msg'] || 'Non puoi ripetere il test in questo momento.',
                icon: 'warning',
                allowOutsideClick: false,
                confirmButtonColor: 'var(--mainColor)',
                confirmButtonText: 'Ho capito'
            }).then(() => { location.reload(); });
            return;
        }

        let corrette=product['corrette'];
        let nonCorrette=product['non_corrette'];
        let numeroDomande=product['numero_domande'];
        let sogliaMinimaPercentuale=product['soglia_minima_percentuale'];
        let sogliaMinimaDomande=product['soglia_minima_domande'];
        let sogliaCorrettePercentuale=product['soglia_corrette_percentuale'];
        // ECM — registra tentativo anche per test di valutazione e aggiorna conteggio locale
        if(this.isECM && this.ecmConfig) {
            let superato = (corrette >= sogliaMinimaDomande) ? 1 : 0;
            this.ecmConfig.tentativi_usati++;
            this.ecmRegistraTentativo(corrette, numeroDomande, superato);
        }
        if(corrette>=sogliaMinimaDomande) {
            //test valutazione superato
            this.quizSuperatoValutazione(corrette, numeroDomande);
        }
        else {
            //test non superato
            this.quizNonSuperato(corrette, nonCorrette);
        }

    });
  }

  downloadAttestato(idCorsista, idCorso, idCorsoSvolgimento) {
    //mi serve per la gestione della generazione dell'attestato
    var arrayDetail={'id_corso': idCorso, 'id_corsista': idCorsista, 'id_corso_svolgimento': idCorsoSvolgimento};

    //genero l'attestato
    this.crudService.api_GeneraAttestato(arrayDetail).subscribe(product => {
        //console.log(product);
        let nomeCorsista=product['nome_corsista'];
        let data_nascita=product['data_nascita'];
        let provincia_nascita=product['provincia_nascita'];
        let comune_nascita=product['comune_nascita'];
        let data_attestato=product['data_attestato'];
        let cf=product['cf'];
        let codiceAteco=product['codice_ateco'];
        let isPresent=product['isPresent'];
        let attestato=product['attestato'];
        let dataStart=product['dataStart'];
        if(isPresent.hasOwnProperty('id_certificato')) {
            window.open(environment.urlAttestati+isPresent.file);
        }
        else {
            if(attestato) {
                var detail='?id_corso='+idCorso+'&id_corso_svolgimento='+idCorsoSvolgimento+'&id_corsista='+idCorsista+'&nome_corsista='+nomeCorsista+'&data_nascita='+data_nascita+'&provincia_nascita='+provincia_nascita+'&comune_nascita='+comune_nascita+'&data_attestato='+data_attestato+'&dataStart='+dataStart+'&cf='+cf+'&protocollo='+this.protocollo+'&mansione='+this.mansione+'&codiceAteco='+codiceAteco;
                window.open(environment.urlAttestatiDaCreare+attestato+".php"+detail);
            }
            else {
                Swal.fire({
                    title: 'Errore!',
                    text: "non è stasto creato l\'attestato .pdf, non posso procedere alla generazione dell\'attestato",
                    icon: 'error',
                    showCancelButton: false,
                    confirmButtonColor: '#3085d6',
                    cancelButtonColor: '#d33',
                    confirmButtonText: 'Risolvi',
                    cancelButtonText: 'Annulla'
                  }).then((result) => {
                    if (result.isConfirmed) {
                    }
                })
            }
        }
    });
  }

  rimuoviEsameDallaSessione(idEsameScelto) {

    Swal.fire({
        icon: 'question',
        title: 'Sei sicuro?',
        text: 'vuoi eliminare l\'esame dalla sessione?',
        showCancelButton: true,
        confirmButtonColor: 'var(--mainColor)',
        cancelButtonColor: '#dadada',
        confirmButtonText: 'Si, confermo!',
        cancelButtonText: 'Annulla',
        width: '400px',
        allowOutsideClick: false,
      }).then((result) => {
        if (result.isConfirmed) {
            var arrayDetail={'idEsameScelto': idEsameScelto};

            this.crudService.api_deleteEsamePrenotato(arrayDetail).subscribe(product => {
                //console.log(product);
                if(product==1) {
                    Swal.fire({
                        title:'Eliminato',
                        text: 'esame eliminato con successo dalla sessione d\'esame.',
                        icon: 'success',
                        showCancelButton: false,
                        confirmButtonColor: '#6993FF',
                        cancelButtonColor: '#dadada',
                        confirmButtonText: 'Grazie',
                        allowOutsideClick: false,
                     }).then((result) => {
                        if (result.isConfirmed) {
                            document.getElementById("idEsameScelto_"+idEsameScelto).remove();
                        }
                    });
                }
            });

        }
    })
  }

  rimuoviDalleSessioneEsame(idEsameCorsisti) {
    Swal.fire({
        icon: 'question',
        title: 'Sei sicuro?',
        text: 'ti vuoi togliere dalla sessione d\'esame selezionata?',
        showCancelButton: true,
        confirmButtonColor: 'var(--mainColor)',
        cancelButtonColor: '#dadada',
        confirmButtonText: 'Si, confermo!',
        cancelButtonText: 'Annulla',
        width: '400px',
        allowOutsideClick: false,
      }).then((result) => {
        if (result.isConfirmed) {
            var arrayDetail={'idEsameCorsisti': idEsameCorsisti};

            this.crudService.api_eliminaCorsistaSessioneEsame(arrayDetail).subscribe(product => {
                //console.log(product);
                if(product==1) {
                    Swal.fire({
                        title:'Eliminato',
                        text: 'sei stato eliminato dalla sessione d\'esame.',
                        icon: 'success',
                        showCancelButton: false,
                        confirmButtonColor: '#6993FF',
                        cancelButtonColor: '#dadada',
                        confirmButtonText: 'Grazie',
                        allowOutsideClick: false,
                     }).then((result) => {
                        if (result.isConfirmed) {
                            location.reload();
                        }
                    });
                }
            });

        }
    })
  }

  prenotaSessioneEsame(idEsameBody, timeSessione, havePrenotato, dataSessione) {
    if(havePrenotato!=0) {
        this.rimuoviDalleSessioneEsame(havePrenotato);
        return;
    }

    var arrayDetail={'id_corso': this.idCorsoGlobal, 'id_corsista': this.detailUser.id_corsista, 'dataSessioneEsame': dataSessione.data_sessione};
    this.crudService.api_getElencoEsamiForCorsoCorsista(arrayDetail).subscribe(product => {
        //console.log(product);
    });

    return;


    Swal.fire({
        icon: 'question',
        title: 'Sei sicuro?',
        text: 'vuoi confermare la sessione d\'esame delle '+timeSessione+' selezionata?',
        showCancelButton: true,
        confirmButtonColor: 'var(--mainColor)',
        cancelButtonColor: '#dadada',
        confirmButtonText: 'Si, confermo!',
        cancelButtonText: 'Annulla',
        width: '400px',
        allowOutsideClick: false,
      }).then((result) => {
        if (result.isConfirmed) {
            var arrayDetail={'idEsameBody': idEsameBody, 'id_corsista': this.detailUser.id_corsista, 'id_corso': this.idCorsoGlobal};
            this.crudService.api_prenotaSessioneEsame(arrayDetail).subscribe(product => {
                if(product==1) {
                    Swal.fire({
                        title:'Prenotato',
                        text: 'hai prenotato con successo la tua sessione d\'esame.',
                        icon: 'success',
                        showCancelButton: false,
                        confirmButtonColor: '#6993FF',
                        cancelButtonColor: '#dadada',
                        confirmButtonText: 'Chiudi',
                        allowOutsideClick: false,
                     }).then((result) => {
                        if (result.isConfirmed) {
                            location.reload();
                        }
                    });
                }
            });

        }
    })
  }

  slotCompleto() {
    Swal.fire({
        title: 'Errore!',
        text: "non ci sono posti disponibili, lo slot risulta al completo.",
        icon: 'error',
        showCancelButton: false,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Chiudi',
        cancelButtonText: 'Annulla'
      }).then((result) => {
        if (result.isConfirmed) {
        }
    })
  }

  pinEsameErrato() {
    Swal.fire({
        title: 'Errore!',
        text: "il PIN ESAME inserito risulta non corretto. Riprova",
        icon: 'error',
        showCancelButton: false,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Chiudi',
        cancelButtonText: 'Annulla'
      }).then((result) => {
        if (result.isConfirmed) {
        }
    })
  }

  pinEsameCorretto() {
    Swal.fire({
        title: 'Corretto!',
        text: "il PIN ESAME risulta corretto, puoi procedere con l'esame.",
        icon: 'info',
        showCancelButton: false,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Chiudi',
        cancelButtonText: 'Annulla'
    }).then((result) => {
        if (result.isConfirmed) {
        }
    })
  }

  sessioneBloccataGiaPrenotata() {
    Swal.fire({
        title: 'Bloccata!',
        text: "hai già prenotato un'altra sessione d'esame nella stessa giornata, non puoi prenotare più sessioni nella stessa giornata.",
        icon: 'warning',
        showCancelButton: false,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Chiudi',
        cancelButtonText: 'Annulla'
    }).then((result) => {
        if (result.isConfirmed) {
        }
    })
  }

  showEsamePINEsame(pinEsameUser, idEsameBody) {
    Swal.fire({
        allowOutsideClick: false,
        title: 'PIN ESAME',
        icon: 'warning',
        html: 'per procedere con la visualizzazione dell\'esame, inserisci il PIN ESAME e clicca su verifica\
                <div class="form-group">\
                    <input type="text" id="pinEsame" class="form-control text-center mt-2" placeholder="inserisci il PIN">\
                </div>',
        showCancelButton: true,
        confirmButtonText: 'Verifica PIN',
        cancelButtonText: 'Annulla',
        confirmButtonColor: 'var(--mainColor)',
        didOpen: () => {

        },
        willClose: () => {

        }
    }).then((result) => {
        if (result.isConfirmed) {
            var pinEsame = document.getElementById('pinEsame') as HTMLInputElement;
            if(pinEsame.value==pinEsameUser) {
                this.showEsameDiretto=true;
                // Reset stato risposte multi-tipo prima di iniziare il nuovo esame
                this.userAnswers = {};
                this.abbDxCache = {};
                var arrayDetail={'idCorsista': this.detailUser.id_corsista, 'idEsameBody': idEsameBody, 'tipologia': 'pin_esame'};

                //mi registro l'orario e data dell'inizio esame
                this.crudService.set_dateTimeInizioEsame(arrayDetail).subscribe(response => {
                    //mi registro nel report, l'ingresso nell'esame con il pin
                    this.crudService.set_entraInMeetEsame(arrayDetail).subscribe(response => {
                        /*
                        this.timerHandle=setInterval(() => {
                            this.aggiornaTempoLimiteTEST();
                        }, 1000);
                        */
                        this.pinEsameCorretto();
                    });
                });
            }
            else {
                this.pinEsameErrato();
            }
        }
    })
  }

}
